// eslint-disable-next-line @typescript-eslint/no-unused-vars
import {
  Component,
  ComponentInterface,
  h,
  Prop,
  State,
  Watch,
  Element
} from '@stencil/core'
import {
  getTrackCues,
  fetchVASTWrapper,
  fetchVASTVideo
} from '../../../../services/api'
import {
  BidData,
  FetchMomentsData,
  BidResponseData,
  AnalyticsEventDispatcher
} from '../../../../services/analytics-event-dispatcher'
import {
  OverlayUtilities,
  BannerParameters,
  BidLogicParameters,
  RegisteredWindowEvents,
  WatchedElementProperties,
  CardinalDirections,
  CXInjectorWindowDebug,
  CardinalDirectionsModes,
  ElementDimensions,
  ManualBiddingEvents,
  CurrentInsertMap
} from '../../../../services/overlay-utilities'
import {
  SharedFunctions
} from '../../../../services/shared-functions'
import {
  LogManager
} from '../../../../services/log-manager'
import {
  CustomTimeout
} from '../../../../services/custom-timeout'
import { 
  loadComponents
} from '../../../../utils/js-loader'
import {
  Resource,
  Asset,
  AllowedInsert,
  GroupConfig,
  InsertConfig,
  InsertOverride,
  SqueezeElements,
  InsertConfiguration,
  AdvertiserNode,
  PlayerConfig
} from '../../../../../common/schemas/public'
import {
  InsertType,
  InsertEventType,
  InsertPosition,
  CSSPosition,
  FloatingPlayerPosition,
  LoggerEventType,
  OverlayEventType,
  OverlayExternalEventType,
  InsertAnalyticsEventType,
  BannerMessageType,
  LogType,
  PlayerMode,
  PlayerType,
  ImpressionType,
  AnalyticsEventType,
  BidOriginSourceType,
  DebugURLParams,
  ComponentSourceType,
  PlayerEventLogFrequency,
  ZoneModifications,
  VideoEventQuartileNaming
} from '../../../../../common/schemas/enums'
import {
  InsertSharedLogic
} from '../../../../inserts/src/components/insert-shared-logic/insert-shared-logic'
import { isNil } from 'lodash-es'
//import { Guid } from 'guid-typescript'
//declare var YT: any
// import { Guid } from 'guid-typescript'

// const root = process.env.SERVER_ROOT

declare var owpbjs: any;
declare var IntentIqObject: any;

// Workaround - TextTrackCueList typing seems wrong - says not iterable though it is an array
interface CueList extends TextTrackCueList{
  [Symbol.iterator]
}

enum VideoEvents {
  VIDEO_LOADED_DATA = 'loadeddata',
  VIDEO_LOADED_METADATA = 'loadedmetadata',
  VIDEO_PLAY = 'play',
  VIDEO_PAUSE = 'pause',
  VIDEO_ENDED = 'ended',
  VIDEO_TIMEUPDATE = 'timeupdate',
  VIDEO_EMPTIED = 'emptied',
  VIDEO_EVENT_FROM_INSERT = 'event-from-insert'
}

type RegisteredVideoEvents = {
  [value in VideoEvents]: EventListener
}

enum AirTVVideoEvents {
  IMPRESSION = 'atv.ima.adimpression',
  AD_BREAK_END = 'atv.adbreakended',
  PLAYER_READY = 'atv.playerready',
  VIDEO_INIT = 'atv.videoinit',
  PLAY = 'atv.play',
  PAUSE = 'atv.pause'
}

type RegisteredAirTVVideoEvents = {
  [value in AirTVVideoEvents]: EventListener
}

interface VideoParameters{
  videoStarted: boolean
  videoEnded: boolean
  videoDuration: number
  currentTime: number
  durationChangeCount: number
  analyticsTriggeredVideoStarted: boolean
  analyticsTriggeredPassed15Seconds: boolean
  isStreaming: boolean
  isFloatingExclusive: boolean
  timerBasedBidding: boolean
  lastBidTime: number
  nextBidTime?: number
  isShadowPlayer: boolean
  videoRecentlyEmptied: boolean
  videoAnalyticsParameters: VideoAnalyticsParameters
}

interface VideoAnalyticsParameters{
  started: boolean,
  restarted: boolean,
  fiveSecondsReached: boolean,
  tenSecondsReached: boolean,
  fifteenSecondsReached: boolean,
  thirtySecondsReached: boolean,
  fortyFiveSecondsReached: boolean,
  sixtySecondsReached: boolean,
  minutesReachedLog: number[],
  twentyFivePercent: boolean,
  fiftyPercent: boolean,
  seventyFivePercent: boolean,
  completed: boolean,
  videoPositionDataSent: PlayerMode[]
  videoEndedTriggered: boolean
}

interface OverlayCustomTimers{
  updateCXOTimer: CustomTimeout,
  cxoTimeElapsedEventTimeout: CustomTimeout,
  windowScrollTimer: CustomTimeout,
  delayFetchMomentsTimer: CustomTimeout,
  checkLostVideoPlayerTimer: CustomTimeout,
  createNewInsertTimer: CustomTimeout,
  createNewInsertDebugLogTimer: CustomTimeout,
  checkTrackIntegrityTimer: CustomTimeout,
  reinitializeVideoElementTimer: CustomTimeout,
  dispatchResizeEventTimer: CustomTimeout,
  checkMomentsNeededTimer: CustomTimeout,
  updateCXOFrameDelayTimer: CustomTimeout,
  checkForVideoChangeTimer: CustomTimeout,
  remakeInsertTimer: CustomTimeout,
  remakeADXInsertTimer: CustomTimeout,
  detectCXWaitChangesTimer: CustomTimeout,
  setVideoDimensionsAsStableTimer: CustomTimeout,
  containerElementOpacityResetTimer: CustomTimeout,
  confirmCardinalDirectionsModeTimer: CustomTimeout,
  checkVideoStatusAfterCxWaitTimer: CustomTimeout,
  watchedVideoDurationTimer: CustomTimeout
}

interface ElementHiddenDirection{
  hiddenX: boolean,
  hiddenY: boolean
}

@Component({
  tag: 'cx-overlay',
  styleUrl: 'cx-overlay.css',
  shadow: true
})

export class CxOverlay implements ComponentInterface {
  private cxoActive: boolean = true;
  private overlayUtilities: OverlayUtilities;
  private sharedFunctions: SharedFunctions;
  private analyticsEventDispatcher: AnalyticsEventDispatcher;
  private debugLog: Function;
  private logManager: LogManager;
  private insertLogicManager: InsertSharedLogic;
  private shouldRequestMoments: boolean = true
  private initialMomentsRequested: boolean = false;
  private containerElement: HTMLDivElement
  private overlaySizerElement: HTMLDivElement
  private loggingOverlay: HTMLDivElement
  private showLoggingOverlay: boolean = false;
  private videoElementContainer: HTMLElement
  private videoElement: HTMLVideoElement
  private trackElement?: HTMLTrackElement
  private overlayTimerElement?: HTMLDivElement
  private carouselResource?: HTMLElement
  private carouselResourceData: Resource = null
  private createNewInsertDebugLogMessage: string = ''
  private activeResource?: HTMLElement
  private activeResourceData: Resource = null
  private _activeMediaId?: string
  private _activeLogicalVideoId?: string
  private previousADXId: string = "UNDEFINED"
  //private activeResourceId: string
  private trackUrl: string;
  private airTVEventsEstablished: boolean = false;
  private airTVisAdvertisement: boolean = false;
  private anchorTarget: string = '';
  private playerType: PlayerType = PlayerType.UNKNOWN;
  private playerConfig: PlayerConfig;
  private playerMode: PlayerMode = PlayerMode.DESKTOP_ONSTREAM;
  private isInsertReinitializing: boolean = false;
  private optimalInsertType: InsertType = InsertType.OVERLAY_FULLWIDTH_ICON_COLOR_DETECT;
  private optimalInsertPosition: InsertPosition = InsertPosition.DEFAULT;
  private lockCXO: boolean = false;
  private lockDimensions: boolean = false;
  private lockMargin: boolean = false;
  private floatingPosition: FloatingPlayerPosition = FloatingPlayerPosition.BOTTOM_RIGHT;
  private floatingJumpCount: number = 0;
  private floatingModeLockedCount: number = 0;
  private floatingModeConfirmed: boolean = false;
  private floatingPositionCheckedTime: number = (new Date()).getTime();
  private closestFloatingPosition: { [key:string]: number} = {};
  private floatingCardinalDirections: CardinalDirections = {top: 'auto', right: 'auto', bottom: 'auto', left: 'auto'};
  private cardinalDirectionsMode: CardinalDirectionsModes = CardinalDirectionsModes.ZERO_INSET;
  private currentAnchorPosition: string = 'default';
  private insertCount: number = 0
  private consecutiveVideosLoaded: number = 1
  private watchedVideoSize: WatchedElementProperties = {width: 0, height: 0, top: 0, left: 0}
  private insertBeingCleared: boolean = false
  private isIframePlayer: boolean = false
  private videoPlayerLost: boolean = false
  private videoAdvertVariables: string[] = []
  private stowedBidResponse;
  private cxWaitInitiateBid: boolean = false;
  private timers: OverlayCustomTimers;
  private videoContainerSearchNode: HTMLElement;
  private playerModeExclusionList: string[] = [];
  private rebidBannerSizeAllowedDeviation: number = 2;
  private _videoUrl: string = null;
  private _videoUrlId: string = null;
  private requestedBannerSizes: number[][] = [];
  private forceBannerCustomSqueeze: boolean = false;
  private currentScript: HTMLScriptElement = (document.currentScript as HTMLScriptElement);

  private currentVideoStatus: VideoParameters = {
    videoStarted: false,
    videoEnded: true,
    videoDuration: 0,
    currentTime: 0,
    durationChangeCount: 0,
    analyticsTriggeredVideoStarted: false,
    analyticsTriggeredPassed15Seconds: false,
    isStreaming: false,
    isFloatingExclusive: false,
    lastBidTime: 0,
    isShadowPlayer: false,
    timerBasedBidding: false,
    videoRecentlyEmptied: false,
    videoAnalyticsParameters:  {
      started: false,
      restarted: true,
      fiveSecondsReached: false,
      tenSecondsReached: false,
      fifteenSecondsReached: false,
      thirtySecondsReached: false,
      fortyFiveSecondsReached: false,
      sixtySecondsReached: false,
      minutesReachedLog: [],
      twentyFivePercent: false,
      fiftyPercent: false,
      seventyFivePercent: false,
      completed: false,
      videoPositionDataSent: [],
      videoEndedTriggered: false
    }
  }

  private registeredCXExternalEvent: ()=>{} = this.cxExternalEvent.bind(this);
  
  private registeredVideoEvents: RegisteredVideoEvents = {
    [VideoEvents.VIDEO_LOADED_DATA]: this.videoLoadedData.bind(this),
    [VideoEvents.VIDEO_LOADED_METADATA]: this.videoLoadedMetadata.bind(this),
    [VideoEvents.VIDEO_PLAY]: this.videoPlay.bind(this),
    [VideoEvents.VIDEO_PAUSE]: this.videoPause.bind(this),
    [VideoEvents.VIDEO_ENDED]: this.videoEnd.bind(this),
    [VideoEvents.VIDEO_EMPTIED]: this.videoEmptied.bind(this),
    [VideoEvents.VIDEO_TIMEUPDATE]: this.videoTimeUpdate.bind(this),
    [VideoEvents.VIDEO_EVENT_FROM_INSERT]: this.videoInsertEvent.bind(this)
  }
  
  private registeredAirTVVideoEvents: RegisteredAirTVVideoEvents = {
    [AirTVVideoEvents.AD_BREAK_END]: this.airTvAdBreakEnd.bind(this),
    [AirTVVideoEvents.IMPRESSION]: this.airTvAdImpression.bind(this),
    [AirTVVideoEvents.PLAYER_READY]: this.airTvPlayerReady.bind(this),
    [AirTVVideoEvents.VIDEO_INIT]: this.airTvVideoInit.bind(this),
    [AirTVVideoEvents.PLAY]: this.airTvPlay.bind(this),
    [AirTVVideoEvents.PAUSE]: this.airTvPause.bind(this)
  }

  private registeredManualBidEvents = {
    [ManualBiddingEvents.INITIATE_BID]: this.handleManualBidRequestEvent.bind(this)
  }
  
  private registeredWindowEvents: RegisteredWindowEvents = {
    resize: this.windowResize.bind(this),
    touchmove: this.touchMove.bind(this),
    scroll: this.windowScroll.bind(this),
    message: this.messageReceived.bind(this),
    visibilitychange: this.visibilityChange.bind(this)
  }

  @Element() cxoverlay: HTMLElement
  @Prop() groupId: string
  @Prop() qElementId: string
  @Prop() nobid: boolean = false
  @Prop() cxWait: boolean = false
  @Prop() isesm: boolean = false
  @Prop() marketplaceId: string = null
  @Prop() storeId: string = null
  @Prop() bundleId: string = null

  @State() inserts: Resource[]
  @State() trackData: Blob
  // TODO - return these in the api call
  @State() label: string = 'catapult-x'
  @State() type: string = 'video/mp4'
  @State() kind: string = 'metadata/cxinsert'
  @State() cues: CueList
  @State() videoClass: string = 'video-x'

  @Watch('nobid')
  onNobidToggle(updatedNobid:boolean){
    if(updatedNobid){
      this.debugLog(['nobid attribute turned on for cx-overlay. Should remove track, video events, and active inserts.'], [LogType.QA, LogType.CXO]);
      this.clearRemainingInserts();
      if(!isNil(this.trackElement) && this.videoElement.contains(this.trackElement)){
        this.videoElement.removeChild(this.trackElement)
      }
      if(!isNil(this.videoElement)){
        this.removeVideoEvents();
      }
    }
  }

  @Watch('cxWait')
  onCXWaitToggle(updatedCXWait:boolean){
    const changeInitiator: string = (this.cxoverlay.getAttribute('cx-wait') == null)?'variable set AUTOMATICALLY (cx-overlay initiated)':'attribute set MANUALLY (player initiated)';
    if(updatedCXWait){
      this.debugLog([`cx-wait=true ${changeInitiator}.`], [LogType.QA, LogType.CXO]);
      if(!isNil(this.activeResource)){
        this.activeResource.style.setProperty('display', 'none');
        if(!isNil(this.carouselResource)){
          this.carouselResource.style.setProperty('display', 'none');
        }
        this.debugLog(['Hiding active insert: ' + this.activeResource.tagName], [LogType.QA, LogType.CXO])
        this.overlayUtilities.carouselBidTimer.pause();
      }
      this.overlayUtilities.dispatchOverlayEvent({type:OverlayEventType.OVERLAY_PAUSE_INSERTS});
      this.timers.watchedVideoDurationTimer.pause();
      this.timers.checkVideoStatusAfterCxWaitTimer.cancel();
    } else{
      this.debugLog([`cx-wait=false ${changeInitiator}.`], [LogType.QA, LogType.CXO])
      this.timers.watchedVideoDurationTimer.resume();
      this.timers.checkVideoStatusAfterCxWaitTimer.execute();
    }
  }

  resumePlatformAfterCxWaitToggledFalse(){
    if(!isNil(this.activeResource)){
      this.activeResource.style.setProperty('display', 'block');
      if(!isNil(this.carouselResource)){
        this.carouselResource.style.setProperty('display', 'block');
      }
      this.debugLog(['Continue active insert: ' + this.activeResource.tagName], [LogType.QA, LogType.CXO]);
      this.timers.dispatchResizeEventTimer.reset(1);
      this.timers.updateCXOTimer.execute();
      this.overlayUtilities.carouselBidTimer.resume();
    }
    this.resumeActiveInsertAfterCXWait(1);
    if(typeof this.stowedBidResponse !== 'undefined' && this.stowedBidResponse !== null){
      this.debugLog(['Bid response received while cx-wait=true. Will now check video status before processing stowed bid response.'], [LogType.QA, LogType.CXO]);
      
      this.processBidResponse(this.stowedBidResponse);
      this.stowedBidResponse = null;

    } else if(this.cxWaitInitiateBid){
      this.debugLog(['Bid request attempted while cx-wait=true. Will now attempt new bid request.'], [LogType.QA, LogType.CXO]);
      this.cxWaitInitiateBid = false;
      this.overlayUtilities.initiateBidRequestTimer.execute();
    }
    this.timers.checkMomentsNeededTimer.reset(100);
  }

  resumeActiveInsertAfterCXWait(count: number){
    if(!this.detectCXWaitChanges()){
      if(!isNil(this.activeResource) && count <= 5){
        if(this.overlayUtilities.currentDimensions.width > 10 && this.overlayUtilities.currentDimensions.height > 10){
          this.overlayUtilities.dispatchOverlayEvent({type:OverlayEventType.OVERLAY_RESUME_INSERTS, continue: true});
        }else{
          setTimeout(()=>{this.resumeActiveInsertAfterCXWait(++count)}, 100);
        }
      }else{
        this.overlayUtilities.dispatchOverlayEvent({type:OverlayEventType.OVERLAY_RESUME_INSERTS, continue: false});
      }
    }
  }

  componentWillLoad(){
    this.groupId = (this.groupId === 'null')?null:this.groupId;
    this.overlayUtilities = new OverlayUtilities(this.groupId, ComponentSourceType.OVERLAY);
    this.analyticsEventDispatcher = this.overlayUtilities.analyticsEventDispatcher;
    this.debugLog = this.overlayUtilities.debugLog;
    this.logManager = this.overlayUtilities.logManager;
    this.sharedFunctions = new SharedFunctions(this.logManager);
    this.insertLogicManager = new InsertSharedLogic(this.overlayUtilities.logManager);
    this.insertLogicManager.isMobile = this.overlayUtilities.isMobileDevice;

    this.timers = {
      updateCXOTimer: new CustomTimeout(() => { this.updateCXO() }, 0, 'UpdateCXO Timer', this.logManager, LogType.CXO),
      cxoTimeElapsedEventTimeout: new CustomTimeout(() => { this.logCXOTimeElapsedEvent(0) }, 0, 'Log CXO Time Elapsed Event Timer', this.logManager, LogType.CXO),
      windowScrollTimer: new CustomTimeout(() => { this.windowScrollStopped() }, 0, 'Window Scroll Watch Timer'),
      delayFetchMomentsTimer: new CustomTimeout(() => { this.fetchMoments() }, 0, 'Delay Fetch Moments Timer', this.logManager, LogType.CXO),
      checkLostVideoPlayerTimer: new CustomTimeout(() => { this.videoPlayerRemainsLostCheck() }, 0, 'Check Lost Video Timer', this.logManager, LogType.CXO),
      createNewInsertTimer: new CustomTimeout(() => { }, 0, 'Create New Insert Timer', this.logManager, LogType.CXO),
      createNewInsertDebugLogTimer: new CustomTimeout(() => {}, 0, 'Create New Insert Debug Log Timeout', this.logManager, LogType.NONE),
      checkTrackIntegrityTimer: new CustomTimeout(() => { this.checkTrackIntegrity() }, 0, 'Check Track Integrity Timer'),
      reinitializeVideoElementTimer: new CustomTimeout(() => { this.reinitializeVideoElement(this.videoElementContainer) }, 0, 'Reinitialize Video Element Timer', this.logManager, LogType.CXO),
      dispatchResizeEventTimer: new CustomTimeout(() => { this.overlayUtilities.dispatchOverlayEvent({ type: OverlayEventType.OVERLAY_RESIZE }); }, 0, 'Dispatch Resize Event Timer'),
      checkMomentsNeededTimer: new CustomTimeout(() => { this.checkIfMomentsNeeded() }, 0, 'Check Moments Needed Timer'),
      updateCXOFrameDelayTimer: new CustomTimeout(() => { this.updateCXOFrameDelay() }, 0, 'Update CXO Frame Delay Timer', this.logManager, LogType.CXO),
      checkForVideoChangeTimer: new CustomTimeout(() => { this.checkForVideoChange() }, 0, 'Check Video Change Timer'),
      remakeInsertTimer: new CustomTimeout(() => { }, 0, 'Remake Insert Check Delay Timer', this.logManager, LogType.CXO),
      remakeADXInsertTimer: new CustomTimeout(() => { this.remakeADXInsert() }, 0, 'Remake ADX Insert Timer', this.logManager, LogType.QA),
      detectCXWaitChangesTimer: new CustomTimeout(() => { this.detectCXWaitChanges() }, 0, 'Detect CX-Wait Changes Timer', this.logManager, LogType.CXO),
      setVideoDimensionsAsStableTimer: new CustomTimeout(() => { this.videoDimensionsStable = true; }, 0, 'Set Video Dimensions As Stable Timer'),
      containerElementOpacityResetTimer: new CustomTimeout(() => { this.containerElement?.style.removeProperty('opacity') }, 0, 'Container Element Reset Opacity Timer', this.logManager, LogType.QA),
      confirmCardinalDirectionsModeTimer: new CustomTimeout(() => { this.confirmCardinalDirectionsMode() }, 0, 'Confirm Cardinal Directions Mode Timer', this.logManager, LogType.CXO),
      checkVideoStatusAfterCxWaitTimer: new CustomTimeout(() => {
        if (this.videoElement && !this.videoElement.paused && !this.videoElement.ended) {
          this.debugLog(['Video is playing. Resuming any active inserts, bid requests, and/or response processing.'], [LogType.QA, LogType.CXO]);
          this.resumePlatformAfterCxWaitToggledFalse();
          this.timers.checkVideoStatusAfterCxWaitTimer.cancel();
        } else {
          this.timers.checkVideoStatusAfterCxWaitTimer.reset(100);
        }
      }, 0, 'Check Video State Timer', this.logManager, LogType.QA),
      watchedVideoDurationTimer: new CustomTimeout(() => {this.debugLog('watchedVideoDurationTimer Completed.')}, 8640000000, 'Watch Video Content Duration Timer', this.logManager, LogType.QA)
    }

    this.debugLog('CX overlay initializing.', [LogType.INFO]);
    this.currentScript = document.querySelector(`script[src*="cx-overlay"]`);
    this.debugLog(`CX overlay script source: ${this.currentScript?.src}`, [LogType.CXO, LogType.QA]);
    
    this.overlayUtilities.isCTV = Boolean(navigator.userAgent.includes("SMART-TV") || navigator.userAgent.includes('AmazonWebAppPlatform'));

    this.analyticsEventDispatcher.assignEventsComponentSource(ComponentSourceType.OVERLAY);
  }

  componentDidLoad() {
    
    this.overlayUtilities.initializeRequiredData({
      componentElement: this.cxoverlay,
      activeResourceData: ()=>{return this.activeResourceData},
      carouselResourceData: () => {return this.carouselResourceData},
      activeElement: ()=>{return this.videoElement},
      playerMode: ()=>{return this.playerMode},
      qElementId: ()=>{return this.qElementId},
      cxoActive: ()=>{return this.cxoActive},
      setTimerBidding: (timerBidding: boolean)=>{this.timerBidding = timerBidding},
      setZIndexUpdate: (zIndexUpdate: string)=>{this.zIndexUpdate = zIndexUpdate},
      containerElement: this.containerElement,
      destroyFunction: this.destroyCXO.bind(this),
      bidLogicParams: this.generateBidLogicParameters.bind(this),
      addManualBiddingEvents: this.addManualBiddingEvents.bind(this),
      removeProhibitedInsertTypes: this.removeProhibitedInsertTypes.bind(this)
    });

    if(this.marketplaceId !== null || this.storeId !== null || this.bundleId !== null){
      this.debugLog([`Marketplace ID: ${this.marketplaceId}`, `Store ID: ${this.storeId}`, `Bundle ID: ${this.bundleId}`], [LogType.QA, LogType.IMPORTANT]);
    }

    const showConsoleOverlayParam = this.logManager.getDebugParamValue(DebugURLParams.SHOW_CONSOLE_OVERLAY);
    if(showConsoleOverlayParam !== null && showConsoleOverlayParam === 'true'){
      this.showLoggingOverlay = true;
      this.createLoggingOverlay();
      window.addEventListener(LoggerEventType.DISPATCH_LOG, (evt: CustomEvent)=>{
        this.addConsoleLog(evt.detail);
      })
    }

    const forceBannerCustomSqueezeParam = this.logManager.getDebugParamValue(DebugURLParams.FORCE_BANNER_CUSTOM_SQUEEZE);
    if(forceBannerCustomSqueezeParam !== null && forceBannerCustomSqueezeParam === 'true'){
      this.forceBannerCustomSqueeze = true;
      this.debugLog('Force custom banner squeeze? ' + this.forceBannerCustomSqueeze, [LogType.QA, LogType.IMPORTANT]);
    }

    const rebidBannerSizeAllowedDeviation = this.logManager.getDebugParamValue(DebugURLParams.REBID_ALLOWED_SIZE_DEVIATION);
    if(rebidBannerSizeAllowedDeviation !== null){
      this.rebidBannerSizeAllowedDeviation = parseInt(rebidBannerSizeAllowedDeviation);
      this.debugLog('Rebid Banner Size Allowed Deviation Override: ' + rebidBannerSizeAllowedDeviation, [LogType.QA, LogType.IMPORTANT]);
    }

    this.addKeypressEvents();
    this.sharedFunctions.addWindowEvents(this.registeredWindowEvents);

    this.cxoverlay.addEventListener('cx-external-event', this.registeredCXExternalEvent);

    this.timers.cxoTimeElapsedEventTimeout.reset(5000, ()=>{this.logCXOTimeElapsedEvent(5)});
    
    this.debugLog(['componentDidLoad', this.cxoverlay]);
    this.debugLog(`UserAgent - ${navigator.userAgent}`, [LogType.QA, LogType.CXO, LogType.OVERLAYLOGS])
    this.debugLog(['CX-Overlay loaded. HTML Element: ', this.cxoverlay], [LogType.QA, LogType.TAM]);
    
    this.overlayTimerElement.style.setProperty('z-index', '10000000');
    this.containerElement.style.setProperty('z-index', '10000000');
    this.containerElement.style.setProperty('pointer-events', 'none');
    this.containerElement.style.setProperty('-webkit-tap-highlight-color', 'transparent');

    this.analyticsEventDispatcher.assignEventsGroupId(this.groupId);
    if(this.logManager.getDebugParamValue(DebugURLParams.ANALYTICS_TIER) !== null){
      this.analyticsEventDispatcher.assignPlayerEventFrequency(this.logManager.getDebugParamValue(DebugURLParams.ANALYTICS_TIER)?.toUpperCase?.() as PlayerEventLogFrequency);
    }
    
    this.analyticsEventDispatcher.sendOverlayEvent(AnalyticsEventType.OVERLAY_INIT, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue);

    this.inserts = [];
    if(typeof this.cxoverlay['identifyAdvertVars'] !== 'undefined' && this.cxoverlay['identifyAdvertVars'] !== null){
      this.videoAdvertVariables = this.cxoverlay['identifyAdvertVars'];
    }

    if(typeof this.cxoverlay['osdConfig'] !== 'undefined' && this.cxoverlay['osdConfig'] !== null){
      this.debugLog(['On-Stream Direct configuration found in bootstrapper advanced configuration: ', this.cxoverlay['osdConfig']], [LogType.CXO, LogType.QA]);
      this.overlayUtilities.osdConfig = this.overlayUtilities.normalizeOSDConfig(this.cxoverlay['osdConfig']);
    }
    
    const groupConfigs: GroupConfig = (this.cxoverlay as any).groupConfig;
    this.overlayUtilities.groupConfig = groupConfigs;

    if(this.overlayUtilities.isGroupConfigsProcessed){
      try {
        let playerElement: HTMLVideoElement = (this.cxoverlay as any).foundVideoNode;
        this.videoElementContainer = this.videoContainer ?? playerElement;
        this.debugLog(['videoElementContainer: ', this.videoElementContainer]);
        if(isNil(playerElement)){
          this.debugLog([`Video not identified from bootstrapper. Will perform video search in container ${this.qElementId}.`], LogType.QA);
          playerElement = (this.videoElementContainer.tagName.toUpperCase() === 'VIDEO')?this.videoElementContainer as HTMLVideoElement:this.findVideoElement(this.videoElementContainer)
        }else{
          this.currentVideoStatus.isShadowPlayer = this.testForShadowDOM(playerElement);
          this.debugLog([`Video handoff from bootstrapper in container ${this.qElementId}: `, (this.cxoverlay as any).foundVideoNode, (this.cxoverlay as any).foundVideoNode?.parentElement?.className], LogType.QA);
        }
        if(this.videoElementContainer.tagName.toUpperCase() === 'VIDEO'){
          this.videoElementContainer=this.getParent(this.videoElementContainer);
        }
        if (playerElement !== null) {
          this.debugLog('componentDidLoad --foundVideoElement')
          this.videoUrl = this.getVideoSource(playerElement);
          if(this.videoUrl !== null){
            this.debugLog('componentDidLoad --foundVideoSourceElement')
          }else{
            this.debugLog('componentDidLoad --no video source found.')
          }
        } else {
          this.debugLog('componentDidLoad --noVideoElementFound')
        }
        if (!isNil(this.videoUrl) && this.videoUrl !== '') {
          playerElement['cxInitialized']=true
          this.videoElement = playerElement
          this.insertLogicManager.elementHost = playerElement;
          this.determinePlayerType();
          this.debugLog(['CX attached to player: ', this.videoElement, 'CX video url found: ' + this.videoUrl], [LogType.QA, LogType.TAM, LogType.CXO]);
          
          this.determinePlayerMode();
          this.addEvents()
          this.checkCurrentVideoStatus();
          this.timers.updateCXOTimer.execute();
          this.setNextAutomaticBidTime();
          this.checkIfMomentsNeeded();
        } else {
          this.debugLog('componentDidLoad --noSourceFound')
          if(!isNil(playerElement)){
            playerElement['cxInitialized']=false;
          }
          this.timers.reinitializeVideoElementTimer.reset(1000);
        }
      } catch (e) {
        this.debugLog(['failed to load data', e], [LogType.CXO, LogType.QA, LogType.ERROR]);
      }
      
      if(!isNil(this.overlayUtilities.groupConfig.zoneId)){
        this.overlayUtilities.addSync(this.overlayUtilities.groupConfig.zoneId)
      }

      this.overlaySizerElement.style.setProperty('display', 'block');
    }
    
    let configData: {[key:string]: any} = {};
    const excludeConfigList = ['countryCode', 'regionInfo', 'globalPlayerConfigs', 'deviceInfo'];
    for(let key in this.overlayUtilities.groupConfig){
      if(!excludeConfigList.includes(key)){
        configData[key] = this.overlayUtilities.groupConfig[key];
      }
    }
    configData.videoPlayer = this.playerType;
    configData.videoPlayerConfigs = this.playerConfig;
    
    this.analyticsEventDispatcher.sendOverlayEvent(AnalyticsEventType.OVERLAY_GROUP_CONFIGS, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, configData);

    this.debugLog(`Bidding mode: ${(this.isOSDAvailable)?(this.overlayUtilities.osdConfig.slotRefreshParams.pbjsObject!=null)?'On-Stream Direct Prebid':'On-Stream Direct GAM Only (No Prebid)':'On-Stream Original'}`, [LogType.QA, LogType.CXO, LogType.TAM]);
    if(this.isOSDAvailable){
      this.overlayUtilities.bidderOrder = (this.overlayUtilities.groupConfig.bidOrder.length > 1) ? [BidOriginSourceType.ADK, BidOriginSourceType.ADK] : [BidOriginSourceType.ADK];
      const useOSDBidOrder = this.overlayUtilities.osdBidOrder?.length > 0;
      const bidOrderForRebid = useOSDBidOrder ? this.overlayUtilities.osdBidOrder : this.overlayUtilities.bidderOrder;
      const bidOrderMessage = useOSDBidOrder ? ' (OSD Bid Order)' : ' (Standard Bid Order)';
      this.debugLog(`OSD bidding enabled - setting maximum rebid count to ${bidOrderForRebid.length - 1}${bidOrderMessage}.`, [LogType.QA, LogType.CXO, LogType.TAM])
    }
  }

  //unused?
  createPrebidIframe(){
    if(document.querySelector('#cx_prebid_iframe') === null){
      let iframe: HTMLIFrameElement = document.createElement('iframe');
      iframe.id='cx_prebid_iframe';
      iframe.width = '0';
      iframe.height = '0';
      
      iframe.setAttribute('style', `background:transparent; opacity:0; padding:0; position:absolute; display:block; top:0px; left:0px; width:${iframe.width}px; height:${iframe.height}px; overflow:hidden;`);
      iframe.setAttribute('frameborder', '0');
      const iframeDocumentContent: string = `
      <html>
      <head>
      <script src="https://inserts.catapultx.com/scripts/prebid7.31.0.js" type="text/javascript"></script>
      </body>
      </html>`;
      let prebidFilled = false;
      let fillIframeInterval: ReturnType<typeof setInterval> = setInterval(()=>{
          if(iframe.contentWindow !== null && iframe.contentWindow.document !== null && !prebidFilled){
              //clearInterval(fillIframeInterval);
              prebidFilled = true;
              iframe.contentWindow.document.open();
              iframe.contentWindow.document.write(iframeDocumentContent);
              iframe.contentWindow.document.close();
          }
          if(typeof iframe?.contentWindow?.['pbjs'] !== 'undefined'){
            this.overlayUtilities.osdConfig.slotRefreshParams.pbjsObject = iframe.contentWindow['pbjs'];
            window['pbjs'] = iframe.contentWindow['pbjs'];
            iframe.contentWindow['googletag'] = this.overlayUtilities.osdConfig.slotRefreshParams.gtagObject;
            clearInterval(fillIframeInterval);
          }
      }, 10);
      document.body.appendChild(iframe);
    }else{
      this.debugLog(['PBJS object iframe already loaded.'], [LogType.CXO, LogType.QA]);
    }
  }

  //could move to overlay utilities
  cxExternalEvent(evt: CustomEvent){
    evt.stopPropagation();
    this.debugLog(['cx-external-event received: ', evt], LogType.QA);
    if(evt.detail?.type === 'update-prebid-params'){
      this.overlayUtilities.osdConfig = this.overlayUtilities.normalizeOSDConfig(evt.detail.osdConfig);
      this.debugLog(['OSD configuration received after initialization of cx-overlay: ', this.overlayUtilities.osdConfig], [LogType.QA, LogType.TAM, LogType.CXO]);
      this.debugLog(`Bidding mode: ${(this.isOSDAvailable)?(this.overlayUtilities.osdConfig.slotRefreshParams.pbjsObject!=null)?'On-Stream Direct Prebid':'On-Stream Direct GAM Only (No Prebid)':'On-Stream Original'}`, [LogType.QA, LogType.CXO, LogType.TAM]);
    }
  }

  testForShadowDOM(elem:HTMLElement): boolean{
    if((elem.getRootNode?.() as ShadowRoot)?.host != null){
      this.debugLog('Player is contained within a Shadow DOM component.', [LogType.QA, LogType.CXO]);
      return true;
    }else{
      //this.debugLog('Player is NOT contained within a Shadow DOM component.', [LogType.QA, LogType.CXO]);
      return false;
    }
  }

  createLoggingOverlay(){
    if(document.getElementsByClassName('cxLoggingParent').length === 0){
      this.loggingOverlay = document.createElement('div');
      this.loggingOverlay.setAttribute('style', 'position:fixed; display:block; width:100%; height:100%; opacity:1; z-index:100;');
      this.loggingOverlay.className = 'cxLoggingParent';
      const loggingChild: HTMLDivElement = document.createElement('div');
      loggingChild.setAttribute('style', 'position:fixed; width:100%; height:100%; overflow-y:scroll; opacity:.8; top:0px; left:0px; z-index:100; background:rgba(0,0,0,.25); user-select:text;');
      loggingChild.className = 'loggingContainer';
      const closeButton = document.createElement('div');
      closeButton.setAttribute('style', 'background:black; color:rgb(255,255,255); padding:15px; position:fixed; top:0px; bottom:auto; left:auto; right:20px; opacity:1; pointer-events:auto; z-index:250; user-select:none; cursor:pointer;');
      closeButton.innerHTML = 'x';
      closeButton.id = 'loggingContainerClose';
      closeButton.addEventListener('click', ()=>{
        if(loggingChild.style.getPropertyValue('display') === 'none'){
          loggingChild.style.setProperty('display', 'block');
          closeButton.innerHTML = 'x';
          loggingChild.scrollTo(0, loggingChild.scrollHeight);
        }else{
          loggingChild.style.setProperty('display', 'none');
          closeButton.innerHTML = '∨';
        }
      })
      this.loggingOverlay.appendChild(loggingChild)
      this.loggingOverlay.appendChild(closeButton);
      document.querySelector('body').insertBefore(this.loggingOverlay,document.querySelector('body').firstChild);
    }
  }

  addConsoleLog(logDetails){
    if(isNil(this.loggingOverlay)){
      this.createLoggingOverlay();
    }
    if(this.loggingOverlay.parentElement !== this.cxoverlay.parentElement){
      this.cxoverlay.parentElement.insertBefore(this.loggingOverlay,this.cxoverlay);
    }
    const logContainer: HTMLDivElement = this.loggingOverlay.querySelector('.loggingContainer');
    const logDiv: HTMLDivElement = document.createElement('p');
    logDiv.innerText = logDetails.log[4];
    logDiv.setAttribute('style', logDetails.log[2]);
    logDiv.style.setProperty('margin', '0px');
    logDiv.style.setProperty('display', 'block');
    logDiv.className = 'logEvent ' + logDetails.type;
    const scrollJump: boolean = (logContainer.scrollTop > (logContainer.scrollHeight-logContainer.getBoundingClientRect().height-30) || logContainer.scrollTop === 0)?true:false;
    logContainer.appendChild(logDiv);
    if(scrollJump){
      logContainer.scrollTo(0, logContainer.scrollHeight);
    }
  }

  addKeypressEvents(){
    let keyStatus: {[key:string]: boolean} = {};
    let listenerTarget: Window = window.self;
    try{
      if(window.self !== window.top){
        this.debugLog(`Attempting to attach event listeners to top window: ${window.top.location.href}`, [LogType.CXO, LogType.QA]);
        listenerTarget = window.top;
      }
    }catch(err){
      this.debugLog('Unable to attach event listeners to top window.', [LogType.CXO, LogType.QA]);
    }
    listenerTarget.addEventListener('keydown', (evt)=>{
      keyStatus[evt.code.toLowerCase()] = true;
      this.debugLog(`key down: ${evt.code} = ${keyStatus[evt.code.toLowerCase()]}`, [LogType.CXO]);
      if (keyStatus['keyl'] && keyStatus['semicolon'] && (keyStatus['shiftleft'] || keyStatus['shiftRight'])) {
        if(keyStatus['keya']){
          this.logManager.logMode = LogType.ALL;
          this.debugLog('Shift + : + l + a => Show all console logs.', [LogType.CXO, LogType.IMPORTANT, LogType.QA]);
          this.logManager.showStoredLogs();
        }else if(keyStatus['keym']){
          this.logManager.logMode = `${LogType.INFO}-${LogType.QA}-${LogType.ERROR}-${LogType.INSERT}-${LogType.IMPORTANT}`;
          this.debugLog('Shift + : + l + m => Show most console logs.', [LogType.CXO, LogType.IMPORTANT, LogType.QA]);
          this.logManager.showStoredLogs();
        }else if(keyStatus['keyq']){
          this.logManager.logMode = `${LogType.INFO}-${LogType.QA}-${LogType.ERROR}`;
          this.debugLog('Shift + : + l + q => Show QA console logs.', [LogType.CXO, LogType.IMPORTANT, LogType.QA]);
          this.logManager.showStoredLogs();
        }else if(keyStatus['keyh']){
          this.logManager.logMode += `-${LogType.HIGHLIGHT}`;
          this.debugLog('Shift + : + l + h => Show HIGHLIGHT console logs.', [LogType.HIGHLIGHT]);
          this.logManager.showStoredLogs();
        }
      }else if (keyStatus['keyc'] && keyStatus['keyx'] && keyStatus['keyo'] && (keyStatus['shiftleft'] || keyStatus['shiftRight'])) {
        if(keyStatus['keyk']){
          this.debugLog('Shift + c + x + o + k => Removing CX-Overlay and all video events');
          this.destroyCXO();
        }else if(keyStatus['keyb']){
          this.debugLog('Shift + c + x + o + b => Forcing CX-Overlay bid request');

          this.overlayUtilities.forceNextManualBid = true;
          this.overlayUtilities.forceNextInsert = true;
          this.overlayUtilities.rebidCount = 0;
          this.overlayUtilities.resetCarouselData();

          this.overlayUtilities.initiateBidRequestTimer.execute();
        }else if(keyStatus['keyu'] && keyStatus['keys']){
          this.debugLog('Shift + c + x + o + u + s => Forcing CX-Overlay user sync');
          this.overlayUtilities.addSync(this.overlayUtilities.groupConfig.zoneId);
        }else if(keyStatus['keym'] && keyStatus['keyl']){
          this.logManager.logMode = `${LogType.INFO}-${LogType.QA}-${LogType.ERROR}-${LogType.INSERT}-${LogType.IMPORTANT}`;
          this.debugLog('Shift + c + x + o + l + m => Forcing CX-Overlay QA console logs', [LogType.CXO, LogType.IMPORTANT, LogType.QA]);
          this.logManager.showStoredLogs();
        }
      }
    })
    listenerTarget.addEventListener('keyup', (evt)=>{
      keyStatus[evt.code.toLowerCase()] = false;
      this.debugLog(`key up: ${evt.code} = ${keyStatus[evt.code.toLowerCase()]}`, [LogType.CXO]);
    })
  }

  destroyCXO(){
    this.clearRemainingInserts();
    this.cancelAllTimers();
    this.removeVideoEvents();
    this.sharedFunctions.removeWindowEvents(this.registeredWindowEvents);
    
    this.cxoverlay.removeEventListener('cx-external-event', this.registeredCXExternalEvent);
    const videoElement = this.videoElement ?? (this.cxoverlay as any).foundVideoNode;
    
    if(typeof videoElement?.['cxInitialized'] !== 'undefined'){
      videoElement['cxInitialized'] = null;
      delete(videoElement['cxInitialized']);
    }

    let removeCount: number = 0;
    const removeOverlayInterval = setInterval(()=>{
      if(!isNil(this.cxoverlay.parentElement)){
        clearInterval(removeOverlayInterval);
        this.debugLog('cx-overlay removed from page', [LogType.CXO, LogType.QA, LogType.IMPORTANT]);
        this.cxoverlay.parentElement.removeChild(this.cxoverlay);
      }else{
        this.debugLog('attempted to remove cxoverlay - cxoverlay has no parent element.', [LogType.CXO, LogType.QA, LogType.IMPORTANT]);
        if(removeCount++ > 20){
          clearInterval(removeOverlayInterval);
        }
      }
    }, 500);
    this.debugLog(`Releasing <${this.cxoverlay.tagName}> from video player "${this.qElementId}" and stopping all running code.`, [LogType.CXO, LogType.QA]);
    this.qElementId = null;
    this.videoElement = null;
    this.cxoActive = false;
    this.shouldRequestMoments = false;
  }


  cancelAllTimers(){
    for (var t in this.timers) {
        this.debugLog(`Canceling timer '${this.timers[t].name}'`, [LogType.QA]);
        this.timers[t].cancel();
    }
    this.overlayUtilities.cancelAllTimers();
  }

  findVideoElement(node: any): HTMLVideoElement {
    this.debugLog('findVideoElement')
    let cnode: HTMLVideoElement = null
    let videoNodes = node.getElementsByTagName('video');
    if(videoNodes.length > 1){
      for(let n=0;n < videoNodes.length; n++){
        if(!this.isAdNode(node, videoNodes[n])){
          cnode = videoNodes[n];
          break;
        }else{
          this.debugLog(['Video node is a suspected advertisement: ', videoNodes[n]], [LogType.CXO, LogType.QA]);
        }
      }
      if(cnode === null){
        this.debugLog(['All videos within advert container. Defaulting to first video node.', videoNodes[0]], [LogType.CXO, LogType.QA]);
        cnode = videoNodes[0]
      }
    }else if(videoNodes.length === 1){
      cnode = videoNodes[0];
    }
    return cnode
  }

  isAdNode(topNode: HTMLElement, currentNode: HTMLElement): boolean{
    let isAd: boolean = false;
    if(currentNode !== null && topNode !== currentNode){
      if(
        !!currentNode?.title.toLowerCase().includes('advertisement')
        || (!isNil(currentNode.id) && (currentNode.id.toLowerCase().includes('_ad') || currentNode.id.toLowerCase().includes('-ad')))
        || (!isNil(currentNode.className) && (currentNode.className.toLowerCase().includes('-ad') || currentNode.className.toLowerCase().includes('_ad')))){
          isAd = (!this.playerType.includes(PlayerType.VIDAZOO))?true:false;
      }else{
        this.debugLog('Current Node: ' + !isNil(currentNode.id) + '|' + !isNil(currentNode.id) + ' - ' + currentNode?.id + ' - ' + currentNode?.className + ' - ' + currentNode.parentElement?.outerHTML.substring(0, 50), LogType.IMPORTANT);
        isAd = this.isAdNode(topNode, currentNode.parentElement);
      }
    }
    this.debugLog('Current Node isAd: ' + currentNode?.outerHTML.substring(0, 50) + ": " + isAd, LogType.IMPORTANT);
    return isAd;
  }

  determinePlayerType() {
    let foundPlayerIndex: number = -1;

    //Player types tested in order of PlayerType enum
    for (let p in PlayerType) {
      const playerIndex = this.overlayUtilities.groupConfig.globalPlayerConfigs.findIndex(x => x.player === p);
      if(playerIndex !== -1){
        this.overlayUtilities.groupConfig.globalPlayerConfigs.push(this.overlayUtilities.groupConfig.globalPlayerConfigs.splice(playerIndex, 1)[0]);
      }
    }
    
    let playerDetectionOrder: string = '';
    this.overlayUtilities.groupConfig.globalPlayerConfigs.forEach(x=>{playerDetectionOrder+=(playerDetectionOrder=='')?x.player:', '+x.player})
    this.debugLog(['Player detection order: ' + playerDetectionOrder], [LogType.CXO, LogType.QA]);

    for (let i = 0; i < this.overlayUtilities.groupConfig.globalPlayerConfigs.length && foundPlayerIndex === -1; i++) {
      if (!isNil(this.overlayUtilities.groupConfig.globalPlayerConfigs[i].searchTerm) && this.overlayUtilities.groupConfig.globalPlayerConfigs[i].searchTerm != ''){
        const foundSearchTermNode: HTMLElement = this.findElementFromNode(this.overlayUtilities.groupConfig.globalPlayerConfigs[i].searchTerm, this.videoElementContainer);
        if(!isNil(foundSearchTermNode)){
          this.videoContainerSearchNode = this.getParent(foundSearchTermNode) ?? foundSearchTermNode;
          foundPlayerIndex = i;
          break
        }
      }
    }
    
    this.videoContainerSearchNode ??= this.videoElementContainer;

    if (foundPlayerIndex === -1) {
      foundPlayerIndex = this.overlayUtilities.groupConfig.globalPlayerConfigs.findIndex(x => x.player === PlayerType.UNKNOWN);
      this.debugLog(['Player type not found in player configs. Defaulting to UNKNOWN player.'], [LogType.QA, LogType.CXO]);
    }

    this.playerConfig = this.overlayUtilities.groupConfig.globalPlayerConfigs[foundPlayerIndex];
    this.overlayUtilities._playerConfig = this.playerConfig;
    this.playerType = this.playerConfig.player as PlayerType;
    
    this.analyticsEventDispatcher.sendOverlayEvent(AnalyticsEventType.OVERLAY_HOST_FOUND, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, { host: this.playerType });

    if(!isNil(this.playerConfig.excludedPlayerModes) && this.playerConfig.excludedPlayerModes.length>0){
      this.playerModeExclusionList = this.playerConfig.excludedPlayerModes;
    }
    if(!isNil(this.playerConfig?.playerRoot)){
      this.videoContainerSearchNode = this.findElementFromNode(this.playerConfig.playerRoot, this.videoContainerSearchNode) ?? this.videoContainerSearchNode;
      this.debugLog(`Player root node found: ${this.videoContainerSearchNode?.outerHTML?.substring(0, 50)}.`, [LogType.CXO, LogType.IMPORTANT]);
    }

    if(!isNil(this.playerConfig.domainOverrides)){
      const currentHost: string = this.overlayUtilities.currentWindowLocation.hostname;
      const overrides: {[key:string]:any}[] = this.playerConfig.domainOverrides.filter(override => {
        return !!(override.domains.find(d => currentHost.includes(d)))
      })
      if(!isNil(overrides)){
        const originalPlayerConfig: string = JSON.stringify(this.playerConfig);
        for(let prop in overrides[0]){
          if(prop !== 'domains'){
            this.playerConfig[prop] = overrides[0][prop];
          }
        }
        this.debugLog(['Domain overrides player config: ', originalPlayerConfig, JSON.stringify(this.playerConfig)], [LogType.CXO, LogType.QA]);
      }
    }

    this.debugLog([`Player modes not allowed: ${(this.playerModeExclusionList.length>0)?this.playerModeExclusionList:'none'}`], [LogType.CXO, LogType.QA]);

    let alternateAnchorTarget: string = this.qElementId;
    let alternateSearchNode: HTMLElement = document.querySelector(this.qElementId);
    if(isNil(this.playerConfig.anchorTarget)){
      if(alternateSearchNode === this.videoElement){
        alternateSearchNode = this.getParent(alternateSearchNode);
        alternateSearchNode.classList.add('cx-default-anchor');
        alternateAnchorTarget = '.cx-default-anchor';
      }
    }
    this.playerConfig.anchorTarget ||= alternateAnchorTarget;
    this.videoContainerSearchNode ??= this.getParent(document.querySelector(this.qElementId)) ?? alternateSearchNode;
    
    this.debugLog([`PLAYER DETECTED: ${this.playerType}\n  Configuration loaded:`, this.playerConfig], [LogType.QA, LogType.CXO, LogType.TAM])

    if(this.playerType === PlayerType.ANIPLAYER){
      this.cxoverlay.style.setProperty('display', 'block');
      this.cxoverlay.style.setProperty('position', CSSPosition.ABSOLUTE);
      this.cxoverlay.style.setProperty('overflow', 'visible');
    }
    
    this.moveCxo()
  }

  findElementFromNode(searchForNodeName: string, startNode: HTMLElement): HTMLElement {
    let searchParent: HTMLElement = startNode;
    let isElementFound: boolean = false;
    try{
      if(searchParent.querySelector(searchForNodeName) !== null){
        isElementFound = true;
        searchParent = searchParent.querySelector(searchForNodeName);
      }
      let searchDistance: number = 10;
      while(!isElementFound && searchDistance-- > 0){
        if(typeof searchParent.tagName !== 'undefined' && (searchParent.tagName.toLowerCase() === searchForNodeName.toLowerCase() || searchParent.matches(searchForNodeName))){
          isElementFound = true;
          this.debugLog(`findElementFromNode search ${searchForNodeName} found ${9-searchDistance} nodes above node ${startNode?.outerHTML?.substring(0, 50)} container.`, [LogType.CXO]);
        }else{
          const nextParent:HTMLElement = this.getParent(searchParent)
          if(!isNil(nextParent)){
            searchParent = nextParent;
          }else{
            break;
          }
        }
      }
    }catch(err){
      this.debugLog(`findElementFromNode - Fail on querySelector for ${searchForNodeName}`, LogType.ERROR);
    }
    let returnElement: HTMLElement = null;
    if(isElementFound){
      //returnElement = this.getParent(searchParent) ?? searchParent;
      returnElement = searchParent;
    }
    return returnElement;
  }

  findShadowNodeUp(searchTerm: string, suppressLog:boolean = false): HTMLElement {
    let searchParent = this.videoElementContainer;
    let foundElement: HTMLElement;
    let searchDistance: number = 10;
    while(isNil(foundElement) && searchDistance-- > 0){
      if(typeof searchParent?.tagName !== 'undefined' && (searchParent.tagName.toLowerCase() === searchTerm.toLowerCase() || searchParent.matches(searchTerm))){
        foundElement = searchParent;
      }else if(searchParent?.querySelector(searchTerm) != null){
        foundElement = searchParent.querySelector(searchTerm);
      }else{
        const nextParent:HTMLElement = this.getParent(searchParent)
        if(!isNil(nextParent)){
          searchParent = nextParent;
        }else{
          break;
        }
      }
    }
    if(isNil(foundElement) && !isNil(this.videoElement) && searchDistance === 0){
      searchDistance = 10;
      searchParent = this.videoElement;
      while((typeof foundElement === 'undefined' || foundElement === null) && searchDistance-- > 0){
        if(typeof searchParent?.tagName !== 'undefined' && (searchParent.tagName.toLowerCase() === searchTerm.toLowerCase() || searchParent.matches(searchTerm))){
          foundElement = searchParent;
        }else if(searchParent?.querySelector(searchTerm) != null){
          foundElement = searchParent.querySelector(searchTerm);
        }else{
          const nextParent:HTMLElement = this.getParent(searchParent)
          if(!isNil(nextParent)){
            searchParent = nextParent;
          }else{
            break;
          }
        }
      }
    }
    if(!suppressLog) {
      this.debugLog(`Node found in shadow DOM: ${foundElement?.outerHTML.substring(0, 50)} at a distance of ${9-searchDistance} node(s).`, [LogType.CXO, LogType.QA]);
    }
    return foundElement;
  }
  
  findShadowNodeDown(searchContainer: HTMLElement | ShadowRoot, identifier: string, foundNode: HTMLElement):HTMLElement{
    if(searchContainer !== null && foundNode === null){
      searchContainer.childNodes.forEach(node =>{
          if(foundNode === null && node.nodeType === 1){
            const HTMLNode: HTMLElement = (node as HTMLElement);
            //this.debugLog([`Checking for video in container ${HTMLNode.outerHTML?.substring(0, 50)}`], LogType.IMPORTANT);
            if(HTMLNode.matches(identifier)){
              foundNode = HTMLNode;
            }else{
              foundNode = this.findShadowNodeDown(HTMLNode, identifier, foundNode);
            }
            if(!isNil(HTMLNode.shadowRoot) && foundNode === null){
              foundNode = this.findShadowNodeDown(HTMLNode.shadowRoot, identifier, foundNode);
            }
          }
      })
    }
    return foundNode;
  }

  containsShadowNode(shadowNode: HTMLElement, containerNode: HTMLElement): boolean{
    let containsNode: boolean = false;
    let searchDistance = 20;
    let parentNode = shadowNode;
    while(searchDistance-- > 0 && !containsNode && parentNode !== null){
      if(parentNode === containerNode){
        containsNode = true;
      }
      parentNode = this.getParent(parentNode);
    }
    return containsNode;
  }

  getParent(elem:HTMLElement, getHost: boolean = false): HTMLElement{
    let p:HTMLElement = elem;
    if(!isNil(p)){
      p = elem.parentElement
        || ((elem?.getRootNode?.() === elem || getHost)?(elem?.getRootNode?.() as ShadowRoot)?.host as HTMLElement : elem?.getRootNode?.() as HTMLElement) 
        || null;
      if(p?.nodeName === '#document'){
        p = null;
      }
    }
    return p;
  }

  reinitializeVideoElement(node: any): HTMLVideoElement {
    this.debugLog('reinitializeVideoElement')
    this.checkParentElementAvailability();
    let cnode: HTMLVideoElement = null
    let videoNodes = (!this.isVideoAdvertisement)? node.getElementsByTagName('video'): [];
    let videoInitialized: boolean = false;

    if (videoNodes.length > 1) {
      videoNodes.forEach((vid)=>{
        const vidNode: HTMLVideoElement = vid as HTMLVideoElement;
        if(!videoInitialized && (document.contains(vid) || (this.currentVideoStatus.isShadowPlayer))){
          //this.debugLog(['findVideoElement TESTING: ', vidNode.outerHTML.substring(0, 100)], LogType.IMPORTANT);
          if (cnode === null && !this.isAdNode(node, vidNode)) {
            if(isNil(vid['cxInitialized']) || vid['cxInitialized'] == false){
              cnode = vid;
            }else{
              videoInitialized = true;
              this.debugLog(['Video node already initialized: ', vid], [LogType.CXO, LogType.QA]);
              this.destroyCXO();
            }
            cnode = vidNode;
          }else{
            this.debugLog(['Video node is a suspected advertisement: ', vid], [LogType.CXO, LogType.QA]);
          }
        }
      })
    }
    if (cnode === null) {
      videoNodes.forEach((vid)=>{
        const vidNode: HTMLVideoElement = vid as HTMLVideoElement;
        if(!videoInitialized && (document.contains(vid) || (this.currentVideoStatus.isShadowPlayer))){
          //this.debugLog(['findVideoElement FINAL TESTING: ', vidNode.outerHTML.substring(0, 100)], LogType.IMPORTANT);
          if (cnode === null && !this.isAdNode(vidNode.parentElement, vidNode)) {
            if(isNil(vid['cxInitialized']) || vid['cxInitialized'] == false){
              cnode = vid;
            }else{
              videoInitialized = true;
              this.debugLog(['Video node already initialized: ', vid], [LogType.CXO, LogType.QA]);
              this.destroyCXO();
            }
            cnode = vidNode;
          }else{
            this.debugLog(['Video node is a suspected advertisement: ', vid], [LogType.CXO, LogType.QA]);
          }
        }
      })
    }
    
    if(cnode == null){
      if(!videoInitialized){
        this.timers.reinitializeVideoElementTimer.reset(1000);
      }
    }else{
      const playerElement = cnode;

      this.videoUrl = this.getVideoSource(playerElement);
      if (!isNil(this.videoUrl) && this.videoUrl !== '') {
        this.debugLog('reinitializeVideoElement --foundVideoSource')
        playerElement['cxInitialized']=true
        this.videoElement = playerElement
        this.insertLogicManager.elementHost = playerElement;
        this.determinePlayerType()
        this.debugLog(['CX attached to player: ', this.videoElement], [LogType.QA, LogType.CXO]);
        this.shouldRequestMoments = (!isNil(this.overlayUtilities.groupConfig) && this.overlayUtilities.groupConfig.persistentInserts)?false:true;
        this.resetVideoStatus();

        if (this.cxWait && this.cxoverlay.getAttribute('cx-wait') == null){
          this.cxWait = false;
        }

        this.debugLog('CX video url found (reinitialized): ' + this.videoUrl, [LogType.QA, LogType.CXO]);
        this.determinePlayerMode();
        this.addEvents()
        this.checkCurrentVideoStatus();
        this.checkIfMomentsNeeded()
        this.currentAnchorPosition = 'none';
        this.moveCxo();
        if(this.overlayUtilities.groupConfig.persistentInserts && !isNil(this.activeResource) && this.activeResource.tagName.toLowerCase().includes('squeeze')){
          this.dispatchVideoSqueezeLayers();
        }
        //this.timers.checkForVideoChangeTimer.resetInterval(50, 20);
        //this.timers.updateCXOTimer.execute();
      } else{
        this.debugLog('reinitializeVideoElement --no video source found.')
        this.checkParentElementAvailability();
        this.timers.reinitializeVideoElementTimer.reset(1000);
      }
    }
    return cnode
  }
  
  checkParentElementAvailability(){
    if(!this.currentVideoStatus.isShadowPlayer){
      if(!document.contains(this.videoElementContainer)){
        let newPlayer: HTMLElement = this.videoContainer;
        if(newPlayer !== null){
          this.videoElementContainer = newPlayer.parentElement ?? newPlayer;
        }
      }
    }
  }

  validateInsertTypeAllowedList(resourceData: Resource, allowedInserts: string[]): string[]{
    this.debugLog(['validateInsertTypeAllowedList BEFORE FILTERS: ', [...allowedInserts]]);

    /* URL Parameter to allow removal of native data objects
    Available objects: Headline, Subheadline, MainImage, Icon, CTA
    */
   const removeAssetDataObjectParam = this.logManager.getDebugParamValue(DebugURLParams.REMOVE_ASSET_DATA_OBJECT);
    if(removeAssetDataObjectParam !== null){
      const removeObjects: string = removeAssetDataObjectParam;
      if(!isNil(resourceData.data.assets) && !isNil(removeObjects)){
        if(removeObjects.indexOf('headline')>=0 || removeObjects.indexOf('title')>=0){resourceData.data.assets = resourceData.data.assets.filter((asset:Asset) => asset.id !== 1);}
        if(removeObjects.indexOf('subhead')>=0 || removeObjects.indexOf('description')>=0){resourceData.data.assets = resourceData.data.assets.filter((asset:Asset) => asset.id !== 2);}
        if(removeObjects.indexOf('cta')>=0){resourceData.data.assets = resourceData.data.assets.filter((asset:Asset) => asset.id !== 3);}
        if(removeObjects.indexOf('icon')>=0){resourceData.data.assets = resourceData.data.assets.filter((asset:Asset) => asset.id !== 4);}
        if(removeObjects.indexOf('image')>=0){resourceData.data.assets = resourceData.data.assets.filter((asset:Asset) => asset.id < 5);}
      }
    }

    // REMOVE UNAVAILABLE INSERT TYPES
    //allowedInserts = allowedInserts.filter(ins => ins.insertType.toLowerCase().indexOf('squeeze')===-1)
    for (let i = 0; i < allowedInserts.length; i++) {
      const insertType: string = allowedInserts[i].replace(/-/g, '_').toUpperCase()
      if (!(Object).values(InsertType).includes(InsertType[insertType])) {
        this.debugLog('validateInsertTypeAllowedList' +
          `\n --removeItem = ${allowedInserts[i]}`)
          allowedInserts.splice(i, 1)
          i--;
      }
    }

    //Remove bleedover types on iframe players
    let filteredInsertList: string[] = [...allowedInserts];
    const overflowHidden: ElementHiddenDirection = this.isOverflowHidden;
    if(this.isIframePlayer){
      filteredInsertList = filteredInsertList.filter(ins => ins.toLowerCase().indexOf('bleedover')===-1 );
      this.debugLog("Content will be inside of an iframe container. Bleedover types have been removed.", [LogType.QA, LogType.CXO]);
    }else if(overflowHidden.hiddenX || overflowHidden.hiddenY){
      if (overflowHidden.hiddenX) {
        filteredInsertList = filteredInsertList.filter(ins => ins.toLowerCase().indexOf('bleedover-wing')===-1 );
        this.debugLog("Content overflow hidden along the x-axis. Bleedover wing types have been removed.", [LogType.QA, LogType.CXO]);
      }
      if (overflowHidden.hiddenY) {
        filteredInsertList = filteredInsertList.filter(ins => ins.toLowerCase().indexOf('bleedover-flap')===-1 );
        this.debugLog("Content overflow hidden along the y-axis. Bleedover flap types have been removed.", [LogType.QA, LogType.CXO]);
      }
    }else{
      this.debugLog("Content not within an iframe or overflow:hidden container. Will not filter any insert types.", [LogType.CXO]);
    }

    if(filteredInsertList.length > 0){
      allowedInserts = [...filteredInsertList];
    }else{
      if(!this.overlayUtilities.isMobileDevice){
        if(this.overlayUtilities.currentDimensions.isFloating){
          allowedInserts = [this.currentInserts.nativeOverlayFullwidth]
        }else{
          allowedInserts = [this.currentInserts.nativeOverlayFullwidth, this.currentInserts.nativeOverlayCorner, this.currentInserts.nativeOverlayIcon]
        }
      }else{
        allowedInserts = [this.currentInserts.nativeOverlayFullwidth]
      }
    }

    //if(!this.isVideoFileWidescreen){
    if(!this.isWideScreenVideoPlayer && !this.isVideoFileWidescreen){
      this.debugLog("Removing squeezeback insert types due to video not being in 16:9 format", [LogType.CXO, LogType.QA]);
      allowedInserts = allowedInserts.filter(ins => ins.toLowerCase().indexOf("squeeze")=== -1);

      //If the video is a vertical format video then select the fullwidth overlay format when available to maximize visibility
      if(this.isVerticalVideo && allowedInserts.findIndex(ins => ins === this.currentInserts.nativeOverlayFullwidth) !== -1){
        this.debugLog('Video type detected as vertical video, and fullwidth overlay is available. Will remove all other insert types.', [LogType.CXO, LogType.QA]);
        allowedInserts = allowedInserts.filter(ins => ins === this.currentInserts.nativeOverlayFullwidth);
      }

    } else {
      const videoRatio: number = (!isNil(this.videoElement))?(this.videoElement.videoWidth/this.videoElement.videoHeight):16/9;
      this.debugLog("Will not remove squezeback types: " + this.overlayUtilities.percentageDifference((16/9), (videoRatio)), LogType.CXO);
    }

    if(resourceData.impressionType === ImpressionType.NATIVE){

      //Remove squeezeback display insert types when native response is received
      allowedInserts = allowedInserts.filter(ins => ins !== this.currentInserts.displaySqueeze);

      //Remove squeezeback insert types when video is not expected widescreen aspect ratio
      //if(allowedInserts.findIndex(ins => (ins.insertType === this.currentInserts.nativeCustomSqueeze || ins.insertType === this.currentInserts.ctvSqueeze)) !== -1 && !this.isVideoFileWidescreen){
      if(allowedInserts.findIndex(ins => (ins === this.currentInserts.nativeCustomSqueeze || ins === this.currentInserts.ctvSqueeze)) !== -1 && (!this.isWideScreenVideoPlayer && !this.isVideoFileWidescreen)){
        this.debugLog("Is Insert Native Custom Squeeze? : " + (allowedInserts.findIndex(ins => (ins === this.currentInserts.nativeCustomSqueeze)) == -1 ))
        this.debugLog("Is Insert CTV Squeeze? : " + (allowedInserts.findIndex(ins => (ins === this.currentInserts.ctvSqueeze)) == -1 ))
        allowedInserts = allowedInserts.filter(ins => (ins !== this.currentInserts.nativeCustomSqueeze && ins !== this.currentInserts.ctvSqueeze));
      }

      //Detect if main image is squeezeback, and if squeezeback type is allowed
      let squeezebackImage: Asset = resourceData.data.assets.find((asset:Asset) => asset.id >= 5 && (asset.img.w === 1200 && asset.img.h === 627 || asset.img.isSqueezeback === true));
      if(!isNil(squeezebackImage)){
        let assetURL = (!isNil(squeezebackImage.img) && !isNil(squeezebackImage.img.url))?squeezebackImage.img.url:'';
        let id: string = (assetURL.length>0)?'pre'+assetURL.replace(/[!^\W]/g, ''):'notfound';
        squeezebackImage.img.isSqueezeback ??= this.isCustomSqueezebackImage(id);
        this.debugLog('Is valid custom squeezeback image? ' + squeezebackImage.img.isSqueezeback, [LogType.CXO, LogType.QA]);
        if(!squeezebackImage.img.isSqueezeback){
          allowedInserts = allowedInserts.filter(ins => (ins !== this.currentInserts.nativeCustomSqueeze && ins !== this.currentInserts.ctvSqueeze));
        }else{
          if(this.overlayUtilities.isCTV){
            if(allowedInserts.findIndex(ins => ins === this.currentInserts.ctvSqueeze) !== -1){
              allowedInserts = allowedInserts.filter(ins => ins === this.currentInserts.ctvSqueeze)
              this.debugLog('Squeezeback imagery detected and player mode allows CTV custom squeezeback. Remove all other insert types.', [LogType.CXO, LogType.QA]);
            }else{
              this.debugLog('Squeezeback imagery detected, but custom squeezeback is not an allowed insert type.', [LogType.CXO, LogType.QA]);
            }
          }else{
            if(allowedInserts.findIndex(ins => ins === this.currentInserts.nativeCustomSqueeze) !== -1){
              allowedInserts = allowedInserts.filter(ins => ins === this.currentInserts.nativeCustomSqueeze)
              this.debugLog('Squeezeback imagery detected and player mode allows custom squeezeback. Remove all other insert types.', [LogType.CXO, LogType.QA]);
            }else{
              this.debugLog('Squeezeback imagery detected, but custom squeezeback is not an allowed insert type.', [LogType.CXO, LogType.QA]);
            }
          }
        }
      }else{
        this.debugLog('No squeezeback images available. Removing custom squeezeback inserts from options.', [LogType.CXO, LogType.QA]);
        allowedInserts = allowedInserts.filter(ins => (ins !== this.currentInserts.nativeCustomSqueeze && ins !== this.currentInserts.ctvSqueeze));
      }

      //For native insert creation: pick appropriate insert types based on availability of icon and imagery
      filteredInsertList = [...allowedInserts]
      const logoAvailable: boolean = (!isNil(resourceData.data.assets.find(x => x.id == 4)))?true:false
      const imageAvailable: boolean = (!isNil(resourceData.data.assets.find(x => x.id >= 5)))?true:false
      if(imageAvailable && !logoAvailable){
        //Only main image available - Image only inserts
        this.debugLog('No logo available. Filtering out insert types that include logos.', [LogType.QA, LogType.CXO]);

        const logoAvailableInserts: string[] = [
          this.currentInserts.nativeOverlayIcon,
          this.currentInserts.nativeOverlayFullwidth,
          this.currentInserts.nativeSqueeze,
        ]

        filteredInsertList = filteredInsertList.filter(ins => !logoAvailableInserts.includes(ins))

        this.debugLog(`Remaining 'no logo' insert count: ${filteredInsertList.length}`, [LogType.QA, LogType.CXO]);
        
      }else if(logoAvailable && !imageAvailable){
        //Only logo imagery available - Logo only inserts (none available currently)
        //this.debugLog('No main image available. Filtering out insert types that include main images.', [LogType.QA, LogType.CXO]);
      }else if(!logoAvailable && !imageAvailable){
        //No imagery available - Text only inserts (none available currently)
        //this.debugLog('No imagery available. Filtering out insert types that include images.', [LogType.QA, LogType.CXO]);
      }

      if(filteredInsertList.length > 0){
        allowedInserts = [...filteredInsertList];
      }

    }else if(resourceData.impressionType === ImpressionType.DISPLAY){
      //Remove squeezeback insert types when ImpressionType is not a native unit
      if(allowedInserts.findIndex(ins => ins === this.currentInserts.nativeCustomSqueeze) !== -1){
        allowedInserts = allowedInserts.filter(ins => (ins !== this.currentInserts.nativeCustomSqueeze && ins !== this.currentInserts.ctvSqueeze));
        this.debugLog('Banner bid received. Will remove Custom Squeezeback as an available insert option.' , [LogType.CXO]);
      }
    }

    //If creating a new insert while an active insert already exists then try to keep the same insert type.
    if(!isNil(this.activeResource)){
      filteredInsertList = [...allowedInserts]
      let currentType: string = this.activeResource.tagName.toLowerCase();
      switch(currentType){
        case this.currentInserts.displayOverlayFullwidth:
          currentType = this.currentInserts.nativeOverlayFullwidth;
          break;
        case this.currentInserts.displayFlap:
          currentType = this.currentInserts.nativeFlap;
          break;
        case this.currentInserts.displayWing:
          currentType = this.currentInserts.nativeWing;
          break;
        case this.currentInserts.displayOverlayCorner:
          currentType = this.currentInserts.nativeOverlayCorner;
          break;
        case this.currentInserts.displaySqueeze:
          currentType = this.currentInserts.nativeSqueeze;
          break;
      }
      filteredInsertList = filteredInsertList.filter(ins => ins === currentType);
      if(filteredInsertList.length > 0){
        allowedInserts = [...filteredInsertList];
        this.debugLog(`${currentType} still available in allowed inserts list. Will be preferred insert at insert creation`, [LogType.CXO]);
      }
    }

    if(resourceData.impressionType === ImpressionType.NATIVE){
      //Prefer flaps over wings when both flaps and wings are available
      const mainImage = resourceData.data.assets.find((asset:Asset) => asset.id === 5);
      if(!isNil(mainImage)){
        filteredInsertList = [...allowedInserts];
        
        this.debugLog(['validateInsertTypeAllowedList BEFORE FLOATING FILTERS: ', [...filteredInsertList]]);
        if(mainImage.img.w/mainImage.img.h > .6){
          filteredInsertList = filteredInsertList.filter(ins => ins.toLowerCase().indexOf('wing')===-1 )
        }else{
          filteredInsertList = filteredInsertList.filter(ins => ins.toLowerCase().indexOf('flap')===-1 )
        }
        if(filteredInsertList.length > 0){
          allowedInserts = [...filteredInsertList];
        }
      }
    }
    
    this.debugLog(['validateInsertTypeAllowedList AFTER FILTERS: ', [...allowedInserts]]);

    return allowedInserts
  }

  isCustomSqueezebackImage(id:string): boolean{
    let squeezeback: boolean = true;
    let preloadedImage: HTMLImageElement = this.overlayTimerElement.querySelector('#'+id);

    this.debugLog(['Testing image for squeezeback qualities:', preloadedImage], [LogType.CXO, LogType.QA]);
    const squeezebackRatio: number = 1200/627;

    if(!isNil(preloadedImage) && preloadedImage.complete && preloadedImage.naturalWidth/preloadedImage.naturalHeight === squeezebackRatio){
      let imageCanvas: HTMLCanvasElement = document.createElement('canvas');
      imageCanvas.width = preloadedImage.naturalWidth;
      imageCanvas.height = preloadedImage.naturalHeight;
      let imageContext = imageCanvas.getContext('2d');
      imageContext.globalCompositeOperation = 'source-over';
      imageContext.drawImage(preloadedImage, 0, 0);
      let imageData: Uint8ClampedArray = imageContext.getImageData(0, 0, imageCanvas.width, imageCanvas.height).data;

      //TESTING 100 RANDOM PIXELS IN THE MIDDLE OF OUR IMAGE FOR EQUALITY
      let centerPixel: number[] = this.getPixelValue(imageData, Math.floor(imageCanvas.width*.5), Math.floor(imageCanvas.height*.5), imageCanvas.width);
      for(let i = 0; i <= 100; i++){
        let xRand = Math.floor(imageCanvas.width*.25)+(Math.floor(Math.random()*imageCanvas.width*.5));
        let yRand = Math.floor(imageCanvas.height*.25)+(Math.floor(Math.random()*imageCanvas.height*.5));
        let pixelValue: number[] = this.getPixelValue(imageData, xRand, yRand, imageCanvas.width);
        if(!(centerPixel[0]===pixelValue[0] && centerPixel[1]===pixelValue[1] && centerPixel[2]===pixelValue[2] && centerPixel[3]===pixelValue[3])){
          squeezeback = false;
          this.debugLog(['Squeezeback image not detected. Mismatched pixels:', centerPixel, pixelValue], [LogType.QA, LogType.CXO]);
          break;
        }
        //this.debugLog('Are pixels equivalent ('+xRand+','+yRand+')? ' + centerPixel + ' === ' + pixelValue + ' = ' + (centerPixel[0]===pixelValue[0] && centerPixel[1]===pixelValue[1] && centerPixel[2]===pixelValue[2] && centerPixel[3]===pixelValue[3]), LogType.IMPORTANT);
      }
    }else{
      squeezeback = false;
    }

    return squeezeback;
  }

  getPixelValue(imageData: Uint8ClampedArray, x:number, y:number, w:number):number[]{
    const pixelIndex: number = (y*w+x)*4;
    return [imageData[pixelIndex], imageData[pixelIndex+1], imageData[pixelIndex+2], imageData[pixelIndex+3]];
  }
  
  removeProhibitedInsertTypes(list: string[] = []) {
    this.debugLog(['removeProhibitedInsertTypes BEFORE FILTERS: ', [...list]]);
    const overflowHidden: ElementHiddenDirection = this.isOverflowHidden;
    if (this.overlayUtilities.currentDimensions.isFullscreen || this.isIframePlayer) {
      const listBeforeFilter = [...list];
      list = list.filter(x => x.toLowerCase().indexOf('bleedover') === -1);
      if(listBeforeFilter.length != list.length){
        this.debugLog(['Bleedover types will not render in fullscreen/iframe/overflow=hidden mode. Allowed inserts after filtered:', list], [LogType.QA, LogType.CXO]);
      }
    } else {
      if (overflowHidden.hiddenY) {
        const listBeforeFilter = [...list];
        list = list.filter(x => x.toLowerCase().indexOf('bleedover-flap') === -1);
        if(listBeforeFilter.length != list.length){
          this.debugLog(['Overflow hidden on the y-axis. Flap inserts will not be visible. Removing from available options. Allowed inserts after page width wings filter:', list], [LogType.QA, LogType.CXO]);
        }
      }
      if (overflowHidden.hiddenX || !this.doesWingInsertFit) {
        const listBeforeFilter = [...list];
        list = list.filter(x => x.toLowerCase().indexOf('bleedover-wing') === -1);
        if(listBeforeFilter.length !== list.length){
          const reasonLog: string = (overflowHidden.hiddenX)?'Overflow hidden on the x-axis. Wing inserts will not be visible. Removing from available options. Allowed inserts after page width wings filter:':'Window width is not large enough to support wing insert. Removing from available options. Allowed inserts after page width wings filter:';
          this.debugLog([reasonLog, list], [LogType.QA, LogType.CXO]);
        }
      }
    }
    return list
  }

  determineFloatingPosition(calculationDimensions: ElementDimensions = null): FloatingPlayerPosition {

    calculationDimensions ??= this.overlayUtilities.currentDimensions;

    let newPosition: FloatingPlayerPosition = FloatingPlayerPosition.BOTTOM_RIGHT;

    const playerVerticalCenter = calculationDimensions.top + (calculationDimensions.height/calculationDimensions.scale)*.5;
    const playerHorizontalCenter = calculationDimensions.left + (calculationDimensions.width/calculationDimensions.scale)*.5;
    const videoScale: number = calculationDimensions.elementScale;

    let floatingOnTop: boolean = (playerVerticalCenter < calculationDimensions.winHeight*.5)?true:false;
    let floatingOnLeft: boolean = (playerHorizontalCenter < calculationDimensions.winWidth*.5)?true:false;
    this.floatingCardinalDirections = {top:'auto', bottom:'auto', left:'auto', right:'auto'};
    if(floatingOnTop){
      newPosition =(floatingOnLeft)?FloatingPlayerPosition.TOP_LEFT:FloatingPlayerPosition.TOP_RIGHT;
      this.floatingCardinalDirections.top = Math.round(calculationDimensions.top) + 'px'
    }else{
      newPosition =(floatingOnLeft)?FloatingPlayerPosition.BOTTOM_LEFT:FloatingPlayerPosition.BOTTOM_RIGHT;
      this.floatingCardinalDirections.bottom = Math.round(calculationDimensions.bottom) + 'px'
    }
    if(floatingOnLeft){
      this.floatingCardinalDirections.left = Math.round(calculationDimensions.left) + 'px'
    }else{
      this.floatingCardinalDirections.right = Math.round(calculationDimensions.right) + 'px'
    }

    if(Math.abs(playerHorizontalCenter/calculationDimensions.winWidth-.5) < .1){
      if(Math.abs(playerVerticalCenter/calculationDimensions.winHeight-.5) < .1){
        newPosition = FloatingPlayerPosition.CENTER;
      }else if(calculationDimensions.top < 50){
        //this.debugLog(`PLAYER IN CENTER TOP: ${calculationDimensions.top}`, LogType.IMPORTANT);
        newPosition = FloatingPlayerPosition.TOP_CENTER;
      }
    }

    this.debugLog('determineFloatingPosition' +
      `\n --position = top - ${calculationDimensions.top} : bottom - ${calculationDimensions.bottom} : left - ${calculationDimensions.left} : right - ${calculationDimensions.right} : width - ${calculationDimensions.width} : height - ${calculationDimensions.height} : scale - ${calculationDimensions.scale}}` +
      `\n --position = ${newPosition}` +
      `\n --top = ${this.floatingCardinalDirections.top}` +
      `\n --bottom = ${this.floatingCardinalDirections.bottom}` +
      `\n --left = ${this.floatingCardinalDirections.left}` +
      `\n --right = ${this.floatingCardinalDirections.right}` +
      `\n --scale = ${videoScale}` +
      `\n --clientWidth = ${calculationDimensions.winWidth}` +
      `\n --clientHeight = ${calculationDimensions.winHeight}`)
      
    return newPosition
  }

  moveCxo() {

    //Determine the anchor target based on player mode
    let newAnchorTarget: string = this.anchorTarget;
    
    if(this.overlayUtilities.currentDimensions.isFullscreen && !isNil(this.playerConfig.fullscreenAnchorTarget)){
      newAnchorTarget = this.playerConfig.fullscreenAnchorTarget
    }else if(!isNil(this.playerConfig.bleedoverAnchorTarget) && this.optimalInsertType.includes('bleedover')){
      newAnchorTarget = this.playerConfig.bleedoverAnchorTarget
    }else{
      newAnchorTarget = this.playerConfig.anchorTarget
    }
    
    //Determine where the cx-o will be placed based on the anchor target
    let newAnchorPosition: string = this.currentAnchorPosition;
    if(!isNil(this.optimalInsertType) && this.optimalInsertType !== InsertType.NONE){
      if(this.overlayUtilities.currentDimensions.isFullscreen && !this.overlayUtilities.currentDimensions.isFloating){
        newAnchorPosition = this.playerConfig.moveCxoFullscreen;
      }else if(this.optimalInsertType.includes('bleedover')) {
        newAnchorPosition = this.playerConfig.moveCxoBleedover;
      }else{
        newAnchorPosition = this.playerConfig.moveCxoStandard;
        if (newAnchorPosition === 'none') {
          newAnchorPosition = 'parent'
        }
      }
    }

    if(this.anchorTarget !== newAnchorTarget || this.currentAnchorPosition !== newAnchorPosition){

      this.debugLog(`CXO move required - from location [${this.anchorTarget}:${this.currentAnchorPosition}] to location [${newAnchorTarget}:${newAnchorPosition}]`, [LogType.CXO, LogType.QA]);

      this.debugLog([`moveCxo --anchorTarget = ${this.anchorTarget}  --anchorPosition = ${this.currentAnchorPosition} `, this.videoContainerSearchNode])
      
      let shouldMoveCXO: boolean = true;
      if(!isNil(this.activeResource) && this.activeResourceData.impressionType === ImpressionType.DISPLAY){
        if(this.overlayUtilities.groupConfig.persistentInserts === true){
          shouldMoveCXO = false;
          this.debugLog(['Banner insert is active and group uses persistentInserts. Will not move CX-O layer.', this.activeResource], [LogType.QA]);
        }else if(this.currentVideoElementScale !== 1){
          this.debugLog(['Banner insert is active and video has been scaled. Will remove insert and move CX-O layer.', this.activeResource], [LogType.QA]);
          this.clearRemainingInserts();
        }else{
          shouldMoveCXO = false;
          this.debugLog(['Banner insert is active. Will not move CX-O layer.', this.activeResource], [LogType.QA]);
        }
      }
      if(shouldMoveCXO){
        this.anchorTarget = newAnchorTarget;
        this.currentAnchorPosition = newAnchorPosition;

        if(!this.currentVideoStatus.isShadowPlayer){
          const anchorNode:HTMLElement = this.videoContainerSearchNode.querySelector(this.anchorTarget) ?? this.videoElementContainer;
          switch (this.currentAnchorPosition) {
            case 'video':
            case 'after-video':
              this.videoElement.after(this.cxoverlay);
              break
            case 'into':
              anchorNode.appendChild(this.cxoverlay)
              break
            case 'after':
              anchorNode.after(this.cxoverlay)
              break
            case 'before':
              anchorNode.parentElement.insertBefore(this.cxoverlay, this.videoContainerSearchNode.querySelector(this.anchorTarget))
              break
            case 'default':
              this.videoElementContainer.appendChild(this.cxoverlay)
              break
            default:
              break
          }
        }else{
          const shadowAnchor: HTMLElement = this.findShadowNodeUp(this.anchorTarget);
          const parentNode: HTMLElement = this.getParent(shadowAnchor);
          switch (this.currentAnchorPosition) {
            case 'video':
            case 'after-video':
              this.videoElement.after(this.cxoverlay);
              break
            case 'into':
              shadowAnchor.appendChild(this.cxoverlay);
              break
            case 'after':
              parentNode.appendChild(this.cxoverlay);
              break
            case 'before':
              parentNode.insertBefore(this.cxoverlay, shadowAnchor);
              break
            case 'default':
              this.videoElementContainer.appendChild(this.cxoverlay)
              break
            default:
              break
          }
        }
      }
    }
  }

  selectInsertTypeFromOptions(resourceData: Resource) {
    let optionsList: string[] = this.validateInsertTypeAllowedList(resourceData, this.overlayUtilities.determineInsertTypeOptions()) ?? [];

    if(this.overlayUtilities.isCTV){
      this.debugLog(['CTV OPTIONS LIST', optionsList], [LogType.CXO, LogType.QA, LogType.IMPORTANT]);
      if(optionsList.length > 0){
        let optionChosen = optionsList[Math.floor(Math.random() * optionsList.length)].replace(/-/g, '_').toUpperCase();
        this.optimalInsertType = InsertType[optionChosen];
        this.optimalInsertPosition = this.determineOptimalInsertPosition();
        const title: string = resourceData.data?.assets?.find(ass => parseInt(ass?.id) === 1)?.title?.text?.trim?.();
        this.debugLog(`CTV headline: ${title}`, LogType.IMPORTANT);
        if(this.optimalInsertType === this.currentInserts.ctvOverlayCorner && (title?.length === 0 || title.toLowerCase() === 'main-image-only')){
          this.debugLog(`Set CTV insert to ${InsertType.CTV_OVERLAY_MAIN_IMAGE_ONLY}`, LogType.IMPORTANT);
          this.optimalInsertType = InsertType.CTV_OVERLAY_MAIN_IMAGE_ONLY;
          const description: string = resourceData.data?.assets?.find(ass => parseInt(ass?.id) === 2)?.data?.value?.trim?.();
          if(description?.length === 2){
            const descriptionPosition: string = description.toLowerCase();
            if(descriptionPosition.includes('t') && descriptionPosition.includes('l')){
              this.optimalInsertPosition = InsertPosition.TOP_LEFT;
            }else if(descriptionPosition.includes('t') && descriptionPosition.includes('r')){
              this.optimalInsertPosition = InsertPosition.TOP_RIGHT;
            }else if(descriptionPosition.includes('b') && descriptionPosition.includes('l')){
              this.optimalInsertPosition = InsertPosition.BOTTOM_LEFT;
            }else if(descriptionPosition.includes('b') && descriptionPosition.includes('r')){
              this.optimalInsertPosition = InsertPosition.BOTTOM_RIGHT;
            }else{
              this.optimalInsertPosition = InsertPosition.DEFAULT;
            }
            this.debugLog(`Set CTV insert position to ${this.optimalInsertPosition}`, LogType.IMPORTANT);
          }
        }
        this.determineIfDebugOverrideInsertType();
      }
    }else if(resourceData.impressionType === ImpressionType.DISPLAY){
      if(this.forceBannerCustomSqueeze){
        this.optimalInsertType = InsertType.DISPLAY_CUSTOM_SQUEEZE_BACK;
        this.optimalInsertPosition = InsertPosition.DEFAULT;
      }else{
        let bannerSize: number[] = [resourceData.data.w, resourceData.data.h];
        if(optionsList.find(insertName => insertName === this.currentInserts.nativeSqueeze) && this.overlayUtilities.allowedBannerSizes.squeezeback.find(size => size[0] === bannerSize[0] && size[1] === bannerSize[1])){
          this.optimalInsertType = this.currentInserts.displaySqueeze;
        }else if(optionsList.find(insertName => !!insertName?.includes('wing')) && (this.overlayUtilities.allowedBannerSizes.wing.find(size => size[0] === bannerSize[0] && size[1] === bannerSize[1]) || this.overlayUtilities.allowedBannerSizes.wingTall.find(size => size[0] === bannerSize[0] && size[1] === bannerSize[1]))){
          this.optimalInsertType = this.currentInserts.displayWing;
        }else if(optionsList.find(insertName => !!insertName?.includes('flap')) && this.overlayUtilities.allowedBannerSizes.flap.find(size => size[0] === bannerSize[0] && size[1] === bannerSize[1])){
          this.optimalInsertType = this.currentInserts.displayFlap;
        }else if(optionsList.find(insertName =>  insertName === this.currentInserts.nativeOverlayFullwidth) && this.overlayUtilities.allowedBannerSizes.overlayFullwidth.find(size => size[0] === bannerSize[0] && size[1] === bannerSize[1])){
          this.optimalInsertType = this.currentInserts.displayOverlayFullwidth;
        }else if(optionsList.find(insertName =>  !!insertName?.includes('overlay')) && this.overlayUtilities.allowedBannerSizes.overlayCorner.find(size => size[0] === bannerSize[0] && size[1] === bannerSize[1])){
          this.optimalInsertType = this.currentInserts.displayOverlayCorner;
        }else{
          this.optimalInsertType = InsertType.NONE;
        }
        this.optimalInsertPosition = this.determineOptimalInsertPosition()
      }
      this.debugLog('selectInsertTypeFromOptions (display)' +
        `\n --optionsList = ${optionsList}` +
        `\n --optimalInsertType = ${this.optimalInsertType}` +
        `\n --optimalInsertPosition = ${this.optimalInsertPosition}`)
    }else{
      if(optionsList.length > 0){
        let optionChosen = optionsList[Math.floor(Math.random() * optionsList.length)].replace(/-/g, '_').toUpperCase()
        this.optimalInsertType = InsertType[optionChosen]
        this.optimalInsertPosition = this.determineOptimalInsertPosition()
        this.determineIfDebugOverrideInsertType()
      }else{
        this.optimalInsertType = InsertType.NONE;
      }
      this.debugLog('selectInsertTypeFromOptions (native)' +
        `\n --optionsList = ${optionsList}` +
        `\n --numberAllowedInsertTypes = ${optionsList.length}` +
        `\n --optimalInsertType = ${this.optimalInsertType}` +
        `\n --optimalInsertPosition = ${this.optimalInsertPosition}`)
    }
  }

  determineOptimalInsertPosition(): InsertPosition {
    let optimalPosition: InsertPosition = InsertPosition.DEFAULT;
    if(this.optimalInsertType.toLowerCase().indexOf('wing') !== -1){
      optimalPosition = (this.overlayUtilities.currentDimensions.left > this.overlayUtilities.currentDimensions.right)?InsertPosition.BOTTOM_LEFT:InsertPosition.BOTTOM_RIGHT;
    }else if(this.optimalInsertType.toLowerCase().indexOf('flap') !== -1){
      optimalPosition = (this.overlayUtilities.currentDimensions.top > this.overlayUtilities.currentDimensions.bottom)?InsertPosition.TOP_LEFT:InsertPosition.BOTTOM_LEFT;
    }else if(this.optimalInsertType.toLowerCase().indexOf('squeeze') !== -1){
      optimalPosition = InsertPosition.TOP_LEFT;
    }
    return optimalPosition;
  }

  determineIfDebugOverrideInsertType() {
    const insertTypeOverrideParam = this.logManager.getDebugParamValue(DebugURLParams.INSERT_TYPE_OVERRIDE);
    if (insertTypeOverrideParam !== null) {
      /* INSERT TO OVERRIDE (POSITION)
       &DEBUGinsertOverridePosition=1
       */
      const insertOverrideLocationParam = this.logManager.getDebugParamValue(DebugURLParams.INSERT_OVERRIDE_LOCATION);
      if (
        insertOverrideLocationParam == null || parseInt(insertOverrideLocationParam)===(++this.insertCount)
      ){
        const overrideType = insertTypeOverrideParam;
        /* TYPES
        CTV
          ?DEBUGinsertTypeOverride=ctv-squeeze-back-custom
          ?DEBUGinsertTypeOverride=ctv-overlay-corner-clean-qr
          ?DEBUGinsertTypeOverride=ctv-overlay-main-image-only
        SQUEEZEBACK
          ?DEBUGinsertTypeOverride=squeezeback
          ?DEBUGinsertTypeOverride=squeeze-back-custom-full-background
          ?DEBUGinsertTypeOverride=squeeze-back-banner
        OVERLAY
          ?DEBUGinsertTypeOverride=overlayhorizontalslidecolordetect
          ?DEBUGinsertTypeOverride=overlayslideiconcolordetect
          ?DEBUGinsertTypeOverride=overlayfullwidthiconcolordetect
        FLAP
          ?DEBUGinsertTypeOverride=bleedoverflaprevolvingheadline
        WING
          ?DEBUGinsertTypeOverride=bleedoverwingprecisionsize
        */
        switch (overrideType) {
          case 'squeeze-back-custom-full-background':
            this.optimalInsertType = InsertType.SQUEEZE_BACK_CUSTOM_FULL_BACKGROUND
            this.optimalInsertPosition = InsertPosition.DEFAULT
            break
          case 'squeeze-back-dynamic-fullwidth':
            this.optimalInsertType = InsertType.SQUEEZE_BACK_DYNAMIC_FULLWIDTH
            this.optimalInsertPosition = InsertPosition.DEFAULT
            break
          case 'squeeze-back-banner':
            this.optimalInsertType = InsertType.DISPLAY_SQUEEZE_BACK_BANNER
            this.optimalInsertPosition = InsertPosition.DEFAULT
            break
          case 'overlayhorizontalslidecolordetect':
            this.optimalInsertType = InsertType.OVERLAY_HORIZONTAL_SLIDE_COLOR_DETECT
            this.optimalInsertPosition = InsertPosition.DEFAULT
            break
          case 'overlayslideiconcolordetect':
            this.optimalInsertType = InsertType.OVERLAY_SLIDE_ICON_COLOR_DETECT
            this.optimalInsertPosition = InsertPosition.DEFAULT
            break
          case 'overlayfullwidthiconcolordetect':
            this.optimalInsertType = InsertType.OVERLAY_FULLWIDTH_ICON_COLOR_DETECT
            this.optimalInsertPosition = InsertPosition.DEFAULT
            break
          case 'bleedoverflaprevolvingheadline':
            this.optimalInsertType = InsertType.BLEEDOVER_FLAP_REVOLVING_HEADLINE
            this.optimalInsertPosition = (this.optimalInsertPosition.indexOf('t')>-1)?InsertPosition.TOP_LEFT:InsertPosition.DEFAULT
            break
          case 'bleedoverwingprecisionsize':
            this.optimalInsertType = InsertType.BLEEDOVER_WING_PRECISION_SIZE
            this.optimalInsertPosition = (this.optimalInsertPosition.indexOf('r')>-1)?InsertPosition.BOTTOM_RIGHT:InsertPosition.DEFAULT
            break
          case 'ctv-squeeze-back-custom-qr':
            this.optimalInsertType = InsertType.CTV_SQUEEZE_BACK_CUSTOM_QR
            this.optimalInsertPosition = InsertPosition.DEFAULT
            break
          case 'ctv-squeeze-back-custom':
            this.optimalInsertType = InsertType.CTV_SQUEEZE_BACK_CUSTOM
            this.optimalInsertPosition = InsertPosition.DEFAULT
            break
          case InsertType.CTV_OVERLAY_CORNER_CLEAN_QR:
            this.optimalInsertType = InsertType.CTV_OVERLAY_CORNER_CLEAN_QR
            this.optimalInsertPosition = InsertPosition.DEFAULT
            break
          case InsertType.CTV_OVERLAY_MAIN_IMAGE_ONLY:
            this.optimalInsertType = InsertType.CTV_OVERLAY_MAIN_IMAGE_ONLY
            this.optimalInsertPosition = InsertPosition.DEFAULT
            break
        }
      }
    }
  }

  determinePlayerMode(useDimensions: ElementDimensions = null) {
    const videoRect = (!isNil(this.videoElement))?this.videoElement.getBoundingClientRect():null;
    let isFullscreen = false;
    let isFloating = false;
    this.overlayUtilities.isOnStream = !this.isInArticlePlayer;
    
    let defaultPlayerMode: PlayerMode;
    if(!this.overlayUtilities.isMobileDevice){
      defaultPlayerMode = (this.playerModeExclusionList.indexOf(PlayerMode.DESKTOP_ONSTREAM)===-1)?PlayerMode.DESKTOP_ONSTREAM:(this.playerModeExclusionList.indexOf(PlayerMode.DESKTOP_INARTICLE)===-1)?PlayerMode.DESKTOP_INARTICLE:PlayerMode.DESKTOP_FLOATING;
    }else{
      defaultPlayerMode = (this.playerModeExclusionList.indexOf(PlayerMode.MOBILE_ONSTREAM)===-1)?PlayerMode.MOBILE_ONSTREAM:(this.playerModeExclusionList.indexOf(PlayerMode.MOBILE_INARTICLE)===-1)?PlayerMode.MOBILE_INARTICLE:PlayerMode.MOBILE_FLOATING;
    }
    const videoScale: number = this.currentVideoElementScale;
    if (document.fullscreenElement || this.overlayUtilities.isCTV || (typeof (document as any).webkitCurrentFullScreenElement !== 'undefined' && (document as any).webkitCurrentFullScreenElement !== null) || (!this.isIframePlayer && videoRect !== null && Math.abs(((videoRect.width/videoScale)/window.innerWidth)-1)<.15 && (Math.abs(((videoRect.height/videoScale)/window.innerHeight)-1)<.15 || videoRect.height/videoScale > window.innerHeight))) {
      isFullscreen = true
      if(this.playerMode !== PlayerMode.DESKTOP_ONSTREAM && this.playerMode !== PlayerMode.MOBILE_ONSTREAM){
        this.debugLog('determinePlayerMode' + `\n --playerMode = full screen`);
      }
      this.playerMode = (this.overlayUtilities.isMobileDevice && this.playerModeExclusionList.indexOf(PlayerMode.MOBILE_ONSTREAM)===-1)?PlayerMode.MOBILE_ONSTREAM:(this.playerModeExclusionList.indexOf(PlayerMode.DESKTOP_ONSTREAM)===-1)?PlayerMode.DESKTOP_ONSTREAM:defaultPlayerMode
    } else {
      isFloating = this.isPlayerFloating;
      if (isFloating) {
        this.floatingPosition = this.determineFloatingPosition(useDimensions);
        if(this.floatingPosition === FloatingPlayerPosition.CENTER){
          isFullscreen = true;
          if(this.playerMode !== PlayerMode.DESKTOP_ONSTREAM && this.playerMode !== PlayerMode.MOBILE_ONSTREAM){
            this.debugLog('determinePlayerMode' + `\n --playerMode = floating full screen`, [LogType.QA, LogType.CXO]);
          }
          this.playerMode = (this.overlayUtilities.isMobileDevice && this.playerModeExclusionList.indexOf(PlayerMode.MOBILE_ONSTREAM)===-1)?PlayerMode.MOBILE_ONSTREAM:(this.playerModeExclusionList.indexOf(PlayerMode.DESKTOP_ONSTREAM)===-1)?PlayerMode.DESKTOP_ONSTREAM:defaultPlayerMode
        }else if(this.floatingPosition === FloatingPlayerPosition.TOP_CENTER){
          if(this.playerMode !== PlayerMode.DESKTOP_ONSTREAM && this.playerMode !== PlayerMode.MOBILE_ONSTREAM){
            this.debugLog('determinePlayerMode' + `\n --playerMode = floating top On-Stream`, [LogType.QA, LogType.CXO]);
          }
          this.playerMode = (this.overlayUtilities.isMobileDevice && this.playerModeExclusionList.indexOf(PlayerMode.MOBILE_ONSTREAM)===-1)?PlayerMode.MOBILE_ONSTREAM:(this.playerModeExclusionList.indexOf(PlayerMode.DESKTOP_ONSTREAM)===-1)?PlayerMode.DESKTOP_ONSTREAM:defaultPlayerMode
        }else{
          this.playerMode = (this.overlayUtilities.isMobileDevice && this.playerModeExclusionList.indexOf(PlayerMode.MOBILE_FLOATING)===-1)?PlayerMode.MOBILE_FLOATING:(this.playerModeExclusionList.indexOf(PlayerMode.DESKTOP_FLOATING)===-1)?PlayerMode.DESKTOP_FLOATING:defaultPlayerMode
        }
      } else if (this.overlayUtilities.isOnStream) {
        this.playerMode = (this.overlayUtilities.isMobileDevice && this.playerModeExclusionList.indexOf(PlayerMode.MOBILE_ONSTREAM)===-1)?PlayerMode.MOBILE_ONSTREAM:(this.playerModeExclusionList.indexOf(PlayerMode.DESKTOP_ONSTREAM)===-1)?PlayerMode.DESKTOP_ONSTREAM:defaultPlayerMode
      } else {
        this.playerMode = (this.overlayUtilities.isMobileDevice && this.playerModeExclusionList.indexOf(PlayerMode.MOBILE_INARTICLE)===-1)?PlayerMode.MOBILE_INARTICLE:(this.playerModeExclusionList.indexOf(PlayerMode.DESKTOP_INARTICLE)===-1)?PlayerMode.DESKTOP_INARTICLE:defaultPlayerMode
      }
    } 

    this.debugLog('determinePlayerMode' + `\n --playerMode = ${this.playerMode}`)

    if(this.overlayUtilities.currentDimensions.isFullscreen !== isFullscreen){
      this.debugLog('determinePlayerMode change in fullscreen player:' + `\n --is Player Fullscreen = ${isFullscreen}` + `\n --was Player Fullscreen = ${this.overlayUtilities.currentDimensions.isFullscreen}`, [LogType.CXO, LogType.QA]);
      this.overlayUtilities.currentDimensions.isFullscreen = isFullscreen;
      this.moveCxo();
    }
    if(this.overlayUtilities.currentDimensions.isFloating !== isFloating){
      this.debugLog('determinePlayerMode change in floating player:' + `\n --is Player Floating = ${isFloating}` + `\n --was Player Floating = ${this.overlayUtilities.currentDimensions.isFloating}`, [LogType.CXO, LogType.QA]);
      this.overlayUtilities.currentDimensions.isFloating = isFloating;
      if(!isFloating && !this.videoPlayerLost){
        if(this.overlayTimerElement.style.getPropertyValue('opacity') == '0'){
          this.overlayTimerElement.style.setProperty('opacity', '1');
        }
      }
      this.moveCxo();
    }
    //this.debugLog('determined player mode: ' + this.playerMode, LogType.IMPORTANT)
  }

  handleVideoSourceChange() {
    if (!this.didVideoSourceChange) {
      this.debugLog('handleVideoSourceChange --video source not changed', [LogType.CXO])
    } else {

      if(this.currentVideoStatus.currentTime > 0 && (Math.abs(this.currentVideoStatus.currentTime - this.videoElement.currentTime) > 1.5)){
        this.sendVideoEndedAnalytics();
      }

      this.currentVideoStatus.videoAnalyticsParameters.started = false;
      this.currentVideoStatus.videoAnalyticsParameters.restarted = true;
      this.consecutiveVideosLoaded++

      this.debugLog('handleVideoSourceChange' +
        `\n --old video source = ${this.videoUrl}` +
        `\n --new video source = ${this.getVideoSource(this.videoElement)}` +
        `\n --videos loaded count = ${this.consecutiveVideosLoaded}`, [LogType.QA, LogType.CXO]);

      this.videoUrl = this.getVideoSource(this.videoElement);
      this.moveCxo();

      if(isNil(this.overlayUtilities.groupConfig) || !this.overlayUtilities.groupConfig.persistentInserts){
        this.clearRemainingInserts();
        this.overlayUtilities.resetCarouselData();
      }

      this.analyticsEventDispatcher.sendVideoEvent(AnalyticsEventType.VIDEO_SRC_CHANGED, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.videoElement.currentTime, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height});

      if(!isNil(this.trackElement) && this.videoElement.contains(this.trackElement)){
        this.videoElement.removeChild(this.trackElement)
      }
      URL.revokeObjectURL(this.trackUrl)
      this.shouldRequestMoments = this.overlayUtilities.isManualBidding ? false : true;
      this.activeLogicalVideoId = null;
      this.activeMediaId = null;
      this.resetVideoStatus();
      this.checkIfMomentsNeeded();
    }
  }

  checkTrackIntegrity(){
    if(!isNil(this.trackElement) && !isNil(this.trackElement.track)){
      if(this.trackElement.track.mode === 'disabled'){
        this.trackElement.track.mode = 'hidden';
        this.debugLog('checkTrackIntegrity --Track mode set from disabled -> hidden', LogType.CXO);
      }
    }
  }

  checkIfMomentsNeeded(){
    if(!this.initialMomentsRequested){
      this.determineDimensions();
      if(this.overlayUtilities.isAndroidWebView){
        this.debugLog('Device has been detected as an unsupported Android Web View player. Will send out event log and shutdown CX-Overlay.', [LogType.QA, LogType.CXO]);
        
        this.analyticsEventDispatcher.sendOverlayEvent(AnalyticsEventType.OVERLAY_ANDROID_WEB_VIEW, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue);

        this.shouldRequestMoments = false;
        this.currentVideoStatus.timerBasedBidding = true;
        this.initialMomentsRequested = true;
        this.destroyCXO();
      }else if(this.overlayUtilities.isDomainBlockedForInApp && this.overlayUtilities.isInAppBrowser){
        const allowBlockedDomainsParam = this.logManager.getDebugParamValue(DebugURLParams.ALLOW_BLOCKED_DOMAINS);
        const allowBlockedDomains: boolean = Boolean(allowBlockedDomainsParam !== null && allowBlockedDomainsParam === 'true');
        if(!allowBlockedDomains){
          this.debugLog('In-App browser detected on Factinate.com domain. Will send out event log and shutdown CX-Overlay.', [LogType.QA, LogType.CXO, LogType.OVERLAYLOGS]);
          
          this.analyticsEventDispatcher.sendOverlayEvent(AnalyticsEventType.OVERLAY_IN_APP_BROWSER_SHUTDOWN, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue);
  
          this.shouldRequestMoments = false;
          this.currentVideoStatus.timerBasedBidding = true;
          this.initialMomentsRequested = true;
          this.destroyCXO();
        }else{
          this.debugLog(`DEBUGallowBlockedDomains is set to 'true'. Will continue to allow cx-overlay to run on this domain.`, [LogType.OVERLAYLOGS, LogType.QA, LogType.CXO]);
        }
      }else if(this.playerMode === PlayerMode.DESKTOP_FLOATING || this.playerMode === PlayerMode.MOBILE_FLOATING){
        this.debugLog('Video has initialized in "floating" mode. Will use set video status to "streaming", isFloatingExclusive = true, and use automatic bidding for video.', [LogType.QA, LogType.CXO]);
        this.currentVideoStatus.isFloatingExclusive = true;
        this.currentVideoStatus.timerBasedBidding = true;
        this.initialMomentsRequested = true;
      }
    }
    if(!this.currentVideoStatus.isStreaming && this.playerConfig.isLiveStreamPlayer?.toLowerCase() === "true"){
      this.debugLog(`Player configuration ${this.playerConfig.player} contains property: isLiveStreamPlayer=${this.playerConfig.isLiveStreamPlayer}. Video has been identified as STREAMING.`, [LogType.CXO, LogType.QA]);
      this.currentVideoStatus.isStreaming = true;
      this.currentVideoStatus.timerBasedBidding = true;
      this.setNextAutomaticBidTime();
    }
    else if(!this.currentVideoStatus.timerBasedBidding && this.videoElement.duration === Infinity){
      this.debugLog('Video duration is equal to "infinity". Will use set video status to "streaming" and use automatic bidding for video.', [LogType.QA, LogType.CXO]);
      this.currentVideoStatus.isStreaming = true;
      this.currentVideoStatus.timerBasedBidding = true;
      this.initialMomentsRequested = true;
    }
    if(this.shouldRequestMoments && !this.currentVideoStatus.timerBasedBidding){
      if(this.playerType === 'AIRTV'){
        if((this.videoElement.readyState >= 2 && this.videoElement.currentTime > 1)){
          if(this.videoElement.currentTime < (this.videoElement.duration-10)){
            if(this.airTVEventsEstablished){
              if(!this.airTVisAdvertisement){
                this.debugLog('AirTV Video is actively playing, not an advertisement, and bid needed. --initializing moments request', [LogType.CXO, LogType.QA]);
                this.timers.updateCXOTimer.execute();
                this.requestMomentsTrack();
              }else{
                this.debugLog('AirTV Video is currently in advertisement break. --delaying moments request', [LogType.CXO, LogType.QA]);
              }
            }else{
              let domainName = window.location.hostname;
              if(window.self !== window.top){
                try{
                  const referrer: string = document.referrer || window.top.location.href;
                  domainName = (new URL(referrer)).hostname;
                }catch(err){
                  this.debugLog(['unable to determine top AirTV domain:', err], [LogType.CXO, LogType.QA]);
                }
              }
              let domainSplit = domainName.split('.');
              domainName = (domainSplit.length>=2)?domainSplit[domainSplit.length-2]+'.'+domainSplit[domainSplit.length-1]:domainSplit[0];
              this.debugLog('AirTV determined domain: ' + domainName, [LogType.CXO, LogType.QA]);
              if(this.getVideoSource(this.videoElement)?.toLowerCase().includes(domainName.toLowerCase())){
                this.debugLog('Video is actively playing and moments needed. --initializing moments request', [LogType.CXO, LogType.QA]);
                this.timers.updateCXOTimer.execute();
                this.requestMomentsTrack();
              }else{
                this.debugLog(`Video source is not from parent domain ( ${domainName} ). --delaying moments request`, [LogType.CXO, LogType.QA]);
              }
            }
          }else{
            this.debugLog(`Video current time is too close to video end. At ${this.videoElement.currentTime} current time with ${this.videoElement.duration} total duration on video. --delaying moments request`, [LogType.CXO, LogType.QA]);
          }
        }else{
          this.debugLog(`AirTV Video not ready for bid - readyState=${this.videoElement.readyState} at time ${this.videoElement.currentTime}. --delaying moments request`, [LogType.CXO, LogType.QA])
          if(!this.videoElement.paused){
            this.timers.checkMomentsNeededTimer.reset(1000);
          }
        }
      }else{
        if((this.videoElement.readyState >= 2 && (!this.videoElement.paused || this.videoElement.currentTime > .1))){
          if(this.videoElement.currentTime < (this.videoElement.duration-10)){
            this.debugLog('Video is actively playing and bid needed. --initializing moments request', [LogType.CXO, LogType.QA])
            this.timers.updateCXOTimer.execute();
            this.requestMomentsTrack();
          }else{
            this.debugLog(`Video current time is too close to video end. At ${this.videoElement.currentTime} current time with ${this.videoElement.duration} total duration on video. --delaying moments request`, [LogType.CXO, LogType.QA]);
          }
        }else{
          this.debugLog('Video has not begun playback. --delaying moments request', [LogType.CXO, LogType.QA]);
          if(!this.videoElement.paused){
            this.timers.checkMomentsNeededTimer.reset(1000);
          }else{
            this.timers.updateCXOTimer.reset(1000);
          }
        }
      }
    }else{
      if(this.shouldRequestMoments && this.currentVideoStatus.timerBasedBidding){
        if(this.currentVideoStatus.isFloatingExclusive){
          this.debugLog('Floating player detected as primary player mode.', [LogType.CXO, LogType.QA]);
        }else if(this.overlayUtilities.groupConfig.persistentInserts){
          this.debugLog(`Zone configurations has 'persistentInserts' set to 'true'`, [LogType.CXO, LogType.QA]);
        }
        this.debugLog('Timer based bidding has been toggled on. Will not analyze video for moments.', [LogType.CXO, LogType.QA]);
        this.setNextAutomaticBidTime();
        this.shouldRequestMoments = false;
      }else if(!this.shouldRequestMoments){
        this.debugLog(`Video shouldRequestMoments=${this.shouldRequestMoments}. --will not initiate new moments request`, [LogType.CXO, LogType.QA]);
        this.debugLog(`Time remaining on automatic bid timer: ${this.overlayUtilities.automaticBidTimer.timeRemainingInSeconds} seconds.`, [LogType.CXO, LogType.QA]);
        if(this.overlayUtilities.automaticBidTimer.timeRemainingInSeconds === 0 && this.cxoActive && this.currentVideoStatus.timerBasedBidding){
          this.setNextAutomaticBidTime();
          this.debugLog(`Automatic bid timer has failed during lost video. Restarting automatic bid timer with ${this.overlayUtilities.automaticBidTimer.timeRemainingInSeconds} seconds.`, [LogType.CXO, LogType.QA]);
        }
      }
    }
  }

  requestMomentsTrack() {
    this.shouldRequestMoments = false;
    this.timers.delayFetchMomentsTimer.reset(500);
  }

  fetchMoments(){
    if(!this.overlayUtilities.groupConfig.analyzeContent){
      this.debugLog(`fetchMoments - Zone configuration has 'analyzeContent' flag set to ${this.overlayUtilities.groupConfig.analyzeContent}. Switching to timer based bidding. Will not fetch moments.`, [LogType.QA, LogType.CXO]);
      this.currentVideoStatus.timerBasedBidding = true;
      this.setNextAutomaticBidTime();
    }else if(this.videoUrlSourceMapping?.toLowerCase?.().indexOf('blob') === 0){
      this.debugLog(`fetchMoments - Video source is of type 'blob'. Switching to timer based bidding. Will not fetch moments.`, [LogType.QA, LogType.CXO]);
      this.currentVideoStatus.timerBasedBidding = true;
      this.setNextAutomaticBidTime();
    }
    try{
      if(!this.isVideoAdvertisement && !this.nobid && !this.overlayUtilities.groupConfig?.persistentInserts && !this.currentVideoStatus?.timerBasedBidding){
        this.debugLog('CX Fetching Moments', [LogType.CXO, LogType.QA]);

        let bidGroup: string = this.groupId;
        const overrideConfigsGroupIdParam: string = this.logManager.getDebugParamValue(DebugURLParams.OVERRIDE_CONFIGS_GROUP_ID);
        if(overrideConfigsGroupIdParam !== null){
          bidGroup = (overrideConfigsGroupIdParam == null || overrideConfigsGroupIdParam === '' || overrideConfigsGroupIdParam === 'true')?'internal':overrideConfigsGroupIdParam;
          this.debugLog(`Using group-id '${bidGroup}' for fetch moments request.`, [LogType.QA, LogType.CXO]);
        }

        const fetchMoments:FetchMomentsData = {
          groupId: bidGroup,
          videoUrl: this.videoUrlSourceMapping,
          duration: this.videoElement.duration
        }
        this.analyticsEventDispatcher.sendFetchMomentsEvent(AnalyticsEventType.OVERLAY_FETCH_MOMENTS, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, fetchMoments);


        getTrackCues(bidGroup, this.videoUrlSourceMapping, this.videoElement.duration).then((obj: any) => {
          if(!isNil(obj)){

            if(!this.isVideoAdvertisement && !this.nobid){
              this.initialMomentsRequested = true;
              this.debugLog([`Moments Data for group '${bidGroup}': `, obj], [LogType.QA, LogType.CXO]);
              this.activeMediaId = obj.mediaId ?? null;
              this.activeLogicalVideoId = obj.logicalVideoId ?? null;
              this.trackData = isNil(obj?.cues) ? null : new Blob([obj.cues], { type: 'text/vtt' })
              this.timers.updateCXOTimer.execute()
              this.addCues()
              this.timers.checkTrackIntegrityTimer.reset(1000);
            }else{
              if(this.nobid){
                this.debugLog('nobid attribute found on cx-overlay. Will not attach moments cue track.', [LogType.QA, LogType.CXO]);
              }else{
                this.debugLog('Video identified as advertisement. Will not attach moments cue track.', [LogType.QA, LogType.CXO]);
              }
              this.shouldRequestMoments = true;
            }
          }else{
            this.debugLog(`getTrackCues response is 'null'. Is current URL part of blockedURLs for zone? ${this.overlayUtilities.isBlockedURL}`, [LogType.QA, LogType.CXO]);
          }
        })
      }else{
        if(this.nobid){
          this.debugLog('nobid attribute found on cx-overlay. Will not request moments cue track.', [LogType.QA, LogType.CXO]);
        }else{
          this.debugLog('Video identified as advertisement. Will not request moments cue track.', [LogType.QA, LogType.CXO]);
        }
        this.shouldRequestMoments = true;
      }
    } catch (e) {
      this.debugLog(['Failed to load video moments:', e], LogType.ERROR);
    }
  }

  addCues() {
    if (!isNil(this.trackData)) {
      if (this.videoElement.contains(this.trackElement)) {
        this.debugLog('addCues --removingTrackEvent')
        try{
          URL.revokeObjectURL(this.trackUrl)
          this.videoElement.removeChild(this.trackElement)
        }catch(err){
          this.debugLog(['addCues --removingTrackEvent | Error on remove track element.', err], [LogType.QA, LogType.CXO])
        }
      }
      this.debugLog('addCues --addingNewTrack')
      
      try{
        this.debugLog('addCues --trackUrl')
        this.trackUrl = URL.createObjectURL(this.trackData)
        this.debugLog('addCues --createElement')
        this.trackElement = document.createElement('track')
        this.debugLog('addCues --src=trackUrl')
        this.trackElement.src = this.trackUrl
        this.debugLog('addCues --label=label')
        this.trackElement.label = this.label
        this.debugLog('addCues --kind=kind')
        this.trackElement.kind = this.kind
        this.debugLog('addCues --id=cx-track-data')
        this.trackElement.id = 'cx-track-data'
        this.debugLog('addCues --setAttribute')
        this.trackElement.setAttribute('default', '')
        this.debugLog('addCues --onCueChange')
        this.trackElement.oncuechange = this.onCueChange
        this.debugLog(['addCues --insertBefore - ', this.videoElement, this.videoElement?.firstChild])
        if(typeof this.videoElement?.firstChild !== 'undefined'){
          this.videoElement.insertBefore(this.trackElement, this.videoElement.firstChild)
        }else{
          this.videoElement.appendChild(this.trackElement)
        }
      }catch(err){
        this.debugLog(['addCues --addingNewTrack | Error on add new track element.', err], [LogType.QA, LogType.CXO])
      }

      this.debugLog([`addCues --trackDataAdded --trackUrl = ${this.trackUrl}`], [LogType.CXO, LogType.QA]);

      const watchTrackCues = ()=>{
        if(this.trackElement.track.cues == null){
          setTimeout(()=>{watchTrackCues()}, 100);
        }else{
          let bidGroup: string = this.groupId;
          const overrideConfigsGroupIdParam: string = this.logManager.getDebugParamValue(DebugURLParams.OVERRIDE_CONFIGS_GROUP_ID);
          if(overrideConfigsGroupIdParam !== null){
            bidGroup = (overrideConfigsGroupIdParam == null || overrideConfigsGroupIdParam === '' || overrideConfigsGroupIdParam === 'true')?'internal':overrideConfigsGroupIdParam;
            this.debugLog(`Using group-id '${bidGroup}' for watch track cues.`, [LogType.QA, LogType.CXO]);
          }

          let bidLog = `Expected bid times for group '${bidGroup}': `;
          for(let x in this.trackElement.track.cues){
            if(this.trackElement.track.cues[x]['startTime'] != null){
              bidLog+= `\n  Bid ${(parseInt(x)+1)} starting at ${this.trackElement.track.cues[x]['startTime']} seconds.`
            }
          }
          this.debugLog([bidLog], [LogType.CXO, LogType.QA]);
        }
      }
      watchTrackCues();
    }
  }

  determineDimensions(): boolean {
    let dimensionsChange = false;
    if(!this.lockDimensions){
      const videoRect: DOMRect  = this.videoElement.getBoundingClientRect();
    
      if(this.watchedVideoSize.width !== Math.round(videoRect.width) ||
        this.watchedVideoSize.height !== Math.round(videoRect.height) ||
        this.watchedVideoSize.left !== Math.round(videoRect.left) ||
        this.watchedVideoSize.top !== Math.round(videoRect.top)){
          this.videoDimensionsStable = false;
          this.watchedVideoSize.width = Math.round(videoRect.width);
          this.watchedVideoSize.height = Math.round(videoRect.height);
          this.watchedVideoSize.left = Math.round(videoRect.left);
          this.watchedVideoSize.top = Math.round(videoRect.top);
      }
  
      this.overlayUtilities.currentDimensions.transform = (!isNil(this.videoElement.getAttribute('style')) && this.videoElement.getAttribute('style').includes('transform-origin') && this.videoElement.style.getPropertyValue('transform-origin').split(' ').length>=2)?this.videoElement.style.getPropertyValue('transform-origin').replace(/%/g, '').split(' '):['100','100'];
      this.overlayUtilities.currentDimensions.elementScale = this.currentVideoElementScale;
  
      const containerRect: DOMRect = this.containerElement.getBoundingClientRect();
      const overlayRect: DOMRect = this.overlayTimerElement.getBoundingClientRect();
      if(containerRect.height > 0 && overlayRect.height > 0){
        const heightDifference: number = this.overlayUtilities.percentageDifference(containerRect.height, overlayRect.height);
        if(heightDifference > 5 && this.overlayTimerElement.style.getPropertyValue('position') !== CSSPosition.RELATIVE){
          this.overlayTimerElement.style.setProperty('position', CSSPosition.RELATIVE);
          this.debugLog([`determineDimensions: Container/Overlay height difference of ${this.overlayUtilities.percentageDifference(containerRect.height, overlayRect.height)}% > 5%. Changing #timer position to relative.`], LogType.CXO);
        }
      }
  
      const overrideTimerPosition: string = this.logManager.getDebugParamValue(DebugURLParams.OVERRIDE_TIMER_POSITION);
      if(overrideTimerPosition !== null){
        this.overlayTimerElement.style.setProperty('position', overrideTimerPosition.toLowerCase() as CSSPosition);
        this.debugLog(`Using override timer position '${overrideTimerPosition.toLowerCase() as CSSPosition}' for timer element CSS positioning.`, [LogType.QA, LogType.CXO]);
      }
  
      /*
      this.debugLog(`determineDimensions:\n 
      Video dimensions - width = ${videoRect.width}, height = ${videoRect.height}, left = ${videoRect.left}, top = ${videoRect.top}
      Overlay dimensions - width = ${overlayRect.width}, height = ${overlayRect.height}, left = ${overlayRect.left}, top = ${overlayRect.top}`, LogType.IMPORTANT);
      */
  
      const dimensions: ElementDimensions = {
        height: Math.round(videoRect.height),
        width: Math.round(videoRect.width),
        previousElementWidth: this.overlayUtilities.currentDimensions.previousElementWidth,
        previousHeight: this.overlayUtilities.currentDimensions.previousHeight,
        previousWidth: this.overlayUtilities.currentDimensions.previousWidth,
        x: videoRect.x,
        y: videoRect.y,
        top: videoRect.top,
        right: videoRect.right,
        bottom: videoRect.bottom,
        left: videoRect.left,
        transform: this.overlayUtilities.currentDimensions.transform,
        winHeight: (document.documentElement.clientHeight < window.innerHeight && document.documentElement.clientHeight+30 > window.innerHeight)?document.documentElement.clientHeight:window.innerHeight,
        winWidth: document.documentElement.clientWidth,
        scale: this.overlayUtilities.currentDimensions.scale,
        elementScale: this.overlayUtilities.currentDimensions.elementScale,
        isFloating: this.overlayUtilities.currentDimensions.isFloating,
        isFullscreen: this.overlayUtilities.currentDimensions.isFullscreen,
        insertPosition: this.overlayUtilities.currentDimensions.insertPosition,
        elementDimensionsStable: this.overlayUtilities.currentDimensions.elementDimensionsStable
      }
  
      if(!isNil(this.videoElement) && this.videoElement.hasAttribute('insertvideoscale') && Number.isNaN(parseFloat(this.videoElement.getAttribute('insertvideoscale')))){
        this.videoElement.removeAttribute('insertvideoscale');
      }
  
      const videoScale: number = dimensions.elementScale;
      //this.debugLog('determineDimensions: insertvideoscale from squeezeback at determineDimensions: ' + videoScale, LogType.IMPORTANT);
  
      if(videoRect.width > 0 && videoRect.width === dimensions.previousElementWidth){
        //percentageDifference was used here - this lead to a larger difference in container size vs video size as the resolution increased. This may or may not have been intentional, but to fix smaller (mobile) sizes it has been changed to exact pixel differences.
        //const widthDifference: number = this.overlayUtilities.percentageDifference(videoRect.width/videoScale, containerRect.width);
        const widthDifference: number = Math.abs(videoRect.width/videoScale-containerRect.width);
        if(widthDifference > .5){
          dimensions.scale = (dimensions.scale !== 1)?1:((videoRect.width/videoScale)/containerRect.width);
          if(dimensions.scale === 0 || dimensions.scale === Infinity){
            dimensions.scale = 1;
          }
          //this.debugLog(`determineDimensions - Overlay width and video width do not match: ${containerRect.width} != ${(videoRect.width/videoScale)} -> calculated scale = ${dimensions.scale}`, LogType.IMPORTANT);
        }
      }else{
        this.timers.updateCXOTimer.reset(50);
      }
  
      dimensions.previousElementWidth = videoRect.width;
      
      //this.debugLog(`determineDimensions: dimensions.scale ${dimensions.scale} with comparison calculation value ${Math.abs(overlayRect.width/dimensions.scale - videoRect.width/videoScale)}` , LogType.IMPORTANT);
      
      dimensions.height = Math.round((videoRect.height/videoScale) * dimensions.scale)
      dimensions.width = Math.round((videoRect.width/videoScale) * dimensions.scale);
      dimensions.left = parseFloat((videoRect.left+parseFloat(dimensions.transform[0])*.01*(videoRect.width - videoRect.width/videoScale)).toFixed(3))
      dimensions.top = parseFloat((videoRect.top+parseFloat(dimensions.transform[1])*.01*(videoRect.height - videoRect.height/videoScale)).toFixed(3))
      dimensions.right = parseFloat((dimensions.winWidth - videoRect.right+(100-parseFloat(dimensions.transform[0]))*.01*(videoRect.width - videoRect.width/videoScale)).toFixed(3))
      dimensions.bottom = parseFloat((dimensions.winHeight - videoRect.bottom+(100-parseFloat(dimensions.transform[1]))*.01*(videoRect.height - videoRect.height/videoScale)).toFixed(3))
      //dimensions.top = Math.round(rect.top - (rect.height/videoScale-rect.height));
      //dimensions.left = Math.round(rect.left - (rect.width/videoScale-rect.width));
      
      //this.debugLog(`determineDimensions: (${videoRect.width}/${videoScale})*${dimensions.scale} -> Dimensions after scaling calculation: ${dimensions.width} -> calculated scale?: ${dimensions.scale}}`, LogType.IMPORTANT);
  
      const oldPlayerMode: string = this.playerMode;
      const wasFullscreen: boolean = this.overlayUtilities.currentDimensions.isFullscreen;
      const oldFloatingPosition: FloatingPlayerPosition = this.floatingPosition;
      this.determinePlayerMode(dimensions);
  
      //this.debugLog(`determineDimensions -- old playerMode: ${oldPlayerMode} -- new playerMode: ${this.playerMode}`, LogType.IMPORTANT);
      
      dimensions.isFloating = this.overlayUtilities.currentDimensions.isFloating;
      dimensions.isFullscreen = this.overlayUtilities.currentDimensions.isFullscreen;
  
      const floatingPositionChange:boolean = (oldFloatingPosition !== this.floatingPosition)?true:false;
      const fullscreenChange: boolean = (wasFullscreen !== dimensions.isFullscreen)?true:false;
      const playerModeChange: boolean = (oldPlayerMode !== this.playerMode)?true:false;
  
      if(fullscreenChange || floatingPositionChange || playerModeChange || this.overlayUtilities.currentDimensions.height !== dimensions.height || this.overlayUtilities.currentDimensions.width !== dimensions.width || this.overlayUtilities.currentDimensions.x !== dimensions.x || this.overlayUtilities.currentDimensions.y !== dimensions.y || this.overlayUtilities.currentDimensions.bottom !== dimensions.bottom || this.overlayUtilities.currentDimensions.top !== dimensions.top || this.overlayUtilities.currentDimensions.right !== dimensions.right || this.overlayUtilities.currentDimensions.left !== dimensions.left){
  
        this.debugLog(`Video player (${dimensions.width}x${dimensions.height}) position in frame - left: ${dimensions.left}px • right: ${dimensions.right}px • top: ${dimensions.top}px • bottom: ${dimensions.bottom}px`, [LogType.CXO]);
        if(!this.videoPlayerLost && !isNil(this.activeResource)){
          this.timers.remakeInsertTimer.resetIfInactive(10, ()=>{this.remakeInsertIfNeeded(oldPlayerMode, wasFullscreen, oldFloatingPosition)});
        }
        if(this.overlayUtilities.currentDimensions.isFloating){
          this.floatingJumpCount = 0;
        }
        dimensionsChange = true;
      }else if(this.overlayUtilities.currentDimensions.winHeight !== dimensions.winHeight || this.overlayUtilities.currentDimensions.winWidth != dimensions.winWidth){
        dimensionsChange = true;
      }
  
      if(playerModeChange){
        if((this.videoPlayerLost || this.videoElement === null)){
          //this.debugLog('Hide active insert while video player is lost during playerMode change.', LogType.IMPORTANT);
          //this.overlayElement.style.setProperty('opacity', '0');
          if(this.videoPlayerLost){
            this.timers.checkLostVideoPlayerTimer.execute();
          }else{
            this.timers.reinitializeVideoElementTimer.execute();
          }
        }else{
          this.timers.updateCXOTimer.resetInterval(100, 5);
        }
      }
  
      this.overlayUtilities.currentDimensions = dimensions  
    }

    //this.debugLog([`determineDimensions (${dimensionsChange}): `, this.overlayUtilities.currentDimensions], LogType.CXO);
    
    return dimensionsChange;
  }

  //determine if change insert types or positioning is necessary
  remakeInsertIfNeeded(oldPlayerMode:string, wasFullscreen:boolean, oldFloatingPosition:FloatingPlayerPosition, recheck: boolean = false) {
    
    const floatingPositionChange:boolean = (oldFloatingPosition !== this.floatingPosition)?true:false;
    const fullscreenChange: boolean = (wasFullscreen !== this.overlayUtilities.currentDimensions.isFullscreen)?true:false;
    const playerModeChange: boolean = (oldPlayerMode !== this.playerMode)?true:false;

    this.debugLog(`remakeInsertIfNeeded -
    oldPlayerMode = ${oldPlayerMode} vs currentPlayerMode = ${this.playerMode}
    playerModeChange = ${playerModeChange}
    wasFullscreen = ${wasFullscreen} vs isFullscreen = ${this.overlayUtilities.currentDimensions.isFullscreen}
    fullscreenChange = ${fullscreenChange}
    oldFloadingPosition = ${oldFloatingPosition} vs floatingPosition = ${this.floatingPosition}
    floatingPositionChange = ${floatingPositionChange}
    currentWidth = ${this.overlayUtilities.currentDimensions.width}
    recheck = ${recheck}`, [LogType.CXO]);

    if (!isNil(this.activeResourceData) && !isNil(this.activeResource)){

      let currentType: InsertType = this.translateDisplayToNative(this.activeResource.tagName.toLowerCase() as InsertType);
      
      if(this.overlayUtilities.currentDimensions.width < 10 || this.overlayUtilities.currentDimensions.height < 10){
        this.debugLog('remakeInsertIfNeeded -- Video element transitioning ( < 10px width/height ). Delaying type change.', [LogType.CXO, LogType.QA])
        if(this.cxWait){
          this.debugLog('remakeInsertIfNeeded -- cx-wait turned on. Will not continue trying to remake Insert.', [LogType.CXO, LogType.QA])
        }else{
          this.timers.remakeInsertTimer.resetIfInactive(100, ()=>{this.remakeInsertIfNeeded(oldPlayerMode, wasFullscreen, oldFloatingPosition, recheck)});
        }
      }else{
        const insertTypeOverrideParam = this.logManager.getDebugParamValue(DebugURLParams.INSERT_TYPE_OVERRIDE);
        if(this.activeResourceData.impressionType !== ImpressionType.DISPLAY){
          this.detectCXWaitChanges();
          if(!this.cxWait){
            this.debugLog(`remakeInsertIfNeeded -- optimalInsertPosition: ${this.determineOptimalInsertPosition()} - currentInsertPosition: ${this.activeResource.getAttribute('insertposition')}`, [LogType.CXO]);
            
            const activeResourceWidth: number = parseInt(this.activeResource.getAttribute('creationwidth')) || 0;
            const widthChange: number = this.overlayUtilities.percentageDifference(activeResourceWidth, this.overlayUtilities.currentDimensions.width);

            if(playerModeChange || fullscreenChange || (this.overlayUtilities.currentDimensions.isFloating && floatingPositionChange) || this.determineOptimalInsertPosition() !== this.activeResource.getAttribute('insertposition') || (currentType.includes('wing') && (parseInt(this.activeResource.getAttribute('allowedwidth')) > ((this.activeResource.getAttribute('insertposition').includes('r'))?this.overlayUtilities.currentDimensions.right:this.overlayUtilities.currentDimensions.left)) || parseInt(this.activeResource.getAttribute('creationheight'))*1.5 < this.overlayUtilities.currentDimensions.height) || widthChange > 80){
              //this.debugLog('Percentage difference on width change: ' + widthChange, LogType.IMPORTANT);
              const availableTypes = (insertTypeOverrideParam !== null)?[currentType]:this.validateInsertTypeAllowedList(this.activeResourceData, this.overlayUtilities.determineInsertTypeOptions())
              const typeStillAvailable = availableTypes.filter(x => x === currentType);
              let shouldRemakeInsert: boolean = false;
              if(this.isFullscreenVideoNode){
                this.debugLog(`remakeInsertIfNeeded - Insert should NOT be re-created because a mobile video node is currently fullscreen.`, [LogType.QA, LogType.CXO]);
              }else if(typeStillAvailable.length === 0){
                shouldRemakeInsert = true;
                this.debugLog(`remakeInsertIfNeeded - Insert should be re-created because current insert type is no longer available.`, [LogType.QA, LogType.CXO]);
              }else if(widthChange > 80){
                shouldRemakeInsert = true;
                this.debugLog(`remakeInsertIfNeeded - Insert should be re-created because video size at insert creation has changed significantly (${this.activeResource.getAttribute('creationwidth')}px width at creation vs. ${this.overlayUtilities.currentDimensions.width}px width currently).`, [LogType.QA, LogType.CXO]);
              }else if(currentType.includes('bleedover') && this.overlayUtilities.currentDimensions.isFullscreen){
                shouldRemakeInsert = true;
                this.debugLog(`remakeInsertIfNeeded - Insert should be re-created because insert is a bleedover type and player is now fullscreen.`, [LogType.QA, LogType.CXO]);
              }else if(currentType.includes('bleedover') && this.determineOptimalInsertPosition() !== this.activeResource.getAttribute('insertposition')){
                shouldRemakeInsert = true;
                this.debugLog(`remakeInsertIfNeeded - Insert should be re-created because insert is a bleedover type and insert position needs changing.`, [LogType.QA, LogType.CXO]);
              }else if((currentType.includes('flap') || currentType.includes('wing') ) && widthChange > 25){
                shouldRemakeInsert = true;
                this.debugLog(`remakeInsertIfNeeded - Insert should be re-created because insert is a bleedover type and player width has changed significantly.`, [LogType.QA, LogType.CXO]);
              }else if(currentType.includes('wing') && ((parseInt(this.activeResource.getAttribute('allowedwidth')) > ((this.activeResource.getAttribute('insertposition').includes('r'))?this.overlayUtilities.currentDimensions.right:this.overlayUtilities.currentDimensions.left)) || parseInt(this.activeResource.getAttribute('creationheight'))*1.5 < this.overlayUtilities.currentDimensions.height)){
                shouldRemakeInsert = true;
                this.debugLog(`remakeInsertIfNeeded - Insert should be re-created because wing insert no longer fits in the allowed space. ${((this.activeResource.getAttribute('insertposition').includes('r'))?this.overlayUtilities.currentDimensions.right:this.overlayUtilities.currentDimensions.left)} vs ${parseInt(this.activeResource.getAttribute('allowedwidth'))}`, [LogType.QA, LogType.CXO]);
              }
              if(shouldRemakeInsert){
                if(!recheck){
                  this.timers.remakeInsertTimer.resetIfInactive(500, ()=>{this.remakeInsertIfNeeded(oldPlayerMode, wasFullscreen, oldFloatingPosition, true)});
                  this.activeResource.style.setProperty('opacity', '0');
                }else{
                  this.debugLog('remakeInsertIfNeeded --recheck ' + this.activeResource.style.getPropertyValue('opacity'), [LogType.CXO])
                  if(this.activeResource.style.getPropertyValue('opacity') === '0'){
                    //this.activeResource.style.setProperty('opacity', '1');
                    this.debugLog('remakeInsertIfNeeded --Insert re-create required.', [LogType.CXO, LogType.QA])
                    this.isInsertReinitializing = true;
                    this.clearCarouselInsert();
                    this.overlayUtilities.resetCarouselData();
                    this.clearActiveInsert();
                    //this.selectInsertTypeFromOptions(this.activeResourceData);
                    this.timers.createNewInsertTimer.reset(0, ()=>{this.createNewInsert(this.activeResourceData)});
                  }
                }
              }else{
                this.debugLog(`remakeInsertIfNeeded - Insert does not need to be recreated.`, [LogType.CXO]);
                if(recheck){
                  this.activeResource.style.setProperty('opacity', '1');
                }
              }
            }else if(this.activeResource.style.getPropertyValue('opacity') === '0'){
              this.activeResource.style.setProperty('opacity', '1');
            }
          }
        }else{
          const availableTypes = (insertTypeOverrideParam !== null)?[currentType]:this.validateInsertTypeAllowedList(this.activeResourceData, this.overlayUtilities.determineInsertTypeOptions());
          
          //Allow overlay carousel inserts to remain during player mode change
          if([PlayerMode.DESKTOP_FLOATING, PlayerMode.MOBILE_FLOATING].includes(this.playerMode)){
            availableTypes.push(this.currentInserts.nativeOverlayFullwidth, this.currentInserts.nativeOverlayCorner, this.currentInserts.nativeOverlayIcon);
          }
          const typeStillAvailable = availableTypes.filter(x => x === currentType);

          if(typeStillAvailable.length === 0){
            this.debugLog([`mode: ${this.playerMode}, availableTypes = ${JSON.stringify(availableTypes)}, currentType=${currentType}`, 'No insert types still available. Clear carousel inserts.'], [LogType.CXO]);
            this.clearCarouselInsert();
            this.overlayUtilities.resetCarouselData();
          }
          if((this.overlayUtilities.currentDimensions.isFullscreen && currentType.includes('bleedover')) || (!this.doesWingInsertFit && currentType.includes('wing'))){
            this.debugLog([`Bleedover insert type no longer fits. Removing active insert.`], [LogType.CXO, LogType.QA]);
            this.clearRemainingInserts();
          }else if(!recheck){
            this.timers.remakeInsertTimer.resetIfInactive(500, ()=>{this.remakeInsertIfNeeded(oldPlayerMode, wasFullscreen, oldFloatingPosition, true)});
          }
        }
      }
    }else{
      this.debugLog([`remakeInsertIfNeeded - activeResource not available - NOT changing insert type`], [LogType.CXO, LogType.HIGHLIGHT])
    }
  }

  translateDisplayToNative(type:InsertType){
    let returnType: InsertType = type;
    switch(type){
      case this.currentInserts.displayOverlayFullwidth:
        returnType = this.currentInserts.nativeOverlayFullwidth;
        break;
      case this.currentInserts.displayFlap:
        returnType = this.currentInserts.nativeFlap;
        break;
      case this.currentInserts.displayWing:
        returnType = this.currentInserts.nativeWing;
        break;
      case this.currentInserts.displayOverlayCorner:
        returnType = this.currentInserts.nativeOverlayCorner;
        break;
      case this.currentInserts.displaySqueeze:
        returnType = this.currentInserts.nativeSqueeze;
        break;
    }
    return returnType;
  }

  adjustMargin(){
    if(!this.lockMargin && this.timers.windowScrollTimer.timeRemainingInSeconds === 0){
      const containerRect: DOMRect = this.containerElement.getBoundingClientRect()
      const computedMargin: CSSStyleDeclaration = window.getComputedStyle(this.containerElement);
      
      const transform: string[] = this.overlayUtilities.currentDimensions.transform;
      const videoScale: number = this.overlayUtilities.currentDimensions.elementScale;
      
      let marginLeft: number = parseInt(computedMargin.getPropertyValue('margin-left'));
      let marginTop: number = parseInt(computedMargin.getPropertyValue('margin-top'));
      const vidTop: number = this.overlayUtilities.currentDimensions.top;
      const vidLeft: number = this.overlayUtilities.currentDimensions.left;
      
      this.debugLog(`Adjust margin: ${marginLeft}px ${marginTop}px - ${transform} - ${videoScale}`, [LogType.CXO]);
      
      /*
      this.debugLog(`ADJUST MARGIN\n 
        videoScale: ${videoScale}\n
        videoTopScaled: ${vidTop}\n
        containerTop: ${containerRect.top}\n
        top difference: ${vidTop - containerRect.top}\n
        marginTop: ${marginTop}\n
        new margin top: ${vidTop - containerRect.top + marginTop}\n
        videoLeftScaled: ${vidLeft}\n
        containerLeft: ${containerRect.left}\n
        left difference: ${vidLeft-containerRect.left}\n
        marginLeft: ${marginLeft}\n
        new margin left: ${vidLeft - containerRect.left + marginLeft}\n
        transform origin: ${transform}\n
      `, LogType.IMPORTANT);
      /* */
      if((Math.abs(vidTop - (containerRect.top))>1) || (Math.abs(vidLeft - (containerRect.left))>1)){
        
        if(!this.overlayUtilities.currentDimensions.isFloating && !this.isIframePlayer && !(this.overlayUtilities.currentDimensions.isFullscreen && Math.abs(1-containerRect.height/this.overlayUtilities.currentDimensions.winHeight)<.02)){
          marginTop = Math.round(vidTop - containerRect.top + marginTop);
          marginLeft = Math.round(vidLeft - containerRect.left + marginLeft);
        }else{
          marginTop = 0;
          marginLeft = 0;
        }
        
        //this.debugLog(`Calculated margins: ${marginLeft}px,  ${marginTop}px`, LogType.IMPORTANT);
  
        this.containerElement.style.setProperty('margin-top', marginTop+'px');
        this.containerElement.style.setProperty('margin-left', marginLeft+'px');
        //this.debugLog(`Margin adjusted - top=${marginTop}px left=${marginLeft}px`, LogType.IMPORTANT);
        this.timers.updateCXOTimer.reset(100);
      }
    }
  }

  compareFloatingPlayerPosition() {
    const overlayBounds: DOMRect = (!isNil(this.activeResource)) ? this.activeResource.getBoundingClientRect() : this.overlayTimerElement.getBoundingClientRect()
    const floatingOverlayDistance: number = Math.abs(this.overlayUtilities.currentDimensions.left - overlayBounds.left) + Math.abs(this.overlayUtilities.currentDimensions.top- overlayBounds.top);
    const debugCardinalMode = this.cxoverlay.getAttribute('debug-cardinal-mode');
    //this.debugLog(`compareFloatingPlayerPosition - Mode: ${this.cardinalDirectionsMode} - Off distance: ${floatingOverlayDistance} -  Locked Count: ${this.floatingModeLockedCount} - Jump count: ${this.floatingJumpCount}`, [LogType.IMPORTANT])
    const currentMilliseconds: number = (new Date()).getTime();
    const millisecondsElapsed: number = (currentMilliseconds-this.floatingPositionCheckedTime);
    if(!debugCardinalMode && millisecondsElapsed >= 100){
      this.floatingPositionCheckedTime = currentMilliseconds;
      if(floatingOverlayDistance >= 2){
        if(this.floatingModeLockedCount > 0 || this.floatingJumpCount++ < 20){
          this.overlayTimerElement.style.setProperty('opacity', '0');
          this.closestFloatingPosition[this.cardinalDirectionsMode] = floatingOverlayDistance;
          const nextCardinalDirectionsMode: CardinalDirectionsModes = (this.cardinalDirectionsMode === CardinalDirectionsModes.ZERO_INSET)?CardinalDirectionsModes.ADJUSTED_INSET:(this.cardinalDirectionsMode === CardinalDirectionsModes.ADJUSTED_INSET)?CardinalDirectionsModes.AUTO:CardinalDirectionsModes.ZERO_INSET;
          
          if(!this.floatingModeConfirmed){
            this.floatingModeLockedCount = 0;
            this.timers.confirmCardinalDirectionsModeTimer.cancel();
          }
          if(--this.floatingModeLockedCount <= 0){
            this.floatingModeConfirmed = false;
            this.cardinalDirectionsMode = nextCardinalDirectionsMode;
            this.debugLog(`compareFloatingPlayerPosition
            Floating player mode off by ${floatingOverlayDistance} on cardinalDirectionsMode=${this.cardinalDirectionsMode}.
            floatingModeConfirmed=${this.floatingModeConfirmed}
            floatingModeLockedCount=${this.floatingModeLockedCount}
            floatingJumpCount=${this.floatingJumpCount}
            Changing to floating player mode: cardinalDirectionsMode=${nextCardinalDirectionsMode}`, [LogType.CXO]);
          }else{
            this.debugLog(`compareFloatingPlayerPosition
            Floating player mode off by ${floatingOverlayDistance} on cardinalDirectionsMode=${this.cardinalDirectionsMode}. FLOATING MODE LOCKED.
            floatingModeLockedCount=${this.floatingModeLockedCount}
            floatingJumpCount=${this.floatingJumpCount}`, [LogType.CXO]);
          }

          this.timers.updateCXOTimer.reset(100);
        }else{
          let bestCardinalDirectionsMode: CardinalDirectionsModes = null;
          for(let mode in this.closestFloatingPosition){
            if(bestCardinalDirectionsMode === null){
              bestCardinalDirectionsMode = mode as CardinalDirectionsModes;
            }else if(this.closestFloatingPosition[mode] < this.closestFloatingPosition[bestCardinalDirectionsMode]){
              bestCardinalDirectionsMode = mode as CardinalDirectionsModes;
            }
          }
          this.debugLog([`compareFloatingPlayerPosition - Cannot find matching position (CURRENT: ${this.cardinalDirectionsMode}). floatingJumpCount=${this.floatingJumpCount} - floatingModeLockedCount=${this.floatingModeLockedCount}. Closest position with ${bestCardinalDirectionsMode} at a distance of ${this.closestFloatingPosition[bestCardinalDirectionsMode]}`], [LogType.CXO]);
          this.cardinalDirectionsMode = bestCardinalDirectionsMode;
          if(this.overlayTimerElement.style.getPropertyValue('opacity') == '0'){
            this.overlayTimerElement.style.setProperty('opacity', '1');
          }
        } 
      }else if(overlayBounds.width > 0 && overlayBounds.height > 0){
        this.closestFloatingPosition[this.cardinalDirectionsMode] = floatingOverlayDistance;

        if(this.floatingModeLockedCount < 20){
          this.timers.confirmCardinalDirectionsModeTimer.reset(250);
        }
        if(this.overlayTimerElement.style.getPropertyValue('opacity') == '0' && this.floatingModeConfirmed){
          this.overlayTimerElement.style.setProperty('opacity', '1');
        }

        this.floatingModeLockedCount = 20;
        this.debugLog([`compareFloatingPlayerPosition - Matching position found using cardinal directions (${this.cardinalDirectionsMode}) at a distance of ${this.closestFloatingPosition[this.cardinalDirectionsMode]}. floatingJumpCount=${this.floatingJumpCount} - floatingModeLockedCount=${this.floatingModeLockedCount}.`], [LogType.CXO]);
      }
    }else if(debugCardinalMode){
      this.debugLog([`compareFloatingPlayerPosition - debug override - setting with param ${debugCardinalMode}`], [LogType.CXO, LogType.QA]);
      if (debugCardinalMode === 'zero') {
        this.cardinalDirectionsMode = CardinalDirectionsModes.ZERO_INSET
      } else if (debugCardinalMode === 'adjusted') {
        this.cardinalDirectionsMode = CardinalDirectionsModes.ADJUSTED_INSET
      } else {
        this.cardinalDirectionsMode = CardinalDirectionsModes.AUTO
      }
    }else if(!this.floatingModeConfirmed){
      this.debugLog([`compareFloatingPlayerPosition - Cardinal Directions Mode changed too recently (${millisecondsElapsed}ms). Will delay check.`], [LogType.CXO]);
      this.timers.updateCXOTimer.reset(100);
    }
  }

  confirmCardinalDirectionsMode(){
    if(this.overlayUtilities.currentDimensions.isFloating){
      const overlayBounds: DOMRect = (!isNil(this.activeResource)) ? this.activeResource.getBoundingClientRect() : this.overlayTimerElement.getBoundingClientRect()
      const floatingOverlayDistance: number = Math.abs(this.overlayUtilities.currentDimensions.left - overlayBounds.left) + Math.abs(this.overlayUtilities.currentDimensions.top- overlayBounds.top);
      if(floatingOverlayDistance < 2){
        this.floatingModeConfirmed = true;
        if(this.overlayTimerElement.style.getPropertyValue('opacity') == '0'){
          this.overlayTimerElement.style.setProperty('opacity', '1');
        }
        this.debugLog(`cardinalDirectionsMode confirmed: ${this.cardinalDirectionsMode}
        Floating player mode off by ${floatingOverlayDistance} on cardinalDirectionsMode=${this.cardinalDirectionsMode}.
        floatingModeConfirmed=${this.floatingModeConfirmed}
        floatingModeLockedCount=${this.floatingModeLockedCount}
        floatingJumpCount=${this.floatingJumpCount}`, [LogType.CXO]);
      }
    }
  }

  checkForVideoChange(){
    if(!isNil(this.videoElement) && !isNil(this.overlayUtilities.currentDimensions)){
      const vidRect = this.videoElement.getBoundingClientRect();
      //this.debugLog(`watchedVideoSize -  ${this.watchedVideoSize.width}x${this.watchedVideoSize.height}`, LogType.IMPORTANT);
      if(Math.round(vidRect.width) !== (this.watchedVideoSize.width) || Math.round(vidRect.height) !== (this.watchedVideoSize.height) || Math.round(vidRect.left) !== (this.watchedVideoSize.left) || Math.round(vidRect.top) !== (this.watchedVideoSize.top)){
        this.debugLog(`checkForVideoChange - Video size change. ${Math.round(vidRect.width)} !== ${this.watchedVideoSize.width} || ${Math.round(vidRect.height)} !== ${this.watchedVideoSize.height} || ${Math.round(vidRect.left)} !== ${this.watchedVideoSize.left} || ${Math.round(vidRect.top)} !== ${this.watchedVideoSize.top} -> updateCXO().`);
        this.timers.updateCXOTimer.execute();
      }
    }
  }

  checkCurrentVideoStatus(){
    //Watch video timing to fire analytics tracking
    if(!isNil(this.videoElement) && this.videoElement.readyState >= 2){
      this.currentVideoStatus.currentTime = this.videoElement.currentTime;
      if(!this.isVideoAdvertisement){
        if(!this.videoElement.paused && !this.currentVideoStatus.videoEnded){
          
          if(!this.currentVideoStatus.videoAnalyticsParameters.started){
            this.currentVideoStatus.videoAnalyticsParameters.started = true;
            let videoData: {[key:string]: any} = {
              muted: this.videoElement.muted,
              loop: this.videoElement.loop,
              autoplay: this.videoElement.autoplay,
              defaultMuted: this.videoElement.defaultMuted,
              poster: this.videoElement.poster,
              duration: this.videoElement.duration,
              sourceUrl: this.videoElement.src,
              detectedPlayerType: this.playerType
            };
            this.analyticsEventDispatcher.sendVideoEvent(AnalyticsEventType.VIDEO_STARTED, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.videoElement.currentTime, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height}, {"timeReached": "0_SECONDS", "quartileCompleted": VideoEventQuartileNaming.ZERO}, videoData);
            if (!this.timers.watchedVideoDurationTimer.isRunning) {
              this.timers.watchedVideoDurationTimer = new CustomTimeout(() => {this.debugLog('watchedVideoDurationTimer Completed.')}, 8640000000, 'Watch Video Content Duration Timer', this.logManager, LogType.QA);
            }
          }

          this.logVideoTimeElapsed();
          this.logVideoQuartileElapsed();
        }
      }else{
        this.currentVideoStatus.analyticsTriggeredVideoStarted = true;
      }

      // Option 1: Check the player configuration for live stream toggle
      if (!this.currentVideoStatus.isStreaming && this.playerConfig.isLiveStreamPlayer?.toLowerCase() === "true"){
        this.debugLog(`Player configuration ${this.playerConfig.player} contains property: isLiveStreamPlayer=${this.playerConfig.isLiveStreamPlayer}. Video has been identified as STREAMING.`, [LogType.CXO, LogType.QA]);
        this.currentVideoStatus.isStreaming = true;
        this.currentVideoStatus.timerBasedBidding = true;
        this.setNextAutomaticBidTime();
      }
      // Option 2: Watch video duration to identify streaming events
      else if(this.currentVideoStatus.videoDuration === 0 && this.videoElement?.duration > 0){
        this.currentVideoStatus.videoDuration = this.videoElement.duration;
      }else if(!this.currentVideoStatus.isStreaming && this.currentVideoStatus.videoDuration !== this.videoElement?.duration){
        const durationDifference: number = Math.abs(this.currentVideoStatus.videoDuration - this.videoElement?.duration);
        if(durationDifference > 1){
          this.currentVideoStatus.durationChangeCount++;
          //durationChangeCount will allow us to set how many times the video duration can change before we identify the video as streaming. Currently only 1 duration change is required for us to switch to streaming mode, but if we determine that some players load in a smaller piece of video to load faster we could adjust this number upwards.
          const durationChangesAllowed: number = 0;
          if(this.currentVideoStatus.durationChangeCount > durationChangesAllowed){
            this.debugLog(`Video's original duration of ${this.currentVideoStatus.videoDuration} does not match current video duration of ${this.videoElement.duration}. Video duration has changed ${this.currentVideoStatus.durationChangeCount} time(s). Video has been identified as STREAMING.`, [LogType.CXO, LogType.QA]);
            this.currentVideoStatus.isStreaming = true;
            this.currentVideoStatus.timerBasedBidding = true;
            this.setNextAutomaticBidTime();
          }else{
            this.debugLog(`Video's original duration of ${this.currentVideoStatus.videoDuration} does not match current video duration of ${this.videoElement.duration}. Video duration has changed ${this.currentVideoStatus.durationChangeCount} time(s), but video is not yet identified as STREAMING because ${durationChangesAllowed} duration changes are allowed.`, [LogType.CXO, LogType.QA]);
          }
        }else{
          this.debugLog(`Video's original duration of ${this.currentVideoStatus.videoDuration} does not match current video duration of ${this.videoElement.duration}. Video duration difference of ${durationDifference}s is less than the threshold of >1s. No changes made to video STREAMING status.`, [LogType.CXO, LogType.QA]);
        }
        this.currentVideoStatus.videoDuration = this.videoElement.duration;
      }else if(!this.nobid && this.currentVideoStatus.timerBasedBidding && this.videoElement.currentTime > this.currentVideoStatus.nextBidTime && this.cxoActive){
        this.debugLog(`Initiating timed bid request for ${this.currentVideoStatus.nextBidTime} seconds at video time ${this.videoElement.currentTime}.`, [LogType.CXO, LogType.QA]);
        this.overlayUtilities.automaticBidTimer.execute();
      }
    }
  }

  logVideoTimeElapsed(){
    const currentTime = this.videoElement.currentTime;
    const currentMinute = Math.floor(currentTime/60);
    
    if (currentMinute >= 2 && !this.currentVideoStatus.videoAnalyticsParameters.minutesReachedLog.includes(currentMinute)){
      this.currentVideoStatus.videoAnalyticsParameters.minutesReachedLog.push(currentMinute);
      this.analyticsEventDispatcher.sendVideoEvent(AnalyticsEventType.VIDEO_TIME_REACHED, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.videoElement.currentTime, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height}, {timeReached: currentMinute+"_MINUTES"});
    }
    if (currentTime > 60 && !this.currentVideoStatus.videoAnalyticsParameters.sixtySecondsReached){
      this.analyticsEventDispatcher.sendVideoEvent(AnalyticsEventType.VIDEO_TIME_REACHED, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.videoElement.currentTime, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height},  {timeReached: "60_SECONDS"});
      this.currentVideoStatus.videoAnalyticsParameters.sixtySecondsReached = true;
    }
    if (currentTime > 45 && !this.currentVideoStatus.videoAnalyticsParameters.fortyFiveSecondsReached){
      this.analyticsEventDispatcher.sendVideoEvent(AnalyticsEventType.VIDEO_TIME_REACHED, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.videoElement.currentTime, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height}, {timeReached: "45_SECONDS"});
      this.currentVideoStatus.videoAnalyticsParameters.fortyFiveSecondsReached = true;
    }
    if (currentTime > 30 && !this.currentVideoStatus.videoAnalyticsParameters.thirtySecondsReached){
      this.analyticsEventDispatcher.sendVideoEvent(AnalyticsEventType.VIDEO_TIME_REACHED, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.videoElement.currentTime, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height}, {timeReached: "30_SECONDS"});
      this.currentVideoStatus.videoAnalyticsParameters.thirtySecondsReached = true;
    }
    if (currentTime > 15 && !this.currentVideoStatus.videoAnalyticsParameters.fifteenSecondsReached){
      this.analyticsEventDispatcher.sendVideoEvent(AnalyticsEventType.VIDEO_TIME_REACHED, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.videoElement.currentTime, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height}, {timeReached: "15_SECONDS"});
      this.currentVideoStatus.videoAnalyticsParameters.fifteenSecondsReached = true;
    }
    if (currentTime > 10 && !this.currentVideoStatus.videoAnalyticsParameters.tenSecondsReached){
      this.analyticsEventDispatcher.sendVideoEvent(AnalyticsEventType.VIDEO_TIME_REACHED, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.videoElement.currentTime, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height}, {timeReached: "10_SECONDS"});
      this.currentVideoStatus.videoAnalyticsParameters.tenSecondsReached = true;
    }
    if (currentTime >= 5 && !this.currentVideoStatus.videoAnalyticsParameters.fiveSecondsReached){
      this.analyticsEventDispatcher.sendVideoEvent(AnalyticsEventType.VIDEO_TIME_REACHED, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.videoElement.currentTime, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height}, {timeReached: "5_SECONDS"});
      this.currentVideoStatus.videoAnalyticsParameters.fiveSecondsReached = true;
    }
  }
  

  logVideoQuartileElapsed(){
    const currentTime = this.videoElement.currentTime;
    
    if (currentTime >= this.videoElement.duration*.75 && !this.currentVideoStatus.videoAnalyticsParameters.seventyFivePercent){
      this.analyticsEventDispatcher.sendVideoEvent(AnalyticsEventType.VIDEO_QUARTILE_COMPLETE, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.videoElement.currentTime, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height}, {quartileCompleted: VideoEventQuartileNaming.THIRD});
      this.currentVideoStatus.videoAnalyticsParameters.seventyFivePercent = true;
    }
    if (currentTime >= this.videoElement.duration*.5 && !this.currentVideoStatus.videoAnalyticsParameters.fiftyPercent){
      this.analyticsEventDispatcher.sendVideoEvent(AnalyticsEventType.VIDEO_QUARTILE_COMPLETE, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.videoElement.currentTime, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height}, {quartileCompleted: VideoEventQuartileNaming.SECOND});
      this.currentVideoStatus.videoAnalyticsParameters.fiftyPercent = true;
    }
    if (currentTime >= this.videoElement.duration*.25 && !this.currentVideoStatus.videoAnalyticsParameters.twentyFivePercent){
      this.analyticsEventDispatcher.sendVideoEvent(AnalyticsEventType.VIDEO_QUARTILE_COMPLETE, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.videoElement.currentTime, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height}, {quartileCompleted: VideoEventQuartileNaming.FIRST});
      this.currentVideoStatus.videoAnalyticsParameters.twentyFivePercent = true;
    }
  }

  setNextAutomaticBidTime(){
    if(!this.nobid){
      if(this.currentVideoStatus.timerBasedBidding){
        if(!isNil(this.overlayUtilities.groupConfig) && this.overlayUtilities.groupConfig.persistentInserts){
          if(this.overlayUtilities.automaticBidTimer.timeRemainingInSeconds <= 0){
            const nextBidTime: number = (this.overlayUtilities.bidCount === 0)?1:this.overlayUtilities.groupConfig.insertFrequency+this.overlayUtilities.groupConfig.insertDuration;
            this.debugLog(`Next automatic timed bid request to happen in ${nextBidTime} seconds.`, [LogType.CXO, LogType.QA]);
            this.overlayUtilities.automaticBidTimer.reset(nextBidTime*1000);
          }else{
            this.debugLog(`Automatic bid timer already initialized. Next automatic timed bid request to happen in ${this.overlayUtilities.automaticBidTimer.timeRemainingInSeconds} seconds.`, [LogType.CXO, LogType.QA]);
          }
        }else{
          if(this.currentVideoStatus.lastBidTime !== 0 && this.currentVideoStatus?.nextBidTime > this.videoElement?.currentTime){
            this.debugLog(`Next automatic timed bid request to remain at: ${this.currentVideoStatus.nextBidTime}.`, [LogType.CXO, LogType.QA]);
          }else{
            if(this.currentVideoStatus.lastBidTime !== 0 && !isNil(this.overlayUtilities.groupConfig)){
              this.currentVideoStatus.nextBidTime = this.currentVideoStatus.lastBidTime + (this.overlayUtilities.groupConfig.insertFrequency + this.overlayUtilities.groupConfig.insertDuration);
            }else{
              this.currentVideoStatus.nextBidTime = this.videoElement.currentTime + .5;
              if(this.currentVideoStatus.nextBidTime < 2.1) this.currentVideoStatus.nextBidTime = 2.1;
            }
            this.debugLog(`Next automatic timed bid request to start at video time ${this.currentVideoStatus.nextBidTime}.`, [LogType.CXO, LogType.QA]);
          }
        }
      }
    }else{
      this.debugLog(`'nobid' attribute ${this.nobid} - there will be no automatic bidding.`, [LogType.CXO, LogType.QA]);
    }
  }
  
  resetVideoStatus(){
    this.debugLog('resetVideoStatus');
    this.currentVideoStatus.videoStarted = false;
    this.currentVideoStatus.videoEnded = true;
    this.currentVideoStatus.analyticsTriggeredPassed15Seconds = false;
    this.currentVideoStatus.analyticsTriggeredVideoStarted = false;
    if(!this.overlayUtilities.groupConfig.persistentInserts && !this.currentVideoStatus.isFloatingExclusive){
      this.currentVideoStatus.timerBasedBidding = false;
    }
    this.currentVideoStatus.isStreaming = false;
    this.currentVideoStatus.videoDuration = 0;
    this.currentVideoStatus.currentTime = 0;
    this.currentVideoStatus.durationChangeCount = 0;
    this.currentVideoStatus.lastBidTime = 0;

    this.currentVideoStatus.videoAnalyticsParameters.started = false;
    this.currentVideoStatus.videoAnalyticsParameters.restarted = true;
    this.currentVideoStatus.videoAnalyticsParameters.fiveSecondsReached = false;
    this.currentVideoStatus.videoAnalyticsParameters.tenSecondsReached = false;
    this.currentVideoStatus.videoAnalyticsParameters.fifteenSecondsReached = false;
    this.currentVideoStatus.videoAnalyticsParameters.thirtySecondsReached = false;
    this.currentVideoStatus.videoAnalyticsParameters.fortyFiveSecondsReached = false;
    this.currentVideoStatus.videoAnalyticsParameters.sixtySecondsReached = false;
    this.currentVideoStatus.videoAnalyticsParameters.minutesReachedLog = [];
    this.currentVideoStatus.videoAnalyticsParameters.twentyFivePercent = false;
    this.currentVideoStatus.videoAnalyticsParameters.fiftyPercent = false;
    this.currentVideoStatus.videoAnalyticsParameters.seventyFivePercent = false;
    this.currentVideoStatus.videoAnalyticsParameters.completed = false;
    this.currentVideoStatus.videoAnalyticsParameters.videoEndedTriggered = false;
  }

  logCXOTimeElapsedEvent(time:number) {
    if(this.overlayUtilities.elapsedOverlayTime-this.overlayUtilities.activeOverlayTime > (10800)*1000){
      this.destroyCXO();
    }
    if(this.cxoActive){
      switch(time){
        case 60:
          this.analyticsEventDispatcher.sendOverlayTimeEvent(AnalyticsEventType.OVERLAY_TIME_REACHED, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, this.overlayUtilities.frameRate, "60_SECONDS");
          this.timers.cxoTimeElapsedEventTimeout.reset(60000, ()=>{this.logCXOTimeElapsedEvent(120)});
          break;
        case 45:
          this.analyticsEventDispatcher.sendOverlayTimeEvent(AnalyticsEventType.OVERLAY_TIME_REACHED, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, this.overlayUtilities.frameRate, "45_SECONDS");
          this.timers.cxoTimeElapsedEventTimeout.reset(15000, ()=>{this.logCXOTimeElapsedEvent(60)});
          break;
        case 30:
          this.analyticsEventDispatcher.sendOverlayTimeEvent(AnalyticsEventType.OVERLAY_TIME_REACHED, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, this.overlayUtilities.frameRate, "30_SECONDS");
          this.timers.cxoTimeElapsedEventTimeout.reset(15000, ()=>{this.logCXOTimeElapsedEvent(45)});
          break;
        case 15:
          this.analyticsEventDispatcher.sendOverlayTimeEvent(AnalyticsEventType.OVERLAY_TIME_REACHED, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, this.overlayUtilities.frameRate, "15_SECONDS");
          this.timers.cxoTimeElapsedEventTimeout.reset(15000, ()=>{this.logCXOTimeElapsedEvent(30)});
          break;
        case 10:
          this.analyticsEventDispatcher.sendOverlayTimeEvent(AnalyticsEventType.OVERLAY_TIME_REACHED, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, this.overlayUtilities.frameRate, "10_SECONDS");
          this.timers.cxoTimeElapsedEventTimeout.reset(5000, ()=>{this.logCXOTimeElapsedEvent(15)});
          break;
        case 5:
          this.analyticsEventDispatcher.sendOverlayTimeEvent(AnalyticsEventType.OVERLAY_TIME_REACHED, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, this.overlayUtilities.frameRate, "5_SECONDS");
          this.timers.cxoTimeElapsedEventTimeout.reset(5000, ()=>{this.logCXOTimeElapsedEvent(10)});
          break;
        default:
          if (time > 60){
            this.analyticsEventDispatcher.sendOverlayTimeEvent(AnalyticsEventType.OVERLAY_TIME_REACHED, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, this.overlayUtilities.frameRate, time/60+"_MINUTES");
            this.timers.cxoTimeElapsedEventTimeout.reset(60000, ()=>{this.logCXOTimeElapsedEvent(time+60)});
          }
          break;
      }
    }
  }

  updateCXO() {
    this.detectCXWaitChanges();

    if(this.showLoggingOverlay && this.loggingOverlay?.parentElement !== this.cxoverlay?.parentElement){
        this.cxoverlay.parentElement.insertBefore(this.loggingOverlay,this.cxoverlay);
    }
    
    if (this.lockCXO) {
      this.debugLog(`updateCXO will not run. lockCXO = ${this.lockCXO}`);
    }else if(this.cxWait){
      if (!isNil(this.videoElement) && !this.isVideoOnPage && !this.videoPlayerLost){
        this.setVideoPlayerAsLost();
      }else{
        this.timers.updateCXOTimer.reset(5000);
      }
      this.debugLog(`updateCXO will not run. cxWait = ${this.cxWait}`);
    }else if (!isNil(this.videoElement)) {
      if(!isNil(this.activeResource) || !isNil(this.carouselResource)){
        this.timers.updateCXOTimer.reset(1000);
      }else{
        this.timers.updateCXOTimer.reset(5000);
      }

      if(this.isVideoOnPage){
        this.debugLog(`updateCXO --videoElementId = ${this.qElementId} --optimalInsertType = ${this.optimalInsertType}`);
        
        if(this.videoPlayerLost && this.overlayTimerElement.style.getPropertyValue('opacity') === '0'){
          this.overlayTimerElement.style.setProperty('opacity', '1');
          this.videoPlayerLost = false;
          this.timers.checkLostVideoPlayerTimer.cancel();
        }

        this.timers.checkTrackIntegrityTimer.execute();

        if(!(this.overlayUtilities.isCTV && this.overlayUtilities.currentDimensions.width !== 0)){
          this.determineDimensions()
        }else{
          this.debugLog(`Not re-calculating dimensions for CTV: ${this.overlayUtilities.currentDimensions.width}x${this.overlayUtilities.currentDimensions.height}`, LogType.CXO);
        }
        //let margin = this.determineMargin()
        let overflow:string = 'hidden'
        if (!isNil(this.optimalInsertType) && this.optimalInsertType !== InsertType.NONE) {
          if (this.optimalInsertType.includes('bleedover')) {
            overflow = 'visible'
          }
        }

        let position:CSSPosition = (this.overlayUtilities.currentDimensions.isFullscreen)?CSSPosition.ABSOLUTE:CSSPosition.UNSET;
        let cardinalDirections: CardinalDirections = {top: "auto", right: "auto", bottom: "auto", left: "auto"};
        if (this.overlayUtilities.currentDimensions.isFloating && !this.overlayUtilities.currentDimensions.isFullscreen) {
          position = CSSPosition.FIXED
        } else if (!isNil(this.optimalInsertType) && this.optimalInsertType !== InsertType.NONE) {
          const parentElement: HTMLElement = (this.optimalInsertType.includes('bleedover'))?this.bleedoverParentElement:(this.overlayUtilities.currentDimensions.isFullscreen)?this.fullscreenParentElement:this.overlayParentElement;
          if(!isNil(parentElement)){
            const positionValue: string = window.getComputedStyle(parentElement).getPropertyValue('position').toLowerCase()
            if(positionValue === CSSPosition.RELATIVE || positionValue === CSSPosition.STATIC){
              this.debugLog(`CXOverlay parent position = '${positionValue}' - setting overlay position = '${CSSPosition.ABSOLUTE}'.`, LogType.CXO);
              position = CSSPosition.ABSOLUTE
            }
          }
        }
        if (this.playerType === PlayerType.RUMBLE) {
          position = CSSPosition.UNSET
        }
        
        const overrideOverlayPosition: string = this.logManager.getDebugParamValue(DebugURLParams.OVERRIDE_OVERLAY_POSITION);
        if(overrideOverlayPosition !== null){
          position = overrideOverlayPosition.toLowerCase() as CSSPosition;
          this.debugLog(`Using override overlay position '${position}' for overlay CSS positioning.`, [LogType.QA, LogType.CXO]);
        }

        if(this.overlayUtilities.currentDimensions.isFloating){
          switch(this.cardinalDirectionsMode){
            case CardinalDirectionsModes.ADJUSTED_INSET:
              cardinalDirections = {top: this.floatingCardinalDirections.top, right: this.floatingCardinalDirections.right, bottom: this.floatingCardinalDirections.bottom, left: this.floatingCardinalDirections.left};
              break;
            case CardinalDirectionsModes.ZERO_INSET:
              cardinalDirections = {top: "0px", right: "auto", bottom: "auto", left: "0px"};
              break;
            case CardinalDirectionsModes.AUTO:
              cardinalDirections = {top: "auto", right: "auto", bottom: "auto", left: "auto"};
              break;
          }
        }else if(position === CSSPosition.ABSOLUTE){
          cardinalDirections = {top: "0px", right: "auto", bottom: "auto", left: "0px"};
        }

        this.timers.updateCXOFrameDelayTimer.reset(10);

        this.remakeADXonSizeChange();

        const containerStyle = this.containerElement.style;
        const heightChange: boolean = Boolean(this.overlayUtilities.currentDimensions.previousHeight !== this.overlayUtilities.currentDimensions.height);
        const widthChange: boolean = Boolean(this.overlayUtilities.currentDimensions.previousWidth !== this.overlayUtilities.currentDimensions.width);
        const positionChange: boolean = Boolean(containerStyle.getPropertyValue('position') !== position);
        let info = 'updateCXO'
        info += `\n --style.height = ${containerStyle.getPropertyValue('height')}`
        if (heightChange) {
            containerStyle.setProperty('height', this.overlayUtilities.currentDimensions.height + 'px');
            this.overlayUtilities.currentDimensions.previousHeight = this.overlayUtilities.currentDimensions.height;
            info += `  --changed to ${containerStyle.getPropertyValue('height')}`
        }
        info += `\n --style.width = ${containerStyle.getPropertyValue('width')}`
        if (widthChange) {
          //this.debugLog('Previous width values: ' + this.overlayUtilities.currentDimensions.previousWidths + ' - current width: ' + this.overlayUtilities.currentDimensions.width, LogType.IMPORTANT);
          this.overlayUtilities.currentDimensions.previousWidth = this.overlayUtilities.currentDimensions.width;
          containerStyle.setProperty('width', this.overlayUtilities.currentDimensions.width + 'px');
          info += `  --changed to ${containerStyle.getPropertyValue('width')}`
        }
        info += `\n --style.top = ${containerStyle.getPropertyValue('top')}`
        if (containerStyle.getPropertyValue('top') !== cardinalDirections.top) {
          containerStyle.setProperty('top', cardinalDirections.top);
          info += `  --changed to ${containerStyle.getPropertyValue('top')}`
        }
        info += `\n --style.bottom = ${containerStyle.getPropertyValue('bottom')}`
        if (containerStyle.getPropertyValue('bottom') !== cardinalDirections.bottom) {
          containerStyle.setProperty('bottom', cardinalDirections.bottom);
          info += `  --changed to ${containerStyle.getPropertyValue('bottom')}`
        }
        info += `\n --style.left = ${containerStyle.getPropertyValue('left')}`
        if (containerStyle.getPropertyValue('left') !== cardinalDirections.left) {
          containerStyle.setProperty('left', cardinalDirections.left);
          info += `  --changed to ${containerStyle.getPropertyValue('left')}`
        }
        info += `\n --style.right = ${containerStyle.getPropertyValue('right')}`
        if (containerStyle.getPropertyValue('right') !== cardinalDirections.right) {
          containerStyle.setProperty('right', cardinalDirections.right);
          info += `  --changed to ${containerStyle.getPropertyValue('right')}`
        }
        info += `\n --style.overflow = ${containerStyle.getPropertyValue('overflow')}`
        if (containerStyle.getPropertyValue('overflow') !== overflow) {
          containerStyle.setProperty('overflow', overflow);
          this.overlayTimerElement.style.setProperty('overflow', overflow);
          info += `  --changed to ${containerStyle.getPropertyValue('overflow')}`
        }
        info += `\n --style.position = ${containerStyle.getPropertyValue('position')}`
        if (positionChange) {
          containerStyle.setProperty('position', position);
          info += `  --changed to ${containerStyle.getPropertyValue('position')}`
          this.containerElement?.style.setProperty('opacity', '0');
          this.timers.containerElementOpacityResetTimer.reset(150);
        }
        this.debugLog(info)
        
        if(heightChange || widthChange){
          this.timers.dispatchResizeEventTimer.execute();
          this.timers.dispatchResizeEventTimer.reset(1);
          this.timers.updateCXOTimer.reset(50);
        }
        
      }else if(!this.videoPlayerLost){
        this.setVideoPlayerAsLost();
        this.debugLog(`updateCXO - video player is not on page and videoPlayerLost = false`);
        if(this.overlayUtilities.groupConfig.persistentInserts && !isNil(this.activeResource)){
          this.determineDimensions();
        }
      }else{
        this.debugLog(`updateCXO - video player is not on page and videoPlayerLost = true`);
        if(this.overlayUtilities.groupConfig.persistentInserts && !isNil(this.activeResource)){
          this.determineDimensions();
        }
      }
    }
  }

  setVideoPlayerAsLost(){
    this.debugLog('Attached video element has been detected as removed from page', [LogType.QA, LogType.CXO]);
    this.watchedVideoSize = {left:0, top:0, width:0, height:0}
    if(!this.overlayUtilities.groupConfig.persistentInserts){
      this.overlayTimerElement.style.setProperty('opacity', '0');
      this.debugLog(`Group configuration 'persistentInserts'=${this.overlayUtilities.groupConfig.persistentInserts} - Hiding overlay on video player lost.`, [LogType.CXO]);
    }
    this.videoPlayerLost = true;
    this.timers.checkLostVideoPlayerTimer.reset(1000);
  }

  remakeADXonSizeChange(){
    if(!isNil(this.activeResource) && this.activeResourceData.data.isADX){
      const widthChangePercentage: number = this.overlayUtilities.percentageDifference(parseInt(this.activeResource.getAttribute('creationwidth')), this.overlayUtilities.currentDimensions.width);
      if(widthChangePercentage > 1){
        let shouldRemake: boolean = true;
        if(!isNil(this.carouselResource)){
          const carouselResourceData: Resource = this.inserts.find(ins => ins.id === this.carouselResource.getAttribute('acceptedbidid'));
          if(!isNil(carouselResourceData) && carouselResourceData.data.isADX){
            this.clearRemainingInserts();
          }else{
            this.clearActiveInsert();
            shouldRemake = false;
          }
        }else{
          this.clearActiveInsert();
        }
        if(shouldRemake){
          this.previousADXId = this.activeResourceData.uniqueId;
          this.timers.remakeADXInsertTimer.reset(1000);
        }
        this.debugLog(`Video size has changed by ${widthChangePercentage.toFixed(3)}% since ADX insert creation.\n  ADX insert to be removed.\n  Will be recreated: ${shouldRemake}`, [LogType.QA, LogType.CXO]);
      }
    }
  }

  remakeADXInsert(){
    if(isNil(this.videoElement) || !this.isVideoOnPage){
      this.debugLog('Video is no longer on the page. Will not remake ADX insert.', [LogType.CXO, LogType.QA]);
    }else if(this.isVideoAdvertisement){
      this.debugLog('Video advertisement is active. Will not remake ADX insert.', [LogType.CXO, LogType.QA]);
    }else if(!isNil(this.activeResource)){
      this.debugLog('Another insert is currently active. Will not remake ADX insert.', [LogType.CXO, LogType.QA]);
    }else{
      const preferredBanner: BannerParameters = this.preferredBannerSize;
      this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_REBUILD, BidOriginSourceType.ADX, 'ADX', 'ADX', 'ADX', this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.previousADXId, preferredBanner.insertType.toUpperCase(), `${preferredBanner.adxSize[0]}x${preferredBanner.adxSize[1]}`, this.overlayUtilities.adOpportunityId, this.overlayUtilities.bidRequestId, this.overlayUtilities.containerViewabilityValue);  
      this.generateADXInsert();
    }
  }

  updateCXOFrameDelay(){
    if(this.overlayUtilities.currentDimensions.isFloating){
      this.compareFloatingPlayerPosition()
    }else{
      if(this.cxoverlay.style.getPropertyValue('opacity') == '0'){
        this.cxoverlay.style.setProperty('opacity', '1');
      }
    }
    this.adjustMargin()
  }

  videoPlayerRemainsLostCheck(){
    if(!this.isVideoOnPage){
      this.debugLog('videoPlayerRemainsLostCheck - Player has not been re-added. Reset video status.', [LogType.CXO, LogType.QA]);
      if(!this.overlayUtilities.groupConfig.persistentInserts){
        this.debugLog(`Group configuration 'persistentInserts'=${this.overlayUtilities.groupConfig.persistentInserts} - Not removing inserts after video is no longer available.`, [LogType.QA, LogType.CXO]);
        this.clearRemainingInserts();
        this.overlayUtilities.resetCarouselData();
      }
      this.shouldRequestMoments = false;
      this.resetVideoStatus();
      this.videoElement['cxInitialized'] = false;
      delete(this.videoElement['cxInitialized']);
      this.removeVideoEvents();
      this.videoUrl = null;
      if(this.videoElement.hasAttribute('insertvideoscale')){
        this.debugLog('Removing scaling of lost video player: ' + this.videoElement.getAttribute('insertvideoscale'), LogType.CXO);
        this.videoElement.removeAttribute('insertvideoscale')
        this.videoElement.style.removeProperty('transform');
        this.overlayUtilities.currentDimensions.elementScale = 1;
      }
      this.videoElement = null;
      this.insertLogicManager.elementHost = null;
      this.lockCXO = false;
      this.timers.reinitializeVideoElementTimer.reset(50);
    }else{
      this.debugLog('Player has been re-added page. Take no action.', [LogType.CXO, LogType.QA]);
      this.timers.updateCXOTimer.execute();
    }
    this.videoPlayerLost = false;
  }

  addEvents() {
    if (!isNil(this.videoElement)) {
      this.addVideoEvents();

      if (!isNil(this.playerConfig.floatingCloseBtn)) {
        const closeButton: HTMLElement = this.videoContainerSearchNode.querySelector(this.playerConfig.floatingCloseBtn);
        if(!isNil(closeButton)){
          this.videoContainerSearchNode.querySelector(this.playerConfig.floatingCloseBtn).addEventListener('click', () => {
            this.debugLog('addEvents --floatingClosePlayerClearInsert')
            this.clearRemainingInserts()
            this.overlayUtilities.resetCarouselData();
          })
        }
      }

    }
  }

  addVideoEvents(){
    this.debugLog(`Adding Video Event Listeners for video: ${this.videoElement.outerHTML.slice(0, this.videoElement.outerHTML.indexOf(this.videoElement.innerHTML))}`, [LogType.QA, LogType.CXO]);
    for(var i in this.registeredVideoEvents){
      this.debugLog(`Adding event '${i}' to video`, [LogType.CXO, LogType.QA]);
      if(i === VideoEvents.VIDEO_EVENT_FROM_INSERT){
        this.debugLog(`Removing bubble ability on event ${InsertEventType.EVENT_FROM_INSERT} from insert`, LogType.CXO);
        this.videoElement.addEventListener(InsertEventType.EVENT_FROM_INSERT, this.registeredVideoEvents[i], false);
      }else{
        this.videoElement.addEventListener(i, this.registeredVideoEvents[i]);
      }
    }

    if(this.playerType === PlayerType.AIRTV){
      this.debugLog('Adding AIRTV Video Event Listeners', [LogType.QA, LogType.CXO]);
      for(var i in this.registeredAirTVVideoEvents){
        this.debugLog(`Adding event '${i}' to video`, [LogType.CXO, LogType.QA]);
        this.videoElement.addEventListener(i, this.registeredAirTVVideoEvents[i]);
      }
    }
  }

  removeVideoEvents(){
    if(!isNil(this.videoElement)){
      this.debugLog(`Removing Video Event Listeners for video: ${this.qElementId}`, [LogType.QA, LogType.CXO]);
      for(var i in this.registeredVideoEvents){
        this.debugLog(`Removing event '${i}' from video`, [LogType.CXO, LogType.QA]);
        if(i === VideoEvents.VIDEO_EVENT_FROM_INSERT){
          this.videoElement.removeEventListener(InsertEventType.EVENT_FROM_INSERT, this.registeredVideoEvents[i], false);
        }else{
          this.videoElement.removeEventListener(i, this.registeredVideoEvents[i]);
        }
      }

      if(this.playerType === PlayerType.AIRTV){
        this.debugLog('Removing AIRTV Video Event Listeners', [LogType.QA, LogType.CXO]);
        for(var i in this.registeredAirTVVideoEvents){
          this.debugLog(`Removing event '${i}' from video`, [LogType.CXO, LogType.QA]);
          this.videoElement.removeEventListener(i, this.registeredAirTVVideoEvents[i]);
        }
      }
    }
  }

  addManualBiddingEvents(){
    this.shouldRequestMoments = false;
    for(var i in this.registeredManualBidEvents){
      this.debugLog(`Adding event ${i} to window`, [LogType.CXO, LogType.QA])
      self.addEventListener(i, this.registeredManualBidEvents[i]);
    }
  }

  videoLoadedData(){
    this.debugLog('videoLoadedData')
  }

  videoLoadedMetadata(){
    this.debugLog('videoLoadedMetadata')
    this.handleVideoSourceChange()
  }

  sendVideoEndedAnalytics(videoCompleted: boolean = false) {
    if(!this.currentVideoStatus.videoAnalyticsParameters.videoEndedTriggered) {
      const totalTimeSinceVideoStart = ((new Date()).getTime() - this.timers.watchedVideoDurationTimer.createdTime); 
      this.debugLog(`VIDEO ENDED - Time since video start: ${totalTimeSinceVideoStart}ms`, LogType.CXO);
      
      const watchedVideoTime = this.timers.watchedVideoDurationTimer.getTotalElapsedTime();
      this.debugLog(`VIDEO ENDED - Elapsed time of watchedVideoTimer: ${watchedVideoTime}ms`, LogType.CXO);
      
      const watchedAdTime = totalTimeSinceVideoStart - watchedVideoTime;
      this.debugLog(`VIDEO ENDED - Time spent in cx-wait: ${watchedAdTime}ms`, LogType.CXO);
      
      this.timers.watchedVideoDurationTimer.complete();
      const videoCompletionPercentage:number = (videoCompleted)?100:parseFloat(((this.currentVideoStatus.currentTime/this.currentVideoStatus.videoDuration)*100).toFixed(2));

      const videoData = {
        watchedAdTime: parseFloat((watchedAdTime/1000).toFixed(2)),
        watchedVideoTime: parseFloat((watchedVideoTime/1000).toFixed(2)), 
        adContentToVideoContentRatio: parseFloat((watchedAdTime/watchedVideoTime).toFixed(5)),
        videoCompletionPercentage: videoCompletionPercentage
      };

      this.analyticsEventDispatcher.sendVideoEvent(
        AnalyticsEventType.VIDEO_ENDED,
        BidOriginSourceType.PLATFORM,
        this.overlayUtilities.currentWindowLocation.href,
        Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"),
        this.playerMode,
        this.videoElement.currentTime,
        this.overlayUtilities.elapsedOverlayTime,
        this.overlayUtilities.activeOverlayTime,
        this.overlayUtilities.containerViewabilityValue,
        {
          width: this.overlayUtilities.currentDimensions.width,
          height: this.overlayUtilities.currentDimensions.height
        },
        null,
        videoData
      );
      this.currentVideoStatus.videoAnalyticsParameters.videoEndedTriggered = true;
    } else {
      this.debugLog('VIDEO ENDED - Event has already been triggered for this video. Will not send again.', LogType.CXO);
    }
  }

  videoEnd() {
    this.debugLog('videoEnd')
    this.currentVideoStatus.videoAnalyticsParameters.restarted = false;
    this.currentVideoStatus.currentTime = this.videoElement.currentTime;

    this.sendVideoEndedAnalytics(true);

    if (!this.currentVideoStatus.videoAnalyticsParameters.completed){
      this.analyticsEventDispatcher.sendVideoEvent(AnalyticsEventType.VIDEO_QUARTILE_COMPLETE, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.videoElement.currentTime, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height}, {quartileCompleted: VideoEventQuartileNaming.FOURTH});
      this.currentVideoStatus.videoAnalyticsParameters.completed = true;
    }

    this.videoEndedReset();
  }

  videoEndedReset(){
    if(!this.currentVideoStatus.videoEnded){
      if(isNil(this.overlayUtilities.groupConfig) || !this.overlayUtilities.groupConfig.persistentInserts){
        this.clearRemainingInserts()
        this.overlayUtilities.resetCarouselData();
        this.shouldRequestMoments = this.overlayUtilities.isManualBidding ? false : true;
      }
      
      this.resetVideoStatus();
    }
  }

  videoPlay(){
    this.debugLog('videoPlay')

    this.analyticsEventDispatcher.sendVideoEvent(AnalyticsEventType.VIDEO_PLAY, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.videoElement.currentTime, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height});

    this.checkIfMomentsNeeded()
    this.timers.checkTrackIntegrityTimer.reset(500);

    this.timers.detectCXWaitChangesTimer.resetInterval(500, 6);
  }

  videoPause(){
    this.debugLog('videoPause');
    this.checkIfMomentsNeeded();

    this.analyticsEventDispatcher.sendVideoEvent(AnalyticsEventType.VIDEO_PAUSE, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.videoElement.currentTime, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height});
    
    this.timers.detectCXWaitChangesTimer.resetInterval(500, 6);

    if(this.videoElement.currentTime >= this.videoElement.duration && !this.currentVideoStatus.isStreaming){
      this.debugLog('Video pause triggered video end reset.', [LogType.QA, LogType.CXO]);
      this.videoEndedReset();
    }
  }

  videoEmptied(){
    if(!this.overlayUtilities.groupConfig.persistentInserts){
      if(this.didVideoSourceChange){
        this.debugLog(['videoEmptied event triggered. Removing any active inserts.', `Current video source: ${this.getVideoSource(this.videoElement)}`], [LogType.QA, LogType.CXO]);
        //this.clearRemainingInserts();
        this.handleVideoSourceChange();
        //this.shouldRequestMoments = true;
      }else{
        this.debugLog(['videoEmptied event triggered, but video source did not change. No change required for inserts.'], [LogType.QA, LogType.CXO]);
        this.currentVideoStatus.videoRecentlyEmptied = true;
        this.resetVideoStatus();
      }
    }else{
      this.debugLog(['videoEmptied event triggered. persistentInserts=true - Will not remove active inserts.', `Current video source: ${this.getVideoSource(this.videoElement)}`], [LogType.QA, LogType.CXO]);
      this.resetVideoStatus();
    }
  }

  videoTimeUpdate(){
    if(!isNil(this.videoElement)){
      if(this.cxWait){
        if(this.cxoverlay.getAttribute('cx-wait') === null){
          this.debugLog('Video time change during "automatic" cx-wait. Testing for video advertisement.', [LogType.CXO]);
          this.detectCXWaitChanges();
        }
      }
      if(this.currentVideoStatus.videoRecentlyEmptied){
        this.debugLog('The video has recently had a "videoEmptied" event. Will check video source.', LogType.CXO);
        this.handleVideoSourceChange();
        this.currentVideoStatus.videoRecentlyEmptied = false;
      }
      if (!this.currentVideoStatus.videoStarted && (this.videoElement.currentTime >= .5 && this.videoElement.currentTime < (this.videoElement.duration-.5))) {
        this.currentVideoStatus.videoStarted = true;
        if (this.currentVideoStatus.videoEnded) {
          this.currentVideoStatus.videoEnded = false;
          this.debugLog('addEvents --timeupdate --videoRestarted')
          this.checkIfMomentsNeeded()

          if (!this.currentVideoStatus.videoAnalyticsParameters.restarted) {
            this.analyticsEventDispatcher.sendVideoEvent(AnalyticsEventType.VIDEO_RESTARTED, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.videoElement.currentTime, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height});
            this.currentVideoStatus.videoAnalyticsParameters.restarted = true;
          }
        }
      } else if (!this.currentVideoStatus.videoEnded && this.videoElement.readyState >= 2 && this.videoElement.currentTime >= (this.videoElement.duration-.5)) {
        if(this.videoElement.getAttribute('loop') != null && this.videoElement.getAttribute('loop') !== 'false'){
          this.videoEnd();
        }
      }
      if(this.videoElement.paused){
        this.debugLog('Video time update while paused', LogType.CXO);
        this.timers.detectCXWaitChangesTimer.resetInterval(500, 6);
      }
      if(!isNil(this.activeResource) && this.isInsertTimeBlocked){
        this.debugLog('Insert time is blocked. Should not be displaying insert. Will destroy active insert.', [LogType.QA, LogType.CXO]);
        this.clearRemainingInserts();
      }
      this.checkCurrentVideoStatus();
    }
  }

  videoInsertEvent(evt:CustomEvent){
    const params = evt.detail;
    const insertUniqueId: string = evt.detail.uid ?? 'UNDEFINED';
    const insertViewability: number = evt.detail.insertViewability ?? null;
    const insertLifetime: number = evt.detail.insertLifetime ?? null;
    const insertViewabilityTime: number = evt.detail.insertViewabilityTime ?? null;
    const insertAverageViewabilityValue: number = Math.round(evt.detail.insertAverageViewabilityValue *10000)/100;
    const logTarget: LogType = (insertUniqueId === 'UNDEFINED')?LogType.IMPORTANT:LogType.CXO;
    this.debugLog(`videoInsertEvent - communication from inserts: ${evt.detail.type} from insert ${insertUniqueId}`, logTarget);
    const eventResource: Resource = this.inserts.find(x => x.uniqueId === insertUniqueId) ?? this.activeResourceData;
    switch (params.type) {
      case InsertEventType.INSERT_INITIALIZED:{
        this.debugLog('addEvents --insertInitializedSuccessfully')

        if(!!this.overlayUtilities.osdConfig?.renderPrebidWin) {
          const iframe = evt.detail?.div;
          const acceptedbidid = evt.detail?.acceptedbidid;
          this.overlayUtilities.osdConfig.renderPrebidWin(iframe, acceptedbidid);
        }
        
        this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_INITIALIZED, this.getOriginSourceFromData(eventResource), eventResource.seat, eventResource.campaignId, eventResource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, insertUniqueId, this.activeResource.tagName, (!isNil(eventResource?.data?.w))?`${eventResource?.data?.w}x${eventResource?.data?.h}`:null, eventResource.adOpportunityId, eventResource.bidRequestId, this.overlayUtilities.containerViewabilityValue, null, insertViewability);
        
        break;
      }
      case InsertEventType.INSERT_RENDERED:{
        this.debugLog('addEvents --insertDataAssignedSuccessfully')
        
        this.floatingJumpCount = 0;
        this.timers.updateCXOTimer.reset(1);
        
        this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_RENDERED, this.getOriginSourceFromData(eventResource), eventResource.seat, eventResource.campaignId, eventResource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, insertUniqueId, this.activeResource.tagName, (!isNil(eventResource?.data?.w))?`${eventResource?.data?.w}x${eventResource?.data?.h}`:null, eventResource.adOpportunityId, eventResource.bidRequestId, this.overlayUtilities.containerViewabilityValue, null, insertViewability);
        
        break;
      }
      case InsertEventType.INSERT_RERENDERED:{
        this.debugLog('addEvents --insertDataReassignedSuccessfully')
        this.floatingJumpCount = 0;
        this.timers.updateCXOTimer.reset(1);

        this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_RERENDERED, this.getOriginSourceFromData(eventResource), eventResource.seat, eventResource.campaignId, eventResource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, insertUniqueId, this.activeResource.tagName, (!isNil(eventResource?.data?.w))?`${eventResource?.data?.w}x${eventResource?.data?.h}`:null, eventResource.adOpportunityId, eventResource.bidRequestId, this.overlayUtilities.containerViewabilityValue, null, insertViewability);        
        break
      }
      case InsertEventType.INSERT_USER_CLOSED:{
        this.debugLog('addEvents --insertUserClosed')

        this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_USER_CLOSED, this.getOriginSourceFromData(eventResource), eventResource.seat, eventResource.campaignId, eventResource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, insertUniqueId, this.activeResource.tagName, (!isNil(eventResource?.data?.w))?`${eventResource?.data?.w}x${eventResource?.data?.h}`:null, eventResource.adOpportunityId, eventResource.bidRequestId, this.overlayUtilities.containerViewabilityValue, null, insertViewability);
        break
      }
      case InsertEventType.INSERT_CLOSED:{
        this.debugLog('addEvents --insertClosed')

        if(this.isCarouselStarted){
          this.overlayUtilities.activeCarouselData.isClosed = true;
        }

        this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_CLOSED, this.getOriginSourceFromData(eventResource), eventResource.seat, eventResource.campaignId, eventResource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, insertUniqueId, this.activeResource.tagName, (!isNil(eventResource?.data?.w))?`${eventResource?.data?.w}x${eventResource?.data?.h}`:null, eventResource.adOpportunityId, eventResource.bidRequestId, this.overlayUtilities.containerViewabilityValue, null, insertViewability);
        break
      }
      case InsertEventType.INSERT_OPENED:{
        this.debugLog('addEvents --insertOpened')

        if(this.isCarouselStarted){
          this.overlayUtilities.activeCarouselData.isClosed = false;
        }

        this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_REOPENED, this.getOriginSourceFromData(eventResource), eventResource.seat, eventResource.campaignId, eventResource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, insertUniqueId, this.activeResource.tagName, (!isNil(eventResource?.data?.w))?`${eventResource?.data?.w}x${eventResource?.data?.h}`:null, eventResource.adOpportunityId, eventResource.bidRequestId, this.overlayUtilities.containerViewabilityValue, null, insertViewability);        
        break
      }
      case InsertEventType.INSERT_DESTROYED:{
        const tagName:string=(!isNil(this.activeResource))?this.activeResource.tagName:'undefined'
        this.dispatchExternalOverlayEvent(OverlayExternalEventType.INSERT_MOMENT_END);
        if(!isNil(this.activeResource) && this.activeResource.getAttribute('uniqueid')===params.uid){
          if(evt.detail.destroyAll === true && !isNil(this.carouselResource)) {
            this.clearRemainingInserts();
            this.debugLog('Removing subloaded carousel insert from available insert options.', [LogType.CXO]);
          }
          this.insertToClear();
        }else if(!isNil(this.carouselResource) && this.carouselResource.getAttribute('uniqueid')===params.uid){
          this.clearCarouselInsert();
          this.debugLog('Removing subloaded carousel insert from available insert options.', [LogType.CXO]);
        }else if(params.uid === 'empty'){
          this.insertBeingCleared = false;
        }

        if(params?.uid !== 'empty'){
          this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_DESTROYED, this.getOriginSourceFromData(eventResource), eventResource.seat, eventResource.campaignId, eventResource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, insertUniqueId, tagName, (!isNil(eventResource?.data?.w))?`${eventResource?.data?.w}x${eventResource?.data?.h}`:null, eventResource.adOpportunityId, eventResource.bidRequestId, this.overlayUtilities.containerViewabilityValue, null, insertViewability, insertLifetime, insertViewabilityTime, insertAverageViewabilityValue);

          this.debugLog('addEvents --insertDestroyedSuccessfully ' + params?.uid, LogType.QA);
        }

        break
      }
      case InsertEventType.INSERT_IMPRESSION:{
        eventResource.impressionFired = true;
        this.overlayUtilities.impressionCount++;

        const bidAmount:number = eventResource.bid ?? null;
        
        const insertSource: BidOriginSourceType = this.getOriginSourceFromData(eventResource);
        dispatchEvent(new CustomEvent("qortex-rtd", {detail: {type: "qx-impression", uid: params?.uid}}))
        this.analyticsEventDispatcher.sendInsertImpressionEvent(AnalyticsEventType.INSERT_IMPRESSION, insertSource, eventResource.seat, eventResource.campaignId, eventResource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, insertUniqueId, this.activeResource.tagName, (!isNil(eventResource?.data?.w))?`${eventResource?.data?.w}x${eventResource?.data?.h}`:null, eventResource.adOpportunityId, eventResource.bidRequestId, this.overlayUtilities.containerViewabilityValue, insertViewability, bidAmount);

        if(bidAmount !== null){
          this.dispatchExternalOverlayEvent(OverlayExternalEventType.IMPRESSION, {type:OverlayExternalEventType.IMPRESSION, bid: bidAmount});
          if(this.isIframePlayer){
            this.dispatchExternalOverlayEvent(OverlayExternalEventType.IMPRESSION, {type:OverlayExternalEventType.IMPRESSION, bid: bidAmount}, true);
          }
        }
        break;
      }
      case InsertEventType.INSERT_DISPLAY_STARTED:{
        this.debugLog('addEvents --insertDisplayStarted');
        this.debugLog(['Is carousel? ' + this.overlayUtilities.groupConfig.carouselEnabled], [LogType.CXO]);

        if (!this.isCarouselStarted && this.overlayUtilities.groupConfig.carouselEnabled && !this.overlayUtilities.activeCarouselData.isCompleted){
          const carouselBidDelay: number = (this.isOSDAvailable)?this.overlayUtilities.groupConfig.carouselSpeed:this.overlayUtilities.groupConfig.carouselSpeed-3;
          this.overlayUtilities.carouselBidTimer.reset(carouselBidDelay*1000);
          this.debugLog([`Attempting new carousel bid in ${(carouselBidDelay)} seconds.`], [LogType.CXO, LogType.QA]);
        } else if(this.isCarouselStarted){
          this.overlayUtilities.activeCarouselData.isClosed = false;
        }

        if(this.overlayUtilities.isManualBidding){
          this.overlayUtilities.manualBidRequestTimeout.reset(5000)
        }

        this.dispatchExternalOverlayEvent(OverlayExternalEventType.INSERT_MOMENT_BEGIN);

        const insertSource: BidOriginSourceType = this.getOriginSourceFromData(eventResource);
        this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_DISPLAYED, insertSource, eventResource.seat, eventResource.campaignId, eventResource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, insertUniqueId, this.activeResource.tagName, (!isNil(eventResource?.data?.w))?`${eventResource?.data?.w}x${eventResource?.data?.h}`:null, eventResource.adOpportunityId, eventResource.bidRequestId, this.overlayUtilities.containerViewabilityValue, null, insertViewability);

        this.overlayUtilities.forceNextRebid = false;
        this.overlayUtilities.rebidCount = 0;
        
        break
      }
      case InsertEventType.INSERT_GPT_RESPONSE:{
        const insertSource: BidOriginSourceType = this.getOriginSourceFromData(eventResource);
        if(insertSource === BidOriginSourceType.ADX || insertSource === BidOriginSourceType.OSD) {
          const responseData: BidResponseData = {
            overlayTime: this.overlayUtilities.elapsedOverlayTime/1000,
            activeOverlayTime: this.overlayUtilities.activeOverlayTime/1000,
            totalBidsCount: this.overlayUtilities.bidCount,
            adOpportunityBidCount: (this.overlayUtilities.rebidCount + 1),
            adOpportunityId: this.overlayUtilities.adOpportunityId,
            bidRequestId: this.overlayUtilities.bidRequestId,
            bidCpm: 0,
            cid: 'ADX',
            crid: null,
            seatId: null,
            adId: null,
            bidId: null,
            impressionType: ImpressionType.DISPLAY,
            componentDimensions: {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height},
            containerViewability: this.overlayUtilities.containerViewabilityValue,
            videoTime: (!isNil(this.videoElement))?this.videoElement.currentTime:0,
          }
          if(!isNil(eventResource?.data?.w)){
            responseData.bannerSize = `${eventResource?.data?.w}x${eventResource?.data?.h}`;
          }
          if(insertSource === BidOriginSourceType.OSD){
            this.overlayUtilities.osdConfig.eventData['isSafeframe'] = params.safeframe;
            const debugData: {[key:string]:any} = this.overlayUtilities.cleanOSDResponseData(this.overlayUtilities.osdConfig?.eventData);
            responseData.debug = debugData;
            if(!!debugData?.osdData?.pbjs_won){
              this.debugLog([`BID_RESPONSE - Prebid winner (pbjs_won) from bidder ${debugData.osdData.pbjs_won.bidder} at cpm ${debugData.osdData.pbjs_won.cpm}`,debugData.osdData.pbjs_won] , [LogType.CXO, LogType.QA]);
            }
          }
          this.analyticsEventDispatcher.sendBidResponseEvent(AnalyticsEventType.BID_RESPONSE, insertSource, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, responseData);
        }
        break
      }
      case InsertEventType.INSERT_GPT_RESET:{
        const insertSource: BidOriginSourceType = this.getOriginSourceFromData(eventResource);
        if(insertSource === BidOriginSourceType.ADX || insertSource === BidOriginSourceType.OSD) {
          
          const tagName:string=(!isNil(this.activeResource))?this.activeResource.tagName:'undefined';

          this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_DESTROYED, insertSource, eventResource.seat, eventResource.campaignId, eventResource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, insertUniqueId, tagName, (!isNil(eventResource?.data?.w))?`${eventResource?.data?.w}x${eventResource?.data?.h}`:null, eventResource.adOpportunityId, eventResource.bidRequestId, this.overlayUtilities.containerViewabilityValue, null, insertViewability, insertLifetime, insertViewabilityTime, insertAverageViewabilityValue);

          
          eventResource.uniqueId = this.overlayUtilities.generateUniqueId;
          eventResource.bidRequestId = this.overlayUtilities.bidRequestId;
          eventResource.adOpportunityId = this.overlayUtilities.adOpportunityId;

          this.activeResource.setAttribute('uniqueid', eventResource.uniqueId);

          this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_CREATED, insertSource, eventResource.seat, eventResource.campaignId, eventResource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, eventResource.uniqueId, tagName, (!isNil(eventResource?.data?.w))?`${eventResource?.data.w}x${eventResource?.data.h}`:null, eventResource.adOpportunityId, eventResource.bidRequestId, this.overlayUtilities.containerViewabilityValue);
          
          //unsure if we wanted this to be changed in the update
          this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_RENDERED, insertSource, eventResource.seat, eventResource.campaignId, eventResource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, eventResource.uniqueId, tagName, (!isNil(eventResource?.data?.w))?`${eventResource?.data?.w}x${eventResource?.data?.h}`:null, eventResource.adOpportunityId, eventResource.bidRequestId, this.overlayUtilities.containerViewabilityValue, null, insertViewability);
          
        }
        break
      }
      case InsertEventType.INSERT_GPT_REFRESH:{
        const insertSource: BidOriginSourceType = this.getOriginSourceFromData(eventResource);
        if(insertSource === BidOriginSourceType.ADX || insertSource === BidOriginSourceType.OSD) {

          this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_DISPLAYED, insertSource, eventResource.seat, eventResource.campaignId, eventResource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, eventResource.uniqueId, this.activeResource.tagName, (!isNil(eventResource?.data?.w))?`${eventResource?.data?.w}x${eventResource?.data?.h}`:null, eventResource.adOpportunityId, eventResource.bidRequestId, this.overlayUtilities.containerViewabilityValue, null, insertViewability);

          this.overlayUtilities.forceNextRebid = false;
          this.overlayUtilities.rebidCount = 0;
          
          const bidAmount:number = eventResource.bid ?? null;
          dispatchEvent(new CustomEvent("qortex-rtd", {detail: {type: "qx-impression", uid: params?.uid}}))
          this.analyticsEventDispatcher.sendInsertImpressionEvent(AnalyticsEventType.INSERT_IMPRESSION, insertSource, eventResource.seat, eventResource.campaignId, eventResource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, eventResource.uniqueId, this.activeResource.tagName, (!isNil(eventResource?.data?.w))?`${eventResource?.data?.w}x${eventResource?.data?.h}`:null, eventResource.adOpportunityId, eventResource.bidRequestId, this.overlayUtilities.containerViewabilityValue, insertViewability, bidAmount);
          this.overlayUtilities.impressionCount++;
        }
        break
      }
      case InsertEventType.INSERT_REQUEST_VIDEO:{
        this.debugLog('addEvents --insertRequestingVideo')
        this.dispatchVideoSqueezeLayers();
        break
      }
      case InsertEventType.INSERT_SQUEEZE_START:{
        this.debugLog('addEvents --insertSqueezeStart')
        //this.timers.updateCXOTimer.execute();
        this.lockCXO = true;
        break
      }
      case InsertEventType.INSERT_SQUEEZE_FINISH:{
        this.debugLog('addEvents --insertSqueezeFinish')
        new CustomTimeout(()=>{
          this.lockCXO = false;
          this.timers.updateCXOTimer.execute();
        }, 20, 'Unlock CXO Timer', this.logManager, LogType.CXO);
        
        break
      }
      case InsertEventType.INSERT_TRACKING_EVENT:{
        const eventAction: InsertAnalyticsEventType = evt.detail.action;
        switch(eventAction){
          case InsertAnalyticsEventType.CLICKTHROUGH:
            this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_CLICKTHROUGH, this.getOriginSourceFromData(eventResource), eventResource.seat, eventResource.campaignId, eventResource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, insertUniqueId, this.activeResource.tagName, (!isNil(eventResource?.data?.w))?`${eventResource?.data?.w}x${eventResource?.data?.h}`:null, eventResource.adOpportunityId, eventResource.bidRequestId, this.overlayUtilities.containerViewabilityValue, null, insertViewability);
            break;
          case InsertAnalyticsEventType.PRIVACY_CLICKTHROUGH:
            this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_PRIVACY_CLICKTHROUGH, this.getOriginSourceFromData(eventResource), eventResource.seat, eventResource.campaignId, eventResource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, insertUniqueId, this.activeResource.tagName, (!isNil(eventResource?.data?.w))?`${eventResource?.data?.w}x${eventResource?.data?.h}`:null, eventResource.adOpportunityId, eventResource.bidRequestId, this.overlayUtilities.containerViewabilityValue, null, insertViewability);
            break;
          case InsertAnalyticsEventType.LOGO_CLICKTHROUGH:
            this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_LOGO_CLICKTHROUGH, this.getOriginSourceFromData(eventResource), eventResource.seat, eventResource.campaignId, eventResource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, insertUniqueId, this.activeResource.tagName, (!isNil(eventResource?.data?.w))?`${eventResource?.data?.w}x${eventResource?.data?.h}`:null, eventResource.adOpportunityId, eventResource.bidRequestId, this.overlayUtilities.containerViewabilityValue, null, insertViewability);
            break;
          case InsertAnalyticsEventType.OUTBRAIN_CLICKTHROUGH:
            this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_OUTBRAIN_CLICKTHROUGH, this.getOriginSourceFromData(eventResource), eventResource.seat, eventResource.campaignId, eventResource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, insertUniqueId, this.activeResource.tagName, (!isNil(eventResource?.data?.w))?`${eventResource?.data?.w}x${eventResource?.data?.h}`:null, eventResource.adOpportunityId, eventResource.bidRequestId, this.overlayUtilities.containerViewabilityValue, null, insertViewability);
            break;
        }
        break
      }
      case InsertEventType.INSERT_BANNER_BLOCKED:{
        this.debugLog('Banner blocked notification received from insert.', [LogType.CXO, LogType.QA]);
        this.overlayUtilities.attemptRebid(2000, this.rebidBannerSizeAllowedDeviation, this.getOriginSourceFromData(eventResource));

        this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_BANNER_BLOCKED, this.getOriginSourceFromData(eventResource), eventResource.seat, eventResource.campaignId, eventResource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, insertUniqueId, this.activeResource.tagName, (!isNil(eventResource?.data?.w))?`${eventResource?.data?.w}x${eventResource?.data?.h}`:null, eventResource.adOpportunityId, eventResource.bidRequestId, this.overlayUtilities.containerViewabilityValue, null, insertViewability);
        break
      }
      case InsertEventType.INSERT_BANNER_FAILED:{
        this.debugLog('Banner load failed notification received from insert.', [LogType.CXO, LogType.QA]);
        this.overlayUtilities.attemptRebid(2000, this.rebidBannerSizeAllowedDeviation, this.getOriginSourceFromData(eventResource));

        this.analyticsEventDispatcher.sendInsertFailedEvent(AnalyticsEventType.INSERT_BANNER_LOAD_FAILED, this.getOriginSourceFromData(eventResource), eventResource.seat, eventResource.campaignId, eventResource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, insertUniqueId, this.activeResource.tagName, (!isNil(eventResource?.data?.w))?`${eventResource?.data?.w}x${eventResource?.data?.h}`:null, eventResource.adOpportunityId, eventResource.bidRequestId, eventResource.data?.banner, this.overlayUtilities.containerViewabilityValue, null, insertViewability);
        break
      }
      case InsertEventType.INSERT_GPT_FAILED:{
        this.debugLog('ADX load failed notification received from insert.', [LogType.CXO, LogType.QA]);

        const originSource: BidOriginSourceType = this.getOriginSourceFromData(eventResource);

        const responseData: BidResponseData = {
          overlayTime: this.overlayUtilities.elapsedOverlayTime/1000,
          activeOverlayTime: this.overlayUtilities.activeOverlayTime/1000,
          totalBidsCount: this.overlayUtilities.bidCount,
          adOpportunityBidCount: (this.overlayUtilities.rebidCount + 1),
          adOpportunityId: this.overlayUtilities.adOpportunityId,
          bidRequestId: this.overlayUtilities.bidRequestId,
          bidCpm: 0,
          cid: 'ADX',
          crid: null,
          seatId: null,
          adId: null,
          bidId: null,
          impressionType: ImpressionType.DISPLAY,
          componentDimensions: {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height},
          containerViewability: this.overlayUtilities.containerViewabilityValue,
          videoTime: (!isNil(this.videoElement))?this.videoElement.currentTime:0,
        }
        if(!isNil(eventResource?.data?.w)){
          responseData.bannerSize = `${eventResource?.data?.w}x${eventResource?.data?.h}`;
        }
        if(originSource === BidOriginSourceType.OSD){
          this.overlayUtilities.osdConfig.eventData['isSafeframe'] = params.safeframe;
          let debugData: {[key:string]:any} = this.overlayUtilities.cleanOSDResponseData(this.overlayUtilities.osdConfig?.eventData);
          responseData.debug = debugData;
          responseData.bidCpm = debugData?.osdData?.pbjs_won?.cpm || 0;
        }

        this.analyticsEventDispatcher.sendBidResponseEvent(AnalyticsEventType.BID_RESPONSE_EMPTY, originSource, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, responseData);

        this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_LOAD_FAILED, originSource, eventResource.seat, eventResource.campaignId, eventResource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, insertUniqueId, this.activeResource.tagName, `${eventResource?.data?.w}x${eventResource?.data?.h}`, eventResource.adOpportunityId, eventResource.bidRequestId, this.overlayUtilities.containerViewabilityValue, null, insertViewability);

        this.overlayUtilities.attemptRebid(2000, this.rebidBannerSizeAllowedDeviation, originSource);
          
        break
      }
      case InsertEventType.INSERT_GPT_RENDER_FAILED:{
        this.debugLog('OSD render failed notification received from insert.', [LogType.CXO, LogType.QA]);

        const originSource: BidOriginSourceType = this.getOriginSourceFromData(eventResource);

        const responseData: BidResponseData = {
          overlayTime: this.overlayUtilities.elapsedOverlayTime/1000,
          activeOverlayTime: this.overlayUtilities.activeOverlayTime/1000,
          totalBidsCount: this.overlayUtilities.bidCount,
          adOpportunityBidCount: (this.overlayUtilities.rebidCount + 1),
          adOpportunityId: this.overlayUtilities.adOpportunityId,
          bidRequestId: this.overlayUtilities.bidRequestId,
          bidCpm: 0,
          cid: 'ADX',
          crid: null,
          seatId: null,
          adId: null,
          bidId: null,
          impressionType: ImpressionType.DISPLAY,
          componentDimensions: {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height},
          containerViewability: this.overlayUtilities.containerViewabilityValue,
          videoTime: (!isNil(this.videoElement))?this.videoElement.currentTime:0,
        }
        if(!isNil(eventResource?.data?.w)){
          responseData.bannerSize = `${eventResource?.data?.w}x${eventResource?.data?.h}`;
        }
        if(originSource === BidOriginSourceType.OSD){
          let debugData: {[key:string]:any} = this.overlayUtilities.cleanOSDResponseData(this.overlayUtilities.osdConfig?.eventData);
          
          responseData.debug = debugData;
          responseData.debug.reason = 'GPT_RENDER_FAILED';
          responseData.bidCpm = debugData?.osdData?.pbjs_won?.cpm || 0;
        }

        this.analyticsEventDispatcher.sendBidResponseEvent(AnalyticsEventType.BID_RESPONSE_EMPTY, originSource, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, responseData);

        this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_LOAD_FAILED, originSource, eventResource.seat, eventResource.campaignId, eventResource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, insertUniqueId, this.activeResource.tagName, `${eventResource?.data?.w}x${eventResource?.data?.h}`, eventResource.adOpportunityId, eventResource.bidRequestId, this.overlayUtilities.containerViewabilityValue, null, insertViewability);

        this.overlayUtilities.attemptRebid(2000, this.rebidBannerSizeAllowedDeviation, originSource);
          
        break
      }
      case InsertEventType.INSERT_VIEWED_EVENT:{
        this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_VIEWED, this.getOriginSourceFromData(eventResource), eventResource.seat, eventResource.campaignId, eventResource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, insertUniqueId, this.activeResource.tagName, (!isNil(eventResource?.data?.w))?`${eventResource?.data?.w}x${eventResource?.data?.h}`:null, eventResource.adOpportunityId, eventResource.bidRequestId, this.overlayUtilities.containerViewabilityValue, null, insertViewability);
        break;
      }
      case InsertEventType.INSERT_REQUEST_OSD_REFRESH:{
        if(eventResource.data.isPrebid){
          this.overlayUtilities.osdConfig.eventData = {};
          const slotParams: any = this.overlayUtilities.osdConfig.slotRefreshParams;
          if(typeof slotParams.gptAdUnitId !== 'undefined' && slotParams.gptAdUnitId !== null && typeof slotParams.gtagObject !== 'undefined' && slotParams.gtagObject !== null){
            const allowedSizes: number[][] = this.overlayUtilities.osdConfig.availableAdSizes ?? [[300, 250],[336, 280],[300, 600],[300, 1080],[234, 60],[320, 50],[468, 60],[728, 90],[970, 90]];
            if(this.overlayUtilities.osdConfig.osdRefresh == null){
              this.debugLog('OSD refresh function is undefined. Will create new OSD refresh function.', [LogType.CXO, LogType.QA]);
              this.overlayUtilities.osdConfig.osdRefresh ??= this.overlayUtilities.initializeOSDRefresh(slotParams.gptAdUnitId, slotParams.bidderArray, slotParams.gtagObject, slotParams.pbjsObject, allowedSizes);
              
              this.debugLog(['Created OSD refresh function:', this.overlayUtilities.osdConfig.osdRefresh], [LogType.CXO, LogType.QA]);
            }
            //this.debugLog('INSERT OSD REFRESH TRIGGERED', LogType.IMPORTANT);
            this.overlayUtilities.osdConfig.osdRefresh(evt.detail.div, [[eventResource?.data?.w,eventResource?.data?.h]], this.overlayUtilities.osdConfig.eventData);
          }
        }
        break
      }
    }
  }

  airTvAdImpression(e: Event){
    this.airTVisAdvertisement = true
    this.airTVEventsEstablished = true
    this.debugLog(['AirTV Ad Impression: ', e], [LogType.QA, LogType.CXO]);
  }

  airTvAdBreakEnd(e: Event){
    this.airTVisAdvertisement = false
    this.airTVEventsEstablished = true
    this.debugLog(['AirTV Ad Break End: ', e], [LogType.QA, LogType.CXO]);
  }

  airTvPlayerReady(e: Event){
    this.airTVEventsEstablished = true
    this.debugLog(['The ATV Player is ready: ', e], LogType.CXO);
  }

  airTvVideoInit(e: Event){
    this.airTVEventsEstablished = true
    this.debugLog(['The ATV Player engaged: ', e], LogType.CXO);
  }

  airTvPlay(e: Event){
    this.airTVEventsEstablished = true
    this.debugLog(['The ATV Player play: ', e], LogType.CXO);
  }

  airTvPause(e: Event){
    this.airTVEventsEstablished = true
    this.debugLog(['The ATV Player pause: ', e], LogType.CXO);
  }

  windowResize(){
    this.debugLog('windowResize');
    if(this.timers.remakeADXInsertTimer.timeRemainingInSeconds > 0){
      this.timers.remakeADXInsertTimer.reset(1000);
    }
    this.timers.updateCXOTimer.execute();
    this.timers.updateCXOTimer.reset(100);
  }

  windowScroll(){
    this.debugLog('windowScroll');
    this.timers.windowScrollTimer.reset(50);
    this.timers.updateCXOTimer.execute();
    this.timers.updateCXOTimer.reset(100);
  }

  touchMove(){
    this.debugLog('touchMove');
    this.timers.windowScrollTimer.reset(1000);
    this.timers.updateCXOTimer.execute();
    this.timers.updateCXOTimer.reset(100);
  }

  /* POST MESSAGE EXAMPLE:
  var cxmessage = {
      target: 'CXOVERLAY',
      message: 'CREATE_BANNER_INSERT',
      params: {
        w: 300,
        h: 600,
        adm: `<versus-widget x-type="sidebar" x-id="4e71dbe5-95d5-4bb3-a72e-1bfd2738e5b6" x-min-height="720px" x-max-height="720px" x-min-width="200px" x-max-width="200px">
        Please enable Javascript to view this content</versus-widget>
        <script src="https://minigames.versusgame.com/widget/versus-widget.js"></script>`
      }
    }
    window.postMessage(cxmessage, '*');
    document.querySelectorAll("iframe").forEach(i=>{
        i.contentWindow.postMessage(cxmessage, '*');
    }
  )
*/
  messageReceived(evt: Event){
    try{
        const data: any = (evt as any).data;
        if(typeof data.target !== 'undefined' && data.target === 'CXOVERLAY'){
          this.debugLog([`CXO 'message' received:`, evt], [LogType.IMPORTANT]);
          if(data?.message === 'CREATE_INSERT' || data?.message === 'CREATE_NATIVE_INSERT'){
            const headline: string = data.params?.headline ?? null;
            const subheadline: string = data.params?.subheadline ?? null;
            const cta: string = data.params?.cta ?? null;
            const image: string = data.params?.image ?? null;
            const icon: string = data.params?.icon ?? null;
            this.debugLog([`Create native insert request received through postMessage.\n
            headline = ${headline}\n
            subheadline = ${subheadline}\n
            cta = ${cta}\n
            image = ${image}\n
            icon = ${icon}`], [LogType.IMPORTANT]);
            this.generateNativeInsert(headline, subheadline, cta, image, icon);
          }else if(data?.message === 'CREATE_BANNER_INSERT'){
            const w: number = data.params?.w ?? null;
            const h: number = data.params?.h ?? null;
            const adm: string = data.params?.adm ?? null;
            const frameSafe: boolean = data.params?.frameSafe ?? true;
            this.debugLog([`Create banner insert request received through postMessage.\n
            width = ${w}\n
            height = ${h}\n
            adm = ${adm}\n
            frameSafe = ${frameSafe}`], [LogType.IMPORTANT]);
            this.generateBannerInsert(adm, w, h, frameSafe);
          }else if(data?.message === 'LOCK_CXO'){
            this.lockCXO = true;
            this.debugLog([`Overlay LockCXO request received through postMessage.\n
            lockCXO = ${this.lockCXO}`], [LogType.IMPORTANT]);
          }else if(data?.message === 'UNLOCK_CXO'){
            this.lockCXO = false;
            this.debugLog([`Overlay UnlockCXO request received through postMessage.\n
            lockCXO = ${this.lockCXO}`], [LogType.IMPORTANT]);
          }else if(data?.message === 'LOCK_MARGIN'){
            this.lockMargin = true;
            this.debugLog([`Overlay LockMargin request received through postMessage.\n
            lockMargin = ${this.lockMargin}`], [LogType.IMPORTANT]);
          }else if(data?.message === 'UNLOCK_MARGIN'){
            this.lockMargin = false;
            this.debugLog([`Overlay UnlockMargin request received through postMessage.\n
            lockMargin = ${this.lockMargin}`], [LogType.IMPORTANT]);
          }else if(data?.message === 'LOCK_DIMENSIONS'){
            this.lockDimensions = true;
            this.debugLog([`Overlay LockDimensions request received through postMessage.\n
            lockDimensions = ${this.lockDimensions}`], [LogType.IMPORTANT]);
          }else if(data?.message === 'UNLOCK_DIMENSIONS'){
            this.lockDimensions = false;
            this.debugLog([`Overlay UnlockDimensions request received through postMessage.\n
            lockDimensions = ${this.lockDimensions}`], [LogType.IMPORTANT]);
          }else if(data?.message.includes('LOGMODE_')){
            const modeType: string = data?.message.split('_')[1];
            switch(modeType.toUpperCase()){
              case 'ALL':
                this.logManager.logMode = LogType.ALL;
                break;
              case 'MOST':
                this.logManager.logMode = `${LogType.INFO}-${LogType.QA}-${LogType.ERROR}-${LogType.INSERT}-${LogType.IMPORTANT}`;
                break;
              case 'QA':
                this.logManager.logMode = `${LogType.INFO}-${LogType.QA}-${LogType.ERROR}`;
                break;
              case 'NONE':
                this.logManager.logMode = `${LogType.NONE}`;
                break;
            }
            this.debugLog([`LogMode change request received through postMessage.\n
            logMode = ${this.logManager.logMode}`], [LogType.IMPORTANT]);
          }
        }
    }catch(err){
      //this.debugLog([`ERROR ON CXO messageRecieved`, err], [LogType.ERROR]);
    }
  }

  visibilityChange(evt: Event){
    if (document.visibilityState == "visible") {
      this.debugLog([`visibilityChange: Tab is active - total activeOverlayTime=${this.overlayUtilities.activeOverlayTime}`, evt], [LogType.CXO, LogType.QA]);
      this.overlayUtilities.activeOverlayDate = (new Date()).getTime();
    } else {
      this.debugLog([`visibilityChange: Tab is inactive - total activeOverlayTime=${this.overlayUtilities.activeOverlayTime}`, evt], [LogType.CXO, LogType.QA]);
      this.overlayUtilities.activeOverlayDate = 0;
    }
  }

  windowScrollStopped(){
    this.debugLog('addEvents-scroll - User stopped scrolling.', [LogType.CXO, LogType.QA]);
    /*
    if(this.overlayUtilities.currentDimensions.isFloating){
      this.floatingJumpCount = 0;
      this.compareFloatingPlayerPosition();
    }
    */
    this.timers.updateCXOTimer.execute();
  }

  dispatchVideoSqueezeLayers(){
    if(this.videoPlayerLost){
      this.timers.checkLostVideoPlayerTimer.execute();
    }
    const videoElements: SqueezeElements = {
      mainElement: this.videoElement ?? null,
      interfaceElements: this.squeezebackResizeLayers ?? [],
      hideElements: this.squeezebackHideLayers ?? []
    }
    this.overlayUtilities.dispatchOverlayEvent({
      type:OverlayEventType.OVERLAY_HANDOFF_VIDEO,
      videoElements:videoElements
    });
  }

  dispatchExternalOverlayEvent(name: OverlayExternalEventType, params: Object = {}, dispatchOnTopWindow: boolean = false) {
    const insertEvent: CustomEvent = new CustomEvent(name, {
      bubbles: true,
      detail: params
    })
    if(!dispatchOnTopWindow){
      this.debugLog([`Dispatching event to window:${name} - ${JSON.stringify(params)}`], [LogType.QA, LogType.CXO]);
      this.videoElement.dispatchEvent(insertEvent)
    }else{
      try{
        this.debugLog([`Dispatching event to TOP (above iframe) window:${name} - ${JSON.stringify(params)}`], [LogType.QA, LogType.CXO]);
        window.top.dispatchEvent(insertEvent);
      }catch(err){
        this.debugLog(`Unable to dispatch event ${name} to window.top.`, [LogType.QA, LogType.CXO]);
      }
    }
  }

  onTrackLoad = () => {
    this.cues = this.trackElement.track.cues as CueList
  }

  onCueChange = () => {
    this.debugLog('onCueChange')

    const cues = (this.trackElement.track.activeCues as CueList) || []
    this.debugLog('onCueChange' +
      `\n --foundNumberActiveCues = ${cues.length}`)

    for (const cue of cues) {
      this.debugLog('onCueChange' +`\n --cueText = ${cue.text}`)
      
      if(!this.currentVideoStatus.timerBasedBidding){
        this.overlayUtilities.forceNextBid = true;
        this.overlayUtilities.forceNextInsert = true;
        this.overlayUtilities.rebidCount = 0;
        this.overlayUtilities.resetCarouselData();
        this.overlayUtilities.initiateBidRequestTimer.execute();
        this.trackElement.track.removeCue(cue)
      }else{
        this.debugLog('Timer based bidding - ignoring monetize moments from video track.', [LogType.CXO, LogType.QA]);
      }
      
    }
    this.debugLog('onCueChange --cueChangeEnd')
  }

  generateBidLogicParameters(): BidLogicParameters {
    const params: BidLogicParameters = {
      updateCXO: this.updateCXO.bind(this),
      cancelRemakeADXInsertTimer: this.timers.remakeADXInsertTimer.cancel.bind(this),
      generateADXInsert: this.generateADXInsert.bind(this),
      generateNativeInsert: this.generateNativeInsert.bind(this),
      generateOSDInsert: this.generateOSDInsert.bind(this),
      handleResourceResponse: this.handleResourceResponse.bind(this),
      setNextAutomaticBidTime: this.setNextAutomaticBidTime.bind(this),
      isFullscreenVideoNode: this.isFullscreenVideoNode,
      isVideoOnPage: this.isVideoOnPage,
      rebidBannerSizeAllowedDeviation: this.rebidBannerSizeAllowedDeviation,
      stowedBidResponse: this.stowedBidResponse,
      preferredBannerSize: this.preferredBannerSize,
      cxWait: this.cxWait,
      nobid: this.nobid,
      currentElementStatus: this.currentVideoStatus,
      carouselResource: this.carouselResource,
      videoElement: this.videoElement,
      activeMediaId: this.activeMediaId,
      activeLogicalVideoId: this._activeLogicalVideoId,
      marketplaceId: this.marketplaceId,
      storeId: this.storeId,
      bundleId: this.bundleId
    }
    return params;
  }

  handleManualBidRequestEvent(e: Event){
    this.debugLog(['Manual bid event Recieved: ', e], [LogType.QA, LogType.CXO]);
    const manualBidRequestTimeElapsed = this.overlayUtilities.initiateManualBidRequestTimer.timeRemainingInSeconds;
    if(this.overlayUtilities.initiateManualBidRequestTimer.timeRemainingInSeconds > 0) {
      this.debugLog(['Manual bid has already been requested, seconds remaining until next manual bid triggers: ', manualBidRequestTimeElapsed], [LogType.QA, LogType.CXO]);
    } else {
      this.debugLog(['Attempting to initiate manually triggered bid request'], [LogType.QA, LogType.CXO]);
      this.overlayUtilities.initiateManualBidRequestTimer.execute();
    }
  }

  handleResourceResponse(resourceData){
    if(!isNil(resourceData?.resources) && resourceData.resources.length > 0){
      if(!this.cxWait){
        this.processBidResponse(resourceData);
      }else{
        this.stowedBidResponse = resourceData;
        this.debugLog('cx-wait attribute added during bid request. Will not show response insert.', [LogType.ERROR, LogType.CXO, LogType.QA]);
        const returnedResources = resourceData.resources;
        
        const responseSource: BidOriginSourceType = (resourceData.isRevContentBid)?BidOriginSourceType.REV_CONTENT:(resourceData.isOutbrainBid)?BidOriginSourceType.OUTBRAIN:BidOriginSourceType.ADK;
        
        const responseData: BidResponseData = {
          overlayTime: this.overlayUtilities.elapsedOverlayTime/1000,
          activeOverlayTime: this.overlayUtilities.activeOverlayTime/1000,
          totalBidsCount: this.overlayUtilities.bidCount,
          adOpportunityBidCount: (this.overlayUtilities.rebidCount + 1),
          adOpportunityId: this.overlayUtilities.adOpportunityId,
          bidRequestId: this.overlayUtilities.bidRequestId,
          bidCpm: returnedResources[0]?.bid,
          cid: returnedResources[0]?.campaignId,
          crid: returnedResources[0]?.creativeId,
          seatId: returnedResources[0]?.seat,
          adId: returnedResources[0]?.adId,
          bidId: returnedResources[0]?.bidId,
          impressionType: returnedResources[0]?.impressionType,
          componentDimensions: {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height},
          containerViewability: this.overlayUtilities.containerViewabilityValue,
          videoTime: (!isNil(this.videoElement))?this.videoElement.currentTime:0,
        }
        if(!isNil(returnedResources[0]?.data?.w)){
          responseData.bannerSize = `${returnedResources[0]?.data?.w}x${returnedResources[0]?.data?.h}`;
        }
        this.analyticsEventDispatcher.sendBidResponseEvent(AnalyticsEventType.BID_RESPONSE, responseSource, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, responseData);
          
        const debugData: {[key: string]:any} = {
          message: 'CXWAIT_TRUE'
        }
        this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_CREATION_DELAYED, (resourceData.isRevContentBid)?BidOriginSourceType.REV_CONTENT:(resourceData.isOutbrainBid)?BidOriginSourceType.OUTBRAIN:BidOriginSourceType.ADK, resourceData.seat, resourceData.campaignId, resourceData.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, null, InsertType.NONE, (!isNil(returnedResources?.[0]?.data?.w))?`${returnedResources[0].data.w}x${returnedResources[0].data.h}`:null, this.overlayUtilities.adOpportunityId, this.overlayUtilities.bidRequestId, this.overlayUtilities.containerViewabilityValue, debugData);
      }
    }else{
      this.debugLog(`No results returned in bid request ${this.overlayUtilities.bidCount}.`, [LogType.CXO, LogType.QA]);

      const responseData: BidResponseData = {
        overlayTime: this.overlayUtilities.elapsedOverlayTime/1000,
        activeOverlayTime: this.overlayUtilities.activeOverlayTime/1000,
        totalBidsCount: this.overlayUtilities.bidCount,
        adOpportunityBidCount: (this.overlayUtilities.rebidCount + 1),
        adOpportunityId: this.overlayUtilities.adOpportunityId,
        bidRequestId: this.overlayUtilities.bidRequestId,
        bidCpm: 0,
        cid: null,
        crid: null,
        seatId: null,
        adId: null,
        bidId: null,
        impressionType: (resourceData.isRevContentBid || resourceData.isOutbrainBid)?ImpressionType.NATIVE:ImpressionType.ANY,
        componentDimensions: {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height},
        containerViewability: this.overlayUtilities.containerViewabilityValue,
        videoTime: (!isNil(this.videoElement))?this.videoElement.currentTime:0,
      }
      this.analyticsEventDispatcher.sendBidResponseEvent(AnalyticsEventType.BID_RESPONSE_EMPTY, (resourceData.isRevContentBid)?BidOriginSourceType.REV_CONTENT:(resourceData.isOutbrainBid)?BidOriginSourceType.OUTBRAIN:BidOriginSourceType.ADK, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, responseData);
      
      this.overlayUtilities.attemptRebid(1000, this.rebidBannerSizeAllowedDeviation)
    }
  }

  processBidResponse(resourceData){
    const returnedResources: Resource[] = resourceData?.resources ?? [];

    this.inserts = this.inserts.concat(returnedResources);
    const insertArrayLogType: LogType[] = (this.inserts.length > 2)?[LogType.IMPORTANT, LogType.QA, LogType.CXO]:[LogType.CXO];
    this.debugLog([`Insert array (length = ${this.inserts.length}):`, this.inserts], insertArrayLogType);
    
    this.identifyImageryToPreload();

    let seats: string = (returnedResources.length > 0)?' from seatid':'';
    returnedResources.forEach(x => seats += ' ' + x.seat);
    let cids: string = (returnedResources.length > 0)?' cid':'';
    returnedResources.forEach(x => cids += ' ' + x.campaignId);
    let crids: string = (returnedResources.length > 0)?' crid':'';
    returnedResources.forEach(x => crids += ' ' + x.creativeId);
    this.debugLog(`CX bid ${this.overlayUtilities.bidCount} returned ${returnedResources.length} resource(s). ${seats} ${cids} ${crids}`, [LogType.CXO, LogType.QA]);
    
    if(returnedResources.length > 0){
      
      const responseSource: BidOriginSourceType = (resourceData.isRevContentBid)?BidOriginSourceType.REV_CONTENT:(resourceData.isOutbrainBid)?BidOriginSourceType.OUTBRAIN:BidOriginSourceType.ADK;

      const responseData: BidResponseData = {
        overlayTime: this.overlayUtilities.elapsedOverlayTime/1000,
        activeOverlayTime: this.overlayUtilities.activeOverlayTime/1000,
        totalBidsCount: this.overlayUtilities.bidCount,
        adOpportunityBidCount: (this.overlayUtilities.rebidCount + 1),
        adOpportunityId: this.overlayUtilities.adOpportunityId,
        bidRequestId: this.overlayUtilities.bidRequestId,
        bidCpm: returnedResources[0]?.bid,
        cid: returnedResources[0]?.campaignId,
        crid: returnedResources[0]?.creativeId,
        seatId: returnedResources[0]?.seat,
        adId: returnedResources[0]?.adId,
        bidId: returnedResources[0]?.bidId,
        impressionType: returnedResources[0]?.impressionType,
        componentDimensions: {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height},
        containerViewability: this.overlayUtilities.containerViewabilityValue,
        videoTime: (!isNil(this.videoElement))?this.videoElement.currentTime:0,
      }
      if(!isNil(returnedResources[0]?.data?.w)){
        responseData.bannerSize = `${returnedResources[0]?.data?.w}x${returnedResources[0]?.data?.h}`;
      }
      this.analyticsEventDispatcher.sendBidResponseEvent(AnalyticsEventType.BID_RESPONSE, responseSource, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, responseData);

      if(this.overlayUtilities.forceNextInsert && !isNil(this.carouselResource)){
        this.clearCarouselInsert();
      }

      returnedResources.forEach(res => {
        res.uniqueId = this.overlayUtilities.generateUniqueId;
        res.bidRequestId = this.overlayUtilities.bidRequestId;
        res.adOpportunityId = this.overlayUtilities.adOpportunityId;
        res.impressionFired = false;
        if(resourceData.isRevContentBid){
          res.data.isRevContentBid = true;
        }
        if(resourceData.isOutbrainBid){
          res.data.isOutbrainBid = true;
          this.overlayUtilities.outbrainToken ??= res.outbrainToken;
          res.creativeId = 'OUTBRAIN';
          res.campaignId = 'OUTBRAIN';
        }
        this.debugLog(['Full resource at bid response: ', res], [LogType.CXO, LogType.QA]);
        this.debugLog(`Insert type:  ${res.impressionType}`,  [LogType.CXO, LogType.QA]);
        const bannerAllowIframeLoadParam = this.logManager.getDebugParamValue(DebugURLParams.BANNER_ALLOW_IFRAME_LOAD);
        if(bannerAllowIframeLoadParam !== null){
          const frameSafeParam: boolean = (bannerAllowIframeLoadParam.indexOf('t')>=0)?true:false;
          res.frameSafe = frameSafeParam;
          this.debugLog('Forcing frameSafe toggle to ' + frameSafeParam, [LogType.QA, LogType.CXO]);
        }
      })

      if(isNil(this.activeResource) || isNil(this.carouselResource)){
        const nextResource: Resource = this.nextAvailableResource;
        if(nextResource?.impressionType === ImpressionType.VIDEO){
          this.processVideoResource(nextResource);
        }else if(nextResource?.impressionType === ImpressionType.NATIVE || nextResource?.impressionType === ImpressionType.DISPLAY){
          this.processStandardResource(nextResource);
        }
      }
      
    }else{
      this.debugLog(`No results returned in bid request ${this.overlayUtilities.bidCount}.`, [LogType.CXO, LogType.QA]);

      const responseSource: BidOriginSourceType = (resourceData.isADX)?BidOriginSourceType.ADX:(resourceData.isRevContentBid)?BidOriginSourceType.REV_CONTENT:(resourceData.isOutbrainBid)?BidOriginSourceType.OUTBRAIN:BidOriginSourceType.ADK;
      
      const responseData: BidResponseData = {
        overlayTime: this.overlayUtilities.elapsedOverlayTime/1000,
        activeOverlayTime: this.overlayUtilities.activeOverlayTime/1000,
        totalBidsCount: this.overlayUtilities.bidCount,
        adOpportunityBidCount: (this.overlayUtilities.rebidCount + 1),
        adOpportunityId: this.overlayUtilities.adOpportunityId,
        bidRequestId: this.overlayUtilities.bidRequestId,
        bidCpm: 0,
        cid: null,
        crid: null,
        seatId: null,
        adId: null,
        bidId: null,
        impressionType: (resourceData.isRevContentBid || resourceData.isOutbrainBid)?ImpressionType.NATIVE:ImpressionType.ANY,
        componentDimensions: {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height},
        containerViewability: this.overlayUtilities.containerViewabilityValue,
        videoTime: (!isNil(this.videoElement))?this.videoElement.currentTime:0,
      }

      this.analyticsEventDispatcher.sendBidResponseEvent(AnalyticsEventType.BID_RESPONSE_EMPTY, responseSource, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, responseData);

      this.overlayUtilities.attemptRebid(1000, this.rebidBannerSizeAllowedDeviation);
    }
  }

  processVideoResource(res:Resource){
    fetchVASTWrapper(res.data.video.url).then((response) => {
      //this.debugLog(['Vast wrapper response:', response], LogType.IMPORTANT);
      const tagTree = (new DOMParser()).parseFromString(response, "application/xml")
      const vastCreativeURL = tagTree.querySelector('VASTAdTagURI').innerHTML.replace(/<!\[CDATA\[|]]>/g, "")
      this.debugLog(['requesting VAST video from URL: ', vastCreativeURL], [LogType.CXO, LogType.QA])
      fetchVASTVideo(vastCreativeURL).then((videoResponse)=>{
        //this.debugLog(['Vast video response:', videoResponse], LogType.IMPORTANT);
        const creativeTree = (new DOMParser()).parseFromString(videoResponse, "application/xml")
        const vastVideoURL = creativeTree.querySelector('MediaFile').innerHTML.replace(/<!\[CDATA\[|]]>/g, "")
        this.debugLog(['Vast video source url:', vastVideoURL], [LogType.CXO, LogType.QA])
        res.data.video.url = vastVideoURL
        res.data.video.trackers = {}
        const trackers: {[key:string]: string[]} = res.data.video.trackers;
        let trackerURL: NodeListOf<HTMLElement>= creativeTree.querySelectorAll('Tracking[event="firstQuartile"]')
        if(trackerURL.length > 0){
          trackers.firstQuartile = []
          trackerURL.forEach(url => trackers.firstQuartile.push(url.innerHTML.replace(/<!\[CDATA\[|]]>/g, "")))
        }
        trackerURL = creativeTree.querySelectorAll('Tracking[event="midpoint"]')
        if(trackerURL.length > 0){
          trackers.midpoint = []
          trackerURL.forEach(url => trackers.midpoint.push(url.innerHTML.replace(/<!\[CDATA\[|]]>/g, "")))
        }
        trackerURL = creativeTree.querySelectorAll('Tracking[event="thirdQuartile"]')
        if(trackerURL.length > 0){
          trackers.thirdQuartile = []
          trackerURL.forEach(url => trackers.thirdQuartile.push(url.innerHTML.replace(/<!\[CDATA\[|]]>/g, "")))
        }
        trackerURL = creativeTree.querySelectorAll('Tracking[event="complete"]')
        if(trackerURL.length > 0){
          trackers.complete = []
          trackerURL.forEach(url => trackers.complete.push(url.innerHTML.replace(/<!\[CDATA\[|]]>/g, "")))
        }
        trackerURL = creativeTree.querySelectorAll('Tracking[event="mute"]')
        if(trackerURL.length > 0){
          trackers.mute = []
          trackerURL.forEach(url => trackers.mute.push(url.innerHTML.replace(/<!\[CDATA\[|]]>/g, "")))
        }
        trackerURL = creativeTree.querySelectorAll('Tracking[event="unmute"]')
        if(trackerURL.length > 0){
          trackers.unmute = []
          trackerURL.forEach(url => trackers.unmute.push(url.innerHTML.replace(/<!\[CDATA\[|]]>/g, "")))
        }
        trackerURL = creativeTree.querySelectorAll('Tracking[event="pause"]')
        if(trackerURL.length > 0){
          trackers.pause = []
          trackerURL.forEach(url => trackers.pause.push(url.innerHTML.replace(/<!\[CDATA\[|]]>/g, "")))
        }
        trackerURL = creativeTree.querySelectorAll('Tracking[event="resume"]')
        if(trackerURL.length > 0){
          trackers.resume = []
          trackerURL.forEach(url => trackers.resume.push(url.innerHTML.replace(/<!\[CDATA\[|]]>/g, "")))
        }
        trackerURL = creativeTree.querySelectorAll('Tracking[event="fullscreen"]')
        if(trackerURL.length > 0){
          trackers.fullscreen = []
          trackerURL.forEach(url => trackers.fullscreen.push(url.innerHTML.replace(/<!\[CDATA\[|]]>/g, "")))
        }
        trackerURL = creativeTree.querySelectorAll('Tracking[event="close"]')
        if(trackerURL.length > 0){
          trackers.close = []
          trackerURL.forEach(url => trackers.close.push(url.innerHTML.replace(/<!\[CDATA\[|]]>/g, "")))
        }
        
        this.timers.updateCXOTimer.execute();

        this.timers.createNewInsertTimer.reset(0, ()=>{this.createNewInsert(res)});
        
        this.timers.checkTrackIntegrityTimer.reset(1000);

        if (!this.isCarouselStarted) {
          this.overlayUtilities.activeCarouselData.isCompleted = false;
        }

        loadComponents(this.inserts, this.isesm, this.scriptBaseURL)
      });
    });
  }

  processStandardResource(res: Resource){
    this.timers.updateCXOTimer.execute();

    this.timers.createNewInsertTimer.reset(0, ()=>{this.createNewInsert(res)});

    this.timers.checkTrackIntegrityTimer.reset(1000);

    if (!this.isCarouselStarted) {
      this.overlayUtilities.activeCarouselData.isCompleted = false;
    }

    loadComponents(this.inserts, this.isesm, this.scriptBaseURL)
  }

  createNewInsertDebugLog(logMessage: string){
    const debugLogOutput = 'createNewInsert\n' + logMessage;
    if(logMessage !== this.createNewInsertDebugLogMessage){
      this.createNewInsertDebugLogMessage = logMessage;
      this.debugLog(debugLogOutput + logMessage, [LogType.CXO, LogType.QA]);
      this.timers.createNewInsertDebugLogTimer.resetInterval(1000, 200, () => this.debugLog(debugLogOutput, [LogType.CXO, LogType.QA]));
    } else {
      this.debugLog(debugLogOutput, [LogType.CXO])
    }
  }

  clearCreateNewInsertDebugLog(){
    this.createNewInsertDebugLogMessage = '';
    this.timers.createNewInsertDebugLogTimer.cancel()
  }

  createNewInsert(res){
    if(this.insertBeingCleared){
      this.createNewInsertDebugLog('Waiting for current active insert to be cleared.');
      this.timers.createNewInsertTimer.reset(100);
    }else if(this.detectCXWaitChanges()){
      this.createNewInsertDebugLog('cxWait has been activated. Delaying insert creation.');
      this.timers.createNewInsertTimer.reset(100);
    }else if(isNil(this.activeResource) || isNil(this.carouselResource)){
      if(!this.isPreloadImageryComplete){
        this.createNewInsertDebugLog('Waiting for image preload to finish before creating insert.');
        this.timers.createNewInsertTimer.reset(100);
      }else if(this.overlayUtilities.currentDimensions.width <= 10 || this.overlayUtilities.currentDimensions.height <= 10){
        this.createNewInsertDebugLog('Current overlay height OR width is less then 10px. Waiting for size to be available for insert creation.');
        this.timers.createNewInsertTimer.reset(50);
      }else if(!this.overlayUtilities.currentDimensions.elementDimensionsStable){
        this.createNewInsertDebugLog('Current video size is not stable or is in transition. Waiting for video size to normalize before insert creation.');
        this.timers.createNewInsertTimer.reset(100);
      }else if(this.inserts.indexOf(res) === -1){
        this.clearCreateNewInsertDebugLog();
        this.debugLog('createNewInsert\nProvided resource is no longer available in the inserts array. Will not continue insert creation.', [LogType.CXO, LogType.QA]);
      }else{
        this.clearCreateNewInsertDebugLog();
        this.debugLog(`createNewInsert - ${this.overlayUtilities.currentDimensions.width}x${this.overlayUtilities.currentDimensions.height} --insert = ` + JSON.stringify(res), LogType.CXO);

        const isSecondaryInsert: boolean = Boolean(!isNil(this.activeResource));
        const newInsert: HTMLElement = this.createInsert(res, isSecondaryInsert);
  
        if(!isNil(newInsert)){
          this.debugLog(`createNextInsert:\n --addedResource = ${newInsert.tagName}`, LogType.CXO);

          let expectedTypes: InsertType[] = this.getAvailableInserts(this.overlayUtilities.groupConfig.insertConfig).map(x=>{return x.insertType});

          this.debugLog(['Player mode at insert creation: \n    ' + this.playerMode], [LogType.CXO, LogType.QA]);
          this.debugLog(['Expected insert types: ('+this.playerMode+')\n'+expectedTypes.toString()], [LogType.CXO, LogType.QA]);
          this.debugLog(['Insert created: \n    ' + newInsert.tagName.toLowerCase()], [LogType.CXO, LogType.QA]);
          this.overlayTimerElement.appendChild(newInsert);
  
          if(this.overlayTimerElement.style.getPropertyValue('opacity') == '0'){
            this.overlayTimerElement.style.setProperty('opacity', '1');
          }
  
          if(!isSecondaryInsert){
            this.activeResourceData = res;
            this.activeResource = newInsert;
          }else{
            this.carouselResourceData = res;
            this.carouselResource = newInsert;
          }

          this.timers.updateCXOTimer.execute();
          this.timers.checkForVideoChangeTimer.resetInterval(50, 6000);
        }
      }
    }else{
      this.clearCreateNewInsertDebugLog();
      const debugData: {[key: string]:any} = {
        message: 'INSERT_NOT_CREATED',
        reason: 'NO_INSERT_SLOTS_AVAILABLE'
      }
      const responseSource: BidOriginSourceType = this.getOriginSourceFromData(res);
      this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_NO_IMPRESSION, responseSource, res.seat, res.campaignId, res.creativeId,this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, null, InsertType.NONE, (!isNil(res?.data?.w))?`${res.data.w}x${res.data.h}`:null, this.overlayUtilities.adOpportunityId, this.overlayUtilities.bidRequestId, this.overlayUtilities.containerViewabilityValue, debugData);
    }
  }

  identifyImageryToPreload(){
    this.debugLog(['Looking for preload imagery: ', this.inserts], [LogType.CXO]);
    if(!isNil(this.inserts)){
      this.inserts.forEach(ins => {
        const assets = (!isNil(ins?.data?.assets) && ins.data.assets.length > 0)?ins.data.assets:[];
        assets.forEach(asset =>{
          if(!isNil(asset?.img?.url)){
            const setCrossorigin: boolean = (asset?.img?.w === 1200 && asset?.img?.h === 627)?true:false;
            this.preloadImage(asset.img.url, setCrossorigin);
          }
        })
      })
    }
  }

  preloadImage(url: string, crossorigin:boolean = false){
    const id: string = 'pre'+url.replace(/[!^\W]/g, '');
    let preloadBucket: HTMLDivElement;
    if(this.overlayTimerElement.getElementsByClassName('preloadHolder').length === 0){
      preloadBucket = document.createElement('div');
      preloadBucket.setAttribute('style', 'position:absolute; width:1px; height:1px; overflow:hidden; opacity:0; top:0px; left:0px; z-index:-100; pointer-events:none;');
      preloadBucket.className = 'preloadHolder';
      this.overlayTimerElement.appendChild(preloadBucket);
      
      //Preload common imagery
      /*
      this.preloadImage(process.env.SERVER_ROOT+'/assets/inserts/shared/common_images/CatapultX-Bug.png');
      this.preloadImage(process.env.SERVER_ROOT+'/assets/inserts/shared/common_images/CatapultX-BugFlip.png');
      this.preloadImage(process.env.SERVER_ROOT+'/assets/inserts/shared/common_images/PNG_CloseButtonBackground.png');
      this.preloadImage(process.env.SERVER_ROOT+'/assets/inserts/shared/common_images/PNG_CloseButtonOutline.png');
      */
    }else{
      preloadBucket = this.overlayTimerElement.getElementsByClassName('preloadHolder')[0] as HTMLDivElement;
    };

    if(isNil(preloadBucket.querySelector('#'+id))){
      const preload: HTMLImageElement = document.createElement('img');
      preload.src = url;
      preload.id = id;
      preload.className = 'preloadImage';
      preload.setAttribute('style', 'position:absolute; display:block; opacity:0; top:0px; left:0px; z-index:-100; pointer-events:none;');
      if(crossorigin){
        preload.setAttribute('crossorigin', 'anonymous');
      }
      preloadBucket.appendChild(preload);
      this.debugLog(['Preloading image: ', id, url, preload], [LogType.QA, LogType.CXO]);
    }else{
      //this.debugLog(['Preloading image already loaded: ', url, preloadBucket.querySelector('#'+id)], [LogType.QA, LogType.CXO]);
    }
  }

  generateADXInsert(){
    if(this.overlayUtilities.isADXAvailable){
      this.debugLog(`Creating ADX with parameters pageURL=${this.overlayUtilities.groupConfig.gptAdUnitPageUrl}, unitPath=${this.overlayUtilities.groupConfig.gptAdUnitPath}`, [LogType.CXO, LogType.QA]);

      this.overlayUtilities.updateBidRequestId();

      const adxResource: Resource = {
        id: this.overlayUtilities.generateUniqueId,
        uniqueId: this.overlayUtilities.generateUniqueId,
        demand: null,
        bid: null,
        seat: 'ADX',
        bidId: null,
        campaignId: 'ADX',
        creativeId: 'ADX',
        adId: null, 
        viewabilityTrackers: null,
        tracker: null,
        created: null,
        ref: null,
        data: null,
        impressionType: null,
        win: null,
        frameSafe: null,
        bidRequestId: this.overlayUtilities.bidRequestId,
        adOpportunityId: this.overlayUtilities.adOpportunityId,
        impressionFired: false
      }

      const selectedBanner: BannerParameters = this.preferredBannerSize;

      this.debugLog(`Selected banner at generate ADX  ${selectedBanner.insertType} with size ${selectedBanner.adxSize[0]}x${selectedBanner.adxSize[1]}`, [LogType.QA, LogType.CXO]);

      const bidData:BidData = {
        overlayTime: this.overlayUtilities.elapsedOverlayTime/1000,
        activeOverlayTime: this.overlayUtilities.activeOverlayTime/1000,
        totalBidsCount: this.overlayUtilities.bidCount,
        adOpportunityBidCount: (this.overlayUtilities.rebidCount + 1),
        adOpportunityId: this.overlayUtilities.adOpportunityId,
        bidRequestId: this.overlayUtilities.bidRequestId,
        bannerSizeRequested: `${selectedBanner.adxSize[0]}x${selectedBanner.adxSize[1]}`,
        nativeImageSizeRequested: 'DEFAULT',
        componentDimensions: {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height},
        containerViewability: this.overlayUtilities.containerViewabilityValue,
        videoTime: (!isNil(this.videoElement))?this.videoElement.currentTime:0
      }

      this.analyticsEventDispatcher.sendBidEvent(AnalyticsEventType.BID_REQUEST, BidOriginSourceType.ADX, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, bidData);

      if(selectedBanner.adxSize[0] !== 0 && selectedBanner.adxSize[1] !== 0){
        adxResource.data = {
          w: selectedBanner.adxSize[0],
          h: selectedBanner.adxSize[1],
          isADX: true,
          adxInsertType: selectedBanner.insertType,
          banner: `
          <script async src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"></script>
          <script>
            window.googletag = window.googletag || {cmd: []};
            googletag.cmd.push(function() {
              googletag.defineSlot("${this.overlayUtilities.groupConfig.gptAdUnitPath}", [${selectedBanner.adxSize[0]}, ${selectedBanner.adxSize[1]}], "div-gpt-ad-1634255699423-0").
              setForceSafeFrame(true).
              addService(googletag.pubads());
              googletag.pubads().enableSingleRequest();
              googletag.pubads().set("page_url", "${this.overlayUtilities.groupConfig.gptAdUnitPageUrl}")
              googletag.enableServices();
              googletag.pubads().addEventListener('slotOnload', function(event) {
                var slotId = event.slot.getSlotElementId();
                window.parent.postMessage({
                  target: '${adxResource.id}',
                  message: '${BannerMessageType.GPT_LOAD_SUCCESSFUL}'
                },'${window.location.protocol+'//'+window.location.host}');
              });
              googletag.pubads().addEventListener('slotResponseReceived', function(event) {
                var responseInformation = event.slot.getResponseInformation();
                if(responseInformation == null){
                  window.parent.postMessage({
                    target: '${adxResource.id}',
                    message: '${BannerMessageType.GPT_LOAD_FAILED}'
                  },'${window.location.protocol+'//'+window.location.host}');
                }else{
                  window.parent.postMessage({
                    target: '${adxResource.id}',
                    message: '${BannerMessageType.GPT_RESPONSE_RECEIVED}'
                  },'${window.location.protocol+'//'+window.location.host}');
                }
              });
              googletag.pubads().addEventListener('slotRenderEnded', function(event) {
                var slotId = event.slot.getSlotElementId();
                // Record details of the rendered ad.
                var details = {
                  'Advertiser ID': event.advertiserId,
                  'Campaign ID': event.campaignId,
                  'Creative ID': event.creativeId,
                  'Is empty?': event.isEmpty,
                  'Line Item ID': event.lineItemId,
                  'Size': event.size.join('x'),
                  'Source Agnostic Creative ID': event.sourceAgnosticCreativeId,
                  'Source Agnostic Line Item ID': event.sourceAgnosticLineItemId
                }
                //console.log('Slot has finished rendering.', slotId, details);
              });
            });
          </script>
          <!-- ${this.overlayUtilities.groupConfig.gptAdUnitPath}/${selectedBanner[1]} -->
          <div id="div-gpt-ad-1634255699423-0" style="min-width: ${selectedBanner.adxSize[0]}px; min-height: ${selectedBanner.adxSize[1]}px;">
              <script>
              googletag.cmd.push(function() { googletag.display("div-gpt-ad-1634255699423-0"); });
              </script>
          </div>`
        }
        
        adxResource.impressionType = ImpressionType.DISPLAY
        
        this.timers.updateCXOTimer.execute()
        this.timers.checkTrackIntegrityTimer.reset(1000);
  
        this.inserts.push(adxResource);
  
        const nextResource: Resource = this.nextAvailableResource;
        if(!isNil(nextResource)){
          this.timers.createNewInsertTimer.reset(0, ()=>{this.createNewInsert(this.nextAvailableResource)});
        }
  
        if (!this.isCarouselStarted) {
          this.overlayUtilities.activeCarouselData.isCompleted = false;
        }
  
        loadComponents(this.inserts, this.isesm, this.scriptBaseURL)
      }
    }
  }

  generateOSDInsert(){
    if(this.isOSDAvailable){

      this.overlayUtilities.allowedBannerSizes = (this.overlayUtilities.isMobileDevice)?this.overlayUtilities.allowedOnstreamDirectMobileSizes:this.overlayUtilities.allowedOnstreamDirectDesktopSizes;
      this.rebidBannerSizeAllowedDeviation = 1;

      this.debugLog(`Creating OSD supplied insert.`, [LogType.CXO, LogType.QA]);

      this.overlayUtilities.updateBidRequestId();

      const activePrebid: Resource = (!isNil(this.activeResource) && !isNil(this.activeResourceData) && this.activeResourceData.data.isPrebid)?this.activeResourceData:null;

      const selectedBanner: BannerParameters = this.preferredBannerSize;
      const selectedSize: number[] = (!isNil(activePrebid))?[activePrebid.data.w, activePrebid.data.h]:selectedBanner.bannerSize;

      if(selectedSize[0] !== 0 && selectedSize[1] !== 0 && this.overlayUtilities.osdConfig.availableAdSizes !== null && this.overlayUtilities.osdConfig.availableAdSizes.findIndex(size => size[0] === selectedSize[0] && size[1] === selectedSize[1]) === -1){
        this.debugLog([`generatePrebidInsert - Banner size ${selectedSize[0]}x${selectedSize[1]} is not a banner size available in prebidConfig.availableAdSizes. Will not create prebid banner slot.`, this.overlayUtilities.osdConfig.availableAdSizes], [LogType.QA, LogType.IMPORTANT, LogType.CXO]);
      }else{
        const prebidResource: Resource = {
          id: this.overlayUtilities.generateUniqueId,
          uniqueId: this.overlayUtilities.generateUniqueId,
          demand: null,
          bid: null,
          seat: 'OSD',
          bidId: null,
          campaignId: 'OSD',
          creativeId: 'OSD',
          adId: null, 
          viewabilityTrackers: null,
          tracker: null,
          created: null,
          ref: null,
          data: null,
          impressionType: null,
          win: null,
          frameSafe: !(!!this.overlayUtilities.osdConfig.slotRefreshParams?.allowGAMRefresh),
          bidRequestId: this.overlayUtilities.bidRequestId,
          adOpportunityId: this.overlayUtilities.adOpportunityId,
          impressionFired: false
        }
  
        this.requestedBannerSizes.push(selectedSize);
        this.debugLog(`Selected banner at generate prebid  ${selectedBanner.insertType} with size ${selectedSize[0]}x${selectedSize[1]}. \nAdded size array to requested sizes: ${this.requestedBannerSizes}`, [LogType.QA, LogType.CXO]);
  
        const bidData:BidData = {
          overlayTime: this.overlayUtilities.elapsedOverlayTime/1000,
          activeOverlayTime: this.overlayUtilities.activeOverlayTime/1000,
          totalBidsCount: this.overlayUtilities.bidCount,
          adOpportunityBidCount: (this.overlayUtilities.rebidCount + 1),
          adOpportunityId: this.overlayUtilities.adOpportunityId,
          bidRequestId: this.overlayUtilities.bidRequestId,
          bannerSizeRequested: `${selectedSize[0]}x${selectedSize[1]}`,
          nativeImageSizeRequested: 'DEFAULT',
          componentDimensions: {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height},
          containerViewability: this.overlayUtilities.containerViewabilityValue,
          videoTime: (!isNil(this.videoElement))?this.videoElement.currentTime:0
        }
        this.analyticsEventDispatcher.sendBidEvent(AnalyticsEventType.BID_REQUEST, BidOriginSourceType.OSD, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, bidData);
  
        if(!this.overlayUtilities.osdConfig.slotRefreshParams.allowGAMRefresh || (isNil(activePrebid) && selectedSize[0] !== 0 && selectedSize[1] !== 0)){
          const generatedDivId: string = selectedBanner.insertType + '-' + prebidResource.uniqueId;
          if(this.forceBannerCustomSqueeze){
            selectedBanner.bannerSize[0] = 1200;
            selectedBanner.bannerSize[1] = 627;
          }
          prebidResource.data = {
            w: selectedBanner.bannerSize[0],
            h: selectedBanner.bannerSize[1],
            isPrebid: true,
            divId: generatedDivId,
            banner: `<div id="${generatedDivId}" style="width: ${selectedBanner.bannerSize[0]}px; height: ${selectedBanner.bannerSize[1]}px;"></div>`,
          }
          
          prebidResource.impressionType = ImpressionType.DISPLAY
          
          if(this.overlayUtilities.osdConfig.slotRefreshParams.allowGAMRefresh){
            this.timers.updateCXOTimer.execute()
            this.timers.checkTrackIntegrityTimer.reset(1000);
      
            this.inserts.push(prebidResource);
      
            const nextResource: Resource = this.nextAvailableResource;
            if(!isNil(nextResource)){
              this.timers.createNewInsertTimer.reset(0, ()=>{this.createNewInsert(this.nextAvailableResource)});
            }
      
            if (!this.isCarouselStarted) {
              this.overlayUtilities.activeCarouselData.isCompleted = false;
            }

            loadComponents(this.inserts, this.isesm, this.scriptBaseURL)
          }else{
            prebidResource.requestedInsertType = selectedBanner.insertType;
            this.overlayUtilities.osdConfig.eventData = {};
            this.overlayUtilities.initiateNoGAMPrebidAuction(this.overlayUtilities.osdConfig, [selectedSize], this.overlayUtilities.osdConfig.eventData, this.generateNoGAMPrebidInsert.bind(this), prebidResource)
          }
        }else{
          this.debugLog([`Active resource is an on-stream direct GAM insert - will refresh googletag instead of make new bid request.`], [LogType.CXO, LogType.QA]);
          if(this.overlayUtilities.forceNextRebid){
            this.overlayUtilities.resetCarouselData();
            this.debugLog(['Is carousel? ' + this.overlayUtilities.groupConfig.carouselEnabled], [LogType.CXO]);
            if (!this.isCarouselStarted && this.overlayUtilities.groupConfig.carouselEnabled && !this.overlayUtilities.activeCarouselData.isCompleted){
              const carouselBidDelay: number = (this.isOSDAvailable)?this.overlayUtilities.groupConfig.carouselSpeed:this.overlayUtilities.groupConfig.carouselSpeed-3;
              this.overlayUtilities.carouselBidTimer.reset(carouselBidDelay*1000);
              this.debugLog([`Attempting new carousel bid in ${(carouselBidDelay)} seconds.`], [LogType.CXO, LogType.QA]);
            } else if(this.isCarouselStarted){
              this.overlayUtilities.activeCarouselData.isClosed = false;
            }
          }
          this.overlayUtilities.dispatchOverlayEvent({
            type:OverlayEventType.OVERLAY_REFRESH_ACTIVE_OSD,
            forceRefresh: this.overlayUtilities.forceNextRebid
          });
        }
      }
    }
  }
  
  generateNoGAMPrebidInsert(winner, prebidResource: Resource){
    if(!!winner?.adId){

      this.debugLog([`Creating insert from prebid auction without GAM.`, winner], [LogType.CXO, LogType.QA]);
      prebidResource.creativeId = winner?.creativeId;
      prebidResource.adId = winner?.adId;
      prebidResource.data.w = winner?.width ?? prebidResource.data.w;
      prebidResource.data.h = winner?.height ?? prebidResource.data.h;
      this.debugLog(`Winning banner at generate prebid with size ${prebidResource.data.w}x${prebidResource.data.h}`, [LogType.QA, LogType.CXO]);
      
      prebidResource.impressionType = ImpressionType.DISPLAY
      
      this.timers.updateCXOTimer.execute()
      this.timers.checkTrackIntegrityTimer.reset(1000);
  
      //if(!isNil(this.activeResource) || !isNil(this.carouselResource)){
        //this.clearRemainingInserts();
      //}
  
      this.inserts.push(prebidResource);
  
      const nextResource: Resource = this.nextAvailableResource;
      if(!isNil(nextResource)){
        this.timers.createNewInsertTimer.reset(0, ()=>{this.createNewInsert(this.nextAvailableResource)});
      }
  
      if (!this.isCarouselStarted) {
        this.overlayUtilities.activeCarouselData.isCompleted = false;
      }

      this.debugLog([`Prebid only insert loading.`], [LogType.CXO, LogType.QA]);

      loadComponents(this.inserts, this.isesm, this.scriptBaseURL);
      
      this.debugLog([`Prebid only insert loaded. Awaiting render ad.`], [LogType.CXO, LogType.QA]);
  
      this.overlayUtilities.osdConfig.renderPrebidWin = (iframe, acceptedbidid) => {
        const pbjsObject = this.overlayUtilities.osdConfig.slotRefreshParams.pbjsObject
  
        pbjsObject.onEvent('adRenderSucceeded', (evt) => {
          if(evt.adId === winner.adId) {
            evt.doc.body.setAttribute('style', `z-index:100; margin:0px; padding:0px; position:absolute; display:block; top:0px; left:0px; width:${iframe.width}px; height:${iframe.height}px; overflow:hidden;`);
  
            window.postMessage({
              target: acceptedbidid,
              message: BannerMessageType.LOAD_COMPLETE
            }, window.location.protocol + '//' + window.location.host);
          }
        });
  
        pbjsObject.renderAd(iframe.contentWindow.document, winner.adId);
      }
      
      const insertSource: BidOriginSourceType = this.getOriginSourceFromData(prebidResource);
      const responseData: BidResponseData = {
        overlayTime: this.overlayUtilities.elapsedOverlayTime/1000,
        activeOverlayTime: this.overlayUtilities.activeOverlayTime/1000,
        totalBidsCount: this.overlayUtilities.bidCount,
        adOpportunityBidCount: (this.overlayUtilities.rebidCount + 1),
        adOpportunityId: prebidResource.adOpportunityId,
        bidRequestId: prebidResource.bidRequestId,
        bidCpm: 0,
        cid: prebidResource.campaignId,
        crid: prebidResource.creativeId,
        seatId: prebidResource.seat,
        adId: prebidResource.adId,
        bidId: prebidResource.bidId,
        impressionType: ImpressionType.DISPLAY,
        componentDimensions: {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height},
        containerViewability: this.overlayUtilities.containerViewabilityValue,
        videoTime: (!isNil(this.videoElement))?this.videoElement.currentTime:0,
        bannerSize: `${prebidResource?.data?.w}x${prebidResource?.data?.h}`
      }
      if(insertSource === BidOriginSourceType.OSD){
        this.overlayUtilities.osdConfig.eventData['isSafeframe'] = false;
        const debugData: {[key:string]:any} = this.overlayUtilities.cleanOSDResponseData(this.overlayUtilities.osdConfig?.eventData);
        responseData.debug = debugData;
      }
      this.analyticsEventDispatcher.sendBidResponseEvent(AnalyticsEventType.BID_RESPONSE, insertSource, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, responseData);
    }else{
      const originSource: BidOriginSourceType = this.getOriginSourceFromData(prebidResource);

      const responseData: BidResponseData = {
        overlayTime: this.overlayUtilities.elapsedOverlayTime/1000,
        activeOverlayTime: this.overlayUtilities.activeOverlayTime/1000,
        totalBidsCount: this.overlayUtilities.bidCount,
        adOpportunityBidCount: (this.overlayUtilities.rebidCount + 1),
        adOpportunityId: prebidResource.adOpportunityId,
        bidRequestId: prebidResource.bidRequestId,
        bidCpm: 0,
        cid: prebidResource.campaignId,
        crid: prebidResource.creativeId,
        seatId: prebidResource.seat,
        adId: prebidResource.adId,
        bidId: prebidResource.bidId,
        impressionType: ImpressionType.DISPLAY,
        componentDimensions: {width:this.overlayUtilities.currentDimensions.width, height:this.overlayUtilities.currentDimensions.height},
        containerViewability: this.overlayUtilities.containerViewabilityValue,
        videoTime: (!isNil(this.videoElement))?this.videoElement.currentTime:0,
        bannerSize: `${prebidResource?.data?.w}x${prebidResource?.data?.h}`
      }
      if(originSource === BidOriginSourceType.OSD){
        this.overlayUtilities.osdConfig.eventData['isSafeframe'] = false;
        let debugData: {[key:string]:any} = this.overlayUtilities.cleanOSDResponseData(this.overlayUtilities.osdConfig?.eventData);
        responseData.debug = debugData;
      }
      this.analyticsEventDispatcher.sendBidResponseEvent(AnalyticsEventType.BID_RESPONSE_EMPTY, originSource, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, responseData);
    }
    
  }

  generateNativeInsert(
    headline: string = "Unmatched Power and Design.",
    subheadline: string = "Your Dream Setup Starts Here.",
    cta: string = "Learn More",
    image: string = "https://static-rtb2.qortex.ai/storage/Bu/Mi/Eu/PyZ2dWyAnCxiH8cT3NLh.png",
    icon: string = "https://static-rtb2.qortex.ai/storage/XI/x6/Ei/7o20O4UaPF8HntC7wbI8.jpg"
  ){
    const nativeResource: Resource = {
      id: this.overlayUtilities.generateUniqueId,
      uniqueId: this.overlayUtilities.generateUniqueId,
      bid: 0.1,
      seat: "custom",
      campaignId: "custom",
      creativeId: "custom",
      adId: "custom",
      bidId: this.overlayUtilities.generateUniqueId,
      tracker: [],
      viewabilityTrackers: [],
      win: "",
      ref: { groupId: "custom",
        videoId: "undefined",
        scheduleId: null,
        momentId: null },
      demand: null,
      created: null,
      data: {
        ver: "1.1",
        assets: [
          {id: 1, title: { text: headline ?? 'Headline Goes Here.'} },
          {id: 2, data: { type: 0, value: subheadline } },
          {id: 3, data: { type: 0, value: cta } },
          {id: 4, img: { type: 0, url: image, w: 328, h: 328 } },
          {id: 5, img: { type: 0, url: icon, w: 328, h: 328 } }
        ],
        link: {
          url: "https://www.google.com/search?q=catapultx",
          clicktrackers: null,
          fallback: null,
          imptrackers: [],
          wintracker: ""
        },
        imptrackers: [],
        viewabilityTrackers: []
      },
      impressionType: ImpressionType.NATIVE,
      frameSafe: true,
      bidRequestId: "NONE",
      adOpportunityId: "NONE",
      impressionFired: false
    }
    
    this.timers.updateCXOTimer.execute()
    this.timers.checkTrackIntegrityTimer.reset(1000);

    if(!isNil(this.activeResource) || !isNil(this.carouselResource)){
      this.clearRemainingInserts();
    }

    this.inserts.push(nativeResource);

    const nextResource: Resource = this.nextAvailableResource;
    if(!isNil(nextResource)){
      this.timers.createNewInsertTimer.reset(0, ()=>{this.createNewInsert(this.nextAvailableResource)});
    }

    if (!this.isCarouselStarted) {
      this.overlayUtilities.activeCarouselData.isCompleted = false;
    }

    loadComponents(this.inserts, this.isesm, this.scriptBaseURL)
  }

  generateBannerInsert(adm: string, w: number, h: number, frameSafe: boolean = true){
    const bannerResource: Resource = {
      id: this.overlayUtilities.generateUniqueId,
      uniqueId: this.overlayUtilities.generateUniqueId,
      bid: 0.1,
      seat: "custom",
      campaignId: "custom",
      creativeId: "custom",
      adId: "custom",
      bidId: this.overlayUtilities.generateUniqueId,
      tracker: [],
      viewabilityTrackers: [],
      win: "",
      ref: { groupId: "custom",
        videoId: "undefined",
        scheduleId: null,
        momentId: null },
      demand: null,
      created: null,
      data: {
        banner: adm,
        w: w,
        h: h,
        link: {
          url: "https://www.google.com/search?q=catapultx",
          clicktrackers: null,
          fallback: null,
          imptrackers: [],
          wintracker: ""
        },
        imptrackers: [],
        viewabilityTrackers: []
      },
      impressionType: ImpressionType.DISPLAY,
      frameSafe: frameSafe,
      impressionFired: false
    }
    
    this.timers.updateCXOTimer.execute()
    this.timers.checkTrackIntegrityTimer.reset(1000);

    if(!isNil(this.activeResource) || !isNil(this.carouselResource)){
      this.clearRemainingInserts();
    }

    this.inserts.push(bannerResource);

    const nextResource: Resource = this.nextAvailableResource;
    if(!isNil(nextResource)){
      this.timers.createNewInsertTimer.reset(0, ()=>{this.createNewInsert(this.nextAvailableResource)});
    }

    if (!this.isCarouselStarted) {
      this.overlayUtilities.activeCarouselData.isCompleted = false;
    }

    loadComponents(this.inserts, this.isesm, this.scriptBaseURL)
  }

  clearActiveInsert() {
    this.debugLog('clearActiveInsert');
    if (!isNil(this.activeResource)) {
      this.insertBeingCleared = true;
      // Notify the insert that it is being destroyed
      const currentResource = this.activeResource;
      const currentResourceID = currentResource.getAttribute('uniqueid');
      this.debugLog('Dispatch event to insert ' + currentResourceID + ' notifying activeResource destroy.', [LogType.QA, LogType.CXO]);
      this.overlayUtilities.dispatchOverlayEvent({
        type: OverlayEventType.OVERLAY_REQUEST_DESTROY,
        uid: currentResourceID
      })
      new CustomTimeout(()=>{
        this.forceRemoveInsert(currentResource);
      },2000, 'Force Remove Insert Timer', this.logManager, LogType.CXO);
    }
  }

  forceRemoveInsert(removableResource:HTMLElement){
    if(removableResource != null && removableResource.parentNode){
      this.debugLog('Force removal of insert: ' + removableResource.tagName, [LogType.QA, LogType.CXO]);
      removableResource.parentNode.removeChild(removableResource)
    }
  }

  clearCarouselInsert(){
    if(!isNil(this.carouselResource)){
      const carouselResourceID = this.carouselResource.getAttribute('uniqueid')
      
      this.inserts = this.inserts.filter(ins => ins.id !== this.carouselResource.getAttribute('acceptedbidid'));

      if (this.carouselResource?.parentNode) {
        this.carouselResource.parentNode.removeChild(this.carouselResource)
      }else{
        this.debugLog(['Carousel resource has no parent node: ', this.carouselResource], LogType.IMPORTANT);
      }
      
      const resource: Resource = this.carouselResourceData;
      const debugData: {[key: string]:any} = {
        message: 'DESTROYED_BEFORE_DISPLAY',
        insertLocation: 'CAROUSEL'
      }
      this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_NO_IMPRESSION, this.getOriginSourceFromData(resource), resource.seat, resource.campaignId, resource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, carouselResourceID, InsertType.NONE, (!isNil(resource?.data?.w))?`${resource?.data?.w}x${resource?.data?.h}`:null, resource.adOpportunityId, resource.bidRequestId, this.overlayUtilities.containerViewabilityValue, debugData);

      this.carouselResourceData = null
      this.carouselResource = null
      
      this.overlayUtilities.dispatchOverlayEvent({
        type: OverlayEventType.OVERLAY_REQUEST_DESTROY, 
        uid: carouselResourceID
      })
    }
  }

  clearRemainingInserts(){
    this.debugLog("Clearing remaining inserts", LogType.QA);
    this.clearCarouselInsert();
    this.clearActiveInsert();
    this.overlayUtilities.resetCarouselData();
    this.overlayUtilities.dispatchOverlayEvent({
      type: OverlayEventType.OVERLAY_DESTROY_REMAINING_INSERTS
    });
    this.inserts=[];
  }

  insertToClear(){
    const resource = this.activeResource

    if(!isNil(resource)){
      this.debugLog(`insertToClear --removingResource = ${resource.tagName}`)

      this.debugLog(['Insert removed: ', resource.tagName], [LogType.CXO, LogType.QA]);
      if (resource.parentNode) {
        resource.parentNode.removeChild(resource)
      }
    }

    if(!this.isInsertReinitializing){
      this.inserts = this.inserts.filter(ins => ins.id !== this.activeResource.getAttribute('acceptedbidid'));
      if(!this.activeResourceData.impressionFired){
        const resource: Resource = this.activeResourceData;
        const debugData: {[key: string]:any} = {
          message: 'DESTROYED_BEFORE_DISPLAY',
          insertLocation: 'ACTIVE'
        }
        this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_NO_IMPRESSION, this.getOriginSourceFromData(resource), resource.seat, resource.campaignId, resource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, resource.uniqueId, InsertType.NONE, (!isNil(resource?.data?.w))?`${resource?.data?.w}x${resource?.data?.h}`:null, resource.adOpportunityId, resource.bidRequestId, this.overlayUtilities.containerViewabilityValue, debugData);
      }
      if(!isNil(this.carouselResource)){
        this.activeResourceData = this.carouselResourceData;
        this.activeResource = this.carouselResource;
        this.carouselResourceData = null;
        this.carouselResource = null;
        this.debugLog(['Carousel turned into active resource: ', this.activeResource], [LogType.QA, LogType.CXO]);
      }else{
        this.activeResource = null;
        this.timers.checkForVideoChangeTimer.cancel();
      }
      this.debugLog(['remaining inserts: ', this.inserts], LogType.CXO);
      const nextResource: Resource = this.nextAvailableResource;
      if(!isNil(nextResource)){
        this.timers.createNewInsertTimer.reset(0, ()=>{this.createNewInsert(this.nextAvailableResource)});
      }
    }else{
      this.activeResource = null;
      //this.setActiveInsert(this.inserts[currentInsert]);
      this.isInsertReinitializing = false;
      //this.debugLog('Insert to reinitialize = FALSE', LogType.IMPORTANT);
    }

    this.timers.updateCXOTimer.execute()

    this.insertBeingCleared = false;
  }

  getAvailableInserts(configs: InsertConfig): AllowedInsert[]{
    let insertConfigSelection = configs.allowedInsertsDesktopOnStream;
    switch(this.playerMode){
      case PlayerMode.DESKTOP_FLOATING:
        insertConfigSelection = [...configs.allowedInsertsDesktopFloating];
        break;
      case PlayerMode.DESKTOP_ONSTREAM:
        insertConfigSelection = [...configs.allowedInsertsDesktopOnStream];
        break;
      case PlayerMode.DESKTOP_INARTICLE:
        insertConfigSelection = [...configs.allowedInsertsDesktopInArticle];
        break;
      case PlayerMode.MOBILE_FLOATING:
        insertConfigSelection = [...configs.allowedInsertsMobileFloating];
        break;
      case PlayerMode.MOBILE_ONSTREAM:
        insertConfigSelection = [...configs.allowedInsertsMobileOnStream];
        break;
      case PlayerMode.MOBILE_INARTICLE:
        insertConfigSelection = [...configs.allowedInsertsMobileInArticle];
        break;
      default:
        insertConfigSelection = [...configs.allowedInsertsDesktopOnStream];
        break;
    }
    return insertConfigSelection;
  }

  createInsert(resource: Resource, isSubload: boolean = false): HTMLElement {

    let insert = this.optimalInsertType ?? this.currentInserts.nativeOverlayFullwidth;
    const insertConfigs: InsertConfig = this.overlayUtilities.groupConfig.insertConfig;

    if ( !isNil(insertConfigs.allowedInsertsDesktopOnStream) && insertConfigs.allowedInsertsDesktopOnStream.length > 0 ) {
      insert = insertConfigs.allowedInsertsDesktopOnStream[0].insertType
    }

    resource.uniqueId ??= this.overlayUtilities.generateUniqueId;

    this.debugLog(['createInsert --determineOptimalInsertType = ', insert]);

    this.optimalInsertType = insert;
    if(resource.impressionType === ImpressionType.DISPLAY && resource.data.isADX){
      this.optimalInsertType = resource.data.adxInsertType;
    }else{
      this.selectInsertTypeFromOptions(resource)
    }

    this.moveCxo()
      
    if (this.logManager.getDebugParamValue(DebugURLParams.FORCE_VERTICAL_BANNER_SQUEEZEBACK) !== null) {
      resource.data.banner = '<img src="https://static-rtb2.qortex.ai/storage/aR/Ab/0n/vhsUmcDnNQsW8Yb495F8.jpg" />';
      resource.data.w = 300;
      resource.data.h = 600;
      resource.impressionType = ImpressionType.DISPLAY
      this.optimalInsertType = this.currentInserts.displaySqueeze;
      this.optimalInsertPosition = InsertPosition.DEFAULT;
    }else if (this.logManager.getDebugParamValue(DebugURLParams.FORCE_HORIZONTAL_BANNER_SQUEEZEBACK) !== null) {
      resource.data.banner = '<img src="https://static.shareasale.com/image/45519/20FW_Black-Friday_FD_OLA-Banners_728x90.jpg" />';
      resource.data.w = 728;
      resource.data.h = 90;
      resource.impressionType = ImpressionType.DISPLAY
      this.optimalInsertType = this.currentInserts.displaySqueeze;
      this.optimalInsertPosition = InsertPosition.DEFAULT;
    }

    if(resource.impressionType === ImpressionType.VIDEO){
      this.optimalInsertType = this.currentInserts.nativeVideoSqueeze;
    }
      
    /* FORCE VIDEO SQUEEZEBACK
    let imageAsset = resource.data.assets.find(x => x.id >= 5);
    if(!isNil(imageAsset)){
      this.optimalInsertType = this.currentInserts.nativeVideoSqueeze;
      let rand: number = Math.random()*3;
      resource.data.video = {};
      if(rand < 1){
        imageAsset.img.url = process.env.SERVER_ROOT + '/assets/inserts/squeezeback-custom-video/M&Ms_1920x1080_Squeezeback.jpg'
        resource.data.video.url = process.env.SERVER_ROOT + '/assets/inserts/squeezeback-custom-video/M&Ms_1280x720_video.mp4'
        resource.data.video.w = 579
        resource.data.video.h = 326
        resource.data.video.x = 0
        resource.data.video.y = 450
      }else if(rand < 2){
        imageAsset.img.url = process.env.SERVER_ROOT + '/assets/inserts/squeezeback-custom-video/Skittles_1920x1080_Squeezeback.jpg'
        resource.data.video.url = process.env.SERVER_ROOT + '/assets/inserts/squeezeback-custom-video/Skittles_1280x720_video.mp4'
        resource.data.video.w = 579
        resource.data.video.h = 326
        resource.data.video.x = 0
        resource.data.video.y = 450
      }else if(rand < 3){
        imageAsset.img.url = process.env.SERVER_ROOT + '/assets/inserts/squeezeback-custom-video/Snickers_1920x1080_Squeezeback.jpg'
        resource.data.video.url = process.env.SERVER_ROOT + '/assets/inserts/squeezeback-custom-video/Snickers_1280x720_video.mp4'
        resource.data.video.w = 579
        resource.data.video.h = 326
        resource.data.video.x = 0
        resource.data.video.y = 491
      }
      imageAsset.img.w = 1920
      imageAsset.img.h = 1080
    }

    /* */
    
    let insertOverrideConfig: InsertOverride[] = null;
    const insertConfigSelection = this.getAvailableInserts(insertConfigs)

    //Mapping to pull insert override configurations from the NATIVE insert into an identical DISPLAY insert
    if(!isNil(insertConfigSelection)){
      let overrideInsert: InsertType;
      switch(this.optimalInsertType){
        case this.currentInserts.displayOverlayFullwidth:
          overrideInsert = this.currentInserts.nativeOverlayFullwidth;
          break;
        case this.currentInserts.displayOverlayCorner:
          overrideInsert = this.currentInserts.nativeOverlayCorner;
          break;
        case this.currentInserts.displayFlap:
          overrideInsert = this.currentInserts.nativeFlap;
          break;
        case this.currentInserts.displayWing:
          overrideInsert = this.currentInserts.nativeWing;
          break;
        case this.currentInserts.displaySqueeze:
          overrideInsert = this.currentInserts.nativeSqueeze;
          break;
        default:
          overrideInsert = this.optimalInsertType;
          break;
      }
      this.debugLog('Searching for override configs for ' + overrideInsert, [LogType.QA, LogType.CXO]);
      const insertMatch = insertConfigSelection.find(x => x.insertType === overrideInsert);
      if(!isNil(insertMatch)){
        insertOverrideConfig = insertMatch.overrides;
      }
    }

    if(!isNil(this.optimalInsertType) && this.optimalInsertType !== InsertType.NONE){
      if(insertOverrideConfig !== null){
        insertOverrideConfig.forEach(o => {
          o.key = o.key.replace(/[^\w\d-_]/g, '');
          o.value = o.value.replace(/[^\w\d-_]/g, '');
        })
      }
      this.debugLog([`Found ${this.optimalInsertType} insert override configs: `, insertOverrideConfig], [LogType.QA, LogType.CXO]);

      const component:HTMLElement = document.createElement(this.optimalInsertType)
      this.debugLog(`createInsert --optimalInsertType = ${this.optimalInsertType}`)
      const data = resource.data
      
      data.link = (isNil(data.link))?{}:data.link;
      data.link.imptrackers = (!isNil(resource.tracker))?resource.tracker:(!isNil(resource.data.imptrackers))?resource.data.imptrackers:[];
      data.link.wintracker = (!isNil(resource.win))?resource.win:'';
      data.viewabilityTrackers = (!isNil(resource.viewabilityTrackers) ? resource.viewabilityTrackers : []);
      data.eventtrackers?.forEach(tracker => {if((tracker.url || null) !== null && !data.link.imptrackers.includes(tracker.url))data.link.imptrackers.push(tracker.url)})
      if(this.logManager.getDebugParamValue(DebugURLParams.PRIVACY_URL)?.includes('t')){
        data.privacy = 'https://iabtechlab.com/privacy-policy/';
      }
      data.destroyInsertOnClose = (
        this.overlayUtilities.groupConfig.zoneModifications.includes(ZoneModifications.BRAINLY)
        || this.overlayUtilities.groupConfig.zoneModifications.includes(ZoneModifications.HIDE_UI)
        || this.overlayUtilities.groupConfig.zoneModifications.includes(ZoneModifications.REMOVE_LOGO)
      )?true:this.overlayUtilities.groupConfig.destroyInsertOnClose;

      if(this.overlayUtilities.groupConfig.zoneModifications.includes(ZoneModifications.PREVENT_BANNER_UPSCALE)){
        data.preventBannerEnlarge = true;
      }

      if(this.overlayUtilities.groupConfig.zoneModifications.includes(ZoneModifications.REMOVE_LOGO)){
        data.removeLogo = true;
      }

      if(this.overlayUtilities.groupConfig.zoneModifications.includes(ZoneModifications.HIDE_UI)){
        data.transparentMode = true;
      }

      if(this.overlayUtilities.groupConfig.zoneModifications.includes(ZoneModifications.DISABLE_OPEN_ANIMATION)){
        data.disableOpenAnimation = true;
      }

      if(this.overlayUtilities.groupConfig.zoneModifications.includes(ZoneModifications.ROUNDED_INSERT_EDGES)){
        data.roundedInsertEdges = true;
      }
      
      data.akuid = this.overlayUtilities.foundUID;

      let insertDuration = (this.isCarouselStarted && !this.overlayUtilities.forceNextInsert)?(this.overlayUtilities.groupConfig.insertDuration - this.overlayUtilities.carouselBidTimer.getTotalElapsedTime()/1000):this.overlayUtilities.groupConfig.insertDuration
      if(insertDuration < this.overlayUtilities.groupConfig.carouselSpeed+2){
        insertDuration = this.overlayUtilities.groupConfig.carouselSpeed+2
      }
      if(this.overlayUtilities.groupConfig.zoneModifications.includes(ZoneModifications.ALWAYS_ON)){
        insertDuration *= 3;
      }
      const insertConfigs: InsertConfiguration = {
        isBranded: this.overlayUtilities.groupConfig.brandBug ?? true,
        forceLoad: this.overlayUtilities.forceNextInsert,
        isSubloaded: isSubload,
        duration: insertDuration,
        carouselSpeed: this.overlayUtilities.groupConfig?.carouselSpeed || 15,
        isOutbrain: data.isOutbrainBid ?? false,
        isRevContent: data.isRevContentBid ?? false,
        isBrainly: (this.overlayUtilities.groupConfig.zoneModifications.includes(ZoneModifications.BRAINLY))?true:false,
        removeCloseButton: (this.overlayUtilities.groupConfig.zoneModifications.includes(ZoneModifications.REMOVE_INSERT_CLOSE_BUTTON))?true:false,
        playerType: this.playerType
      }
      
      data.insertConfigs = insertConfigs;
      
      component.setAttribute('data', JSON.stringify(data))
      component.setAttribute('overrides', JSON.stringify(insertOverrideConfig))

      const insertPosition: string = (this.logManager.getDebugParamValue(DebugURLParams.INSERT_OVERRIDE_POSITION)?.length === 2)?this.logManager.getDebugParamValue(DebugURLParams.INSERT_OVERRIDE_POSITION):this.optimalInsertPosition;
      component.setAttribute('insertposition', insertPosition);
      if(this.optimalInsertType === this.currentInserts.nativeWing){
        component.setAttribute('allowedheight', String(Math.round(this.overlayUtilities.currentDimensions.height)))
        //const pixelsForLogo: number = 21;
        const pixelsForLogo: number = (insertConfigs.isOutbrain)?21:0;
        let allowedWidth: number =  (this.optimalInsertPosition.indexOf('l')>=0)?Math.floor(this.overlayUtilities.currentDimensions.left)-pixelsForLogo:Math.floor(this.overlayUtilities.currentDimensions.right)-pixelsForLogo;
        if(allowedWidth > this.overlayUtilities.currentDimensions.width * 1.5){
          allowedWidth = this.overlayUtilities.currentDimensions.width * 1.5 - pixelsForLogo;
        }else if(allowedWidth < this.overlayUtilities.currentDimensions.width * .25){
          allowedWidth = this.overlayUtilities.currentDimensions.width*.25-pixelsForLogo;
        }
        component.setAttribute('allowedwidth', String(allowedWidth))
      }
      component.setAttribute('creationwidth', String(this.overlayUtilities.currentDimensions.width))
      component.setAttribute('creationheight', String(this.overlayUtilities.currentDimensions.height))
      component.setAttribute('uniqueid', resource.uniqueId)
      component.setAttribute('acceptedbidid', resource.id)
      if(resource.impressionType === ImpressionType.DISPLAY){
        component.setAttribute('iframeload', String((typeof resource.frameSafe !== 'undefined' && resource.frameSafe != null)?resource.frameSafe:true));
        component.setAttribute('adid', String((typeof resource.adId !== 'undefined' && resource.adId != null)?resource.adId:0));
        component.setAttribute('campaignid', String((typeof resource.campaignId !== 'undefined' && resource.campaignId != null)?(resource.campaignId?.split?.('|').length>1)?resource.campaignId.split('|')[1]:resource.campaignId:0));
        component.setAttribute('creativeid', String((typeof resource.creativeId !== 'undefined' && resource.creativeId != null)?(resource.creativeId?.split?.('|').length>1)?resource.creativeId.split('|')[1]:resource.creativeId:0));
        component.setAttribute('advertiserid', String((typeof resource.seat !== 'undefined' && resource.seat != null)?resource.seat:0));
      }

      this.overlayUtilities.forceNextInsert = false;
      component['stowedInsertSharedLogic']=this.insertLogicManager;
      this.overlayUtilities.currentDimensions.insertPosition = this.optimalInsertPosition;
      
      this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_CREATED, this.getOriginSourceFromData(resource), resource.seat, resource.campaignId, resource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, resource.uniqueId, component.tagName, (!isNil(data?.w))?`${data.w}x${data.h}`:null, resource.adOpportunityId, resource.bidRequestId, this.overlayUtilities.containerViewabilityValue);
        
      return component
    }else{
      this.debugLog([`No available insert types to display. Will not display resource.`, resource], [LogType.QA, LogType.CXO]);
      const debugData: {[key: string]:any} = {
        message: 'INSERT_NOT_CREATED',
        reason: 'NO_INSERT_TYPES_AVAILABLE'
      }
      if(resource.impressionType === ImpressionType.DISPLAY){
        debugData.seatid = resource?.seat;
        debugData.requestedSize = this.requestedBannerSizes[this.requestedBannerSizes.length-1][0]+'x'+this.requestedBannerSizes[this.requestedBannerSizes.length-1][1]
      }
      this.analyticsEventDispatcher.sendInsertEvent(AnalyticsEventType.INSERT_NO_IMPRESSION, this.getOriginSourceFromData(resource), resource.seat, resource.campaignId, resource.creativeId, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, (!isNil(this.videoElement))?this.videoElement.currentTime:0, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, resource.uniqueId, InsertType.NONE, (!isNil(resource?.data?.w))?`${resource?.data?.w}x${resource?.data?.h}`:null, resource.adOpportunityId, resource.bidRequestId, this.overlayUtilities.containerViewabilityValue, debugData);

      const resourceIndex = this.inserts.indexOf(resource)
      if(resourceIndex > -1){
        this.inserts.splice(resourceIndex, 1);
      }

      return null;
    }
  }

  get currentVideoElementScale(): number{
    let videoScale: number = (!isNil(this.videoElement) && this.videoElement.hasAttribute('insertvideoscale') && !Number.isNaN(parseFloat(this.videoElement.getAttribute('insertvideoscale'))))?parseFloat(this.videoElement.getAttribute('insertvideoscale')):1;
    return videoScale;
  }

  get preferredBannerSize(): BannerParameters{
    const bannerParams: BannerParameters = {
      insertType: InsertType.NONE,
      bannerSize: null,
      adxSize: null
    }
    let sizeList: number[][];
    let adxSizeList: number[][];

    let allowedInsertTypes:string[] = this.overlayUtilities.determineInsertTypeOptions();
    if(!isNil(this.activeResource)){
      let filteredInsertList = [...allowedInsertTypes]
      const currentType: string = this.activeResource.tagName.toLowerCase();
      if(currentType.indexOf('squeeze') >= 0){
        filteredInsertList = filteredInsertList.filter(type => type.indexOf('squeeze')>=0);
      }else if(currentType.indexOf('wing') >= 0){
        filteredInsertList = filteredInsertList.filter(type => type.indexOf('wing')>=0);
      }else if(currentType.indexOf('flap') >= 0){
        filteredInsertList = filteredInsertList.filter(type => type.indexOf('flap')>=0);
      }else if(currentType.indexOf('overlay') >= 0){
        if(currentType.indexOf('fullwidth') >= 0){
          filteredInsertList = filteredInsertList.filter(type => type.indexOf('fullwidth')>=0);
        }else{
          filteredInsertList = filteredInsertList.filter(type => (type.indexOf('overlay') >= 0 && type.indexOf('fullwidth') === -1));
        }
      }
      if(filteredInsertList.length > 0){
        this.debugLog(`Finding banner size to request - Active insert is of type ${this.activeResource.tagName.toLowerCase()}. Requesting banner size for ${String(filteredInsertList)}.`, [LogType.QA, LogType.CXO]);
        allowedInsertTypes = filteredInsertList;
      }
    }

    this.debugLog(`Finding banner size for overlay dimensions ${this.overlayUtilities.currentDimensions.width}x${this.overlayUtilities.currentDimensions.height}.`, [LogType.CXO]);
    
    if(allowedInsertTypes.find(type => type === this.currentInserts.nativeSqueeze)){
      bannerParams.insertType = this.currentInserts.displaySqueeze;
      sizeList = this.filterBannerSizeList(this.overlayUtilities.allowedBannerSizes.squeezeback);
      bannerParams.bannerSize = sizeList.find(size => size[0] >= this.overlayUtilities.currentDimensions.width) ?? sizeList[sizeList.length-1];
      adxSizeList = this.filterBannerSizeList(this.overlayUtilities.allowedADXBannerSizes.squeezeback);
      const adxSizeIndex: number = adxSizeList.findIndex(size => size[0] >= this.overlayUtilities.currentDimensions.width);
      bannerParams.adxSize = (adxSizeIndex === -1)?adxSizeList[adxSizeList.length-1]:(adxSizeIndex > 0)?adxSizeList[adxSizeIndex-1]:adxSizeList[0];
    }else if(allowedInsertTypes.find(type => type.indexOf('wing') !== -1)){
      bannerParams.insertType = this.currentInserts.displayWing;
      //const pixelsForLogo: number = 21;
      const pixelsForLogo: number = 0;
      const spaceAvailable: number = (this.overlayUtilities.currentDimensions.left > this.overlayUtilities.currentDimensions.right)?this.overlayUtilities.currentDimensions.left-pixelsForLogo:this.overlayUtilities.currentDimensions.right-pixelsForLogo;
      if(spaceAvailable < this.overlayUtilities.currentDimensions.width*2){
        const spaceRatio: number = spaceAvailable/this.overlayUtilities.currentDimensions.height;
        sizeList = this.filterBannerSizeList(this.overlayUtilities.allowedBannerSizes.wingTall);
        bannerParams.bannerSize = sizeList.find(size => spaceRatio > size[0]/size[1]) ?? sizeList[sizeList.length-1];
        adxSizeList = this.filterBannerSizeList(this.overlayUtilities.allowedADXBannerSizes.wingTall);
        const adxSizeIndex: number = adxSizeList.findIndex(size => spaceRatio > size[0]/size[1] && this.overlayUtilities.currentDimensions.height >= size[1]);
        bannerParams.adxSize = (adxSizeIndex === -1)?adxSizeList[0]:(adxSizeIndex > 0)?adxSizeList[adxSizeIndex]:adxSizeList[0];
      }else{
        sizeList = this.filterBannerSizeList(this.overlayUtilities.allowedBannerSizes.wing);
        bannerParams.bannerSize = sizeList.find(size => size[1] >= this.overlayUtilities.currentDimensions.height) ?? sizeList[sizeList.length-1];
        adxSizeList = this.filterBannerSizeList(this.overlayUtilities.allowedADXBannerSizes.wing);
        const adxSizeIndex: number = adxSizeList.findIndex(size => size[1] >= this.overlayUtilities.currentDimensions.height);
        bannerParams.adxSize = (adxSizeIndex === -1)?adxSizeList[adxSizeList.length-1]:(adxSizeIndex > 0)?adxSizeList[adxSizeIndex-1]:adxSizeList[0];
      }
    }else if(allowedInsertTypes.find(type => type.indexOf('flap') !== -1)){
      bannerParams.insertType = this.currentInserts.displayFlap;
      sizeList = this.filterBannerSizeList(this.overlayUtilities.allowedBannerSizes.flap);
      bannerParams.bannerSize = sizeList.find(size => size[0] >= this.overlayUtilities.currentDimensions.width) ?? sizeList[sizeList.length-1];
      adxSizeList = this.filterBannerSizeList(this.overlayUtilities.allowedADXBannerSizes.flap);
      const adxSizeIndex: number = adxSizeList.findIndex(size => size[0] >= this.overlayUtilities.currentDimensions.width);
      bannerParams.adxSize = (adxSizeIndex === -1)?adxSizeList[adxSizeList.length-1]:(adxSizeIndex > 0)?adxSizeList[adxSizeIndex-1]:adxSizeList[0];
    }else if(allowedInsertTypes.find(type => type === this.currentInserts.nativeOverlayFullwidth)){
      bannerParams.insertType = this.currentInserts.displayOverlayFullwidth;
      sizeList = this.filterBannerSizeList(this.overlayUtilities.allowedBannerSizes.overlayFullwidth);
      bannerParams.bannerSize = sizeList.find(size => size[0] >= this.overlayUtilities.currentDimensions.width) ?? sizeList[sizeList.length-1];
      adxSizeList = this.filterBannerSizeList(this.overlayUtilities.allowedADXBannerSizes.overlayFullwidth);
      const adxSizeIndex: number = adxSizeList.findIndex(size => size[0] >= this.overlayUtilities.currentDimensions.width);
      bannerParams.adxSize = (adxSizeIndex === -1)?adxSizeList[adxSizeList.length-1]:(adxSizeIndex > 0)?adxSizeList[adxSizeIndex-1]:adxSizeList[0];
    }else{
      bannerParams.insertType = this.currentInserts.displayOverlayCorner;
      sizeList = this.filterBannerSizeList(this.overlayUtilities.allowedBannerSizes.overlayCorner);
      bannerParams.bannerSize = sizeList.find(size => size[0] >= this.overlayUtilities.currentDimensions.width*.5) ?? sizeList[0]
      adxSizeList = this.filterBannerSizeList(this.overlayUtilities.allowedADXBannerSizes.overlayCorner);
      const adxSizeIndex: number = adxSizeList.findIndex(size => size[0] >= this.overlayUtilities.currentDimensions.width*.65);
      bannerParams.adxSize = (adxSizeIndex === -1)?adxSizeList[adxSizeList.length-1]:(adxSizeIndex > 0)?adxSizeList[adxSizeIndex-1]:adxSizeList[0];
    }

    bannerParams.bannerSize ??= [0,0];
    bannerParams.adxSize ??= [0,0];

    return bannerParams
  }

  filterBannerSizeList(allowedSizes: number[][]): number[][]{
    let filteredSizes: number[][] = allowedSizes;
    this.requestedBannerSizes.forEach(size =>{
      filteredSizes = filteredSizes.filter(s => s !== size)
    })
    return (filteredSizes.length > 0)?filteredSizes:allowedSizes;
  }

  getOriginSourceFromData(res: Resource): BidOriginSourceType{
    let detectedDataSource: BidOriginSourceType = BidOriginSourceType.PLATFORM;
    if(res !== null && res.data !== null){
      if(res.data.isADX){
        detectedDataSource = BidOriginSourceType.ADX;
      }else if(res.data.isPrebid){
        detectedDataSource = BidOriginSourceType.OSD;
      }else if(res.data.isRevContentBid){
        detectedDataSource = BidOriginSourceType.REV_CONTENT;
      }else if(res.data.isOutbrainBid){
        detectedDataSource = BidOriginSourceType.OUTBRAIN;
      }else{
        detectedDataSource = BidOriginSourceType.ADK;
      }
    }
    this.activeResourceData
    return detectedDataSource
  }

  captureVideoPositionData(){
    if (!this.currentVideoStatus.videoAnalyticsParameters.videoPositionDataSent.includes(this.playerMode)) {
      const videoRect: DOMRect  = this.videoElement.getBoundingClientRect();
      let videoData: {[key:string]: any} = {
        x: videoRect.left,
        y: videoRect.top,
        width: videoRect.width,
        height: videoRect.height,
        videoHeight: this.videoElement.videoHeight,
        videoWidth: this.videoElement.videoWidth,
        scrollDepthY: window.scrollY, 
        scrollDepthX: window.scrollX,
        viewportWidth: window.innerWidth,
        viewportHeight: window.innerHeight
      };

      this.analyticsEventDispatcher.sendOverlayEvent(AnalyticsEventType.OVERLAY_CAPTURE_VIDEO_POSITION, BidOriginSourceType.PLATFORM, this.overlayUtilities.currentWindowLocation.href, Boolean(this.overlayUtilities.foundUID !== "NOT_FOUND"), this.playerMode, this.overlayUtilities.elapsedOverlayTime, this.overlayUtilities.activeOverlayTime, this.overlayUtilities.containerViewabilityValue, videoData);
      this.currentVideoStatus.videoAnalyticsParameters.videoPositionDataSent.push(this.playerMode);
    } else {
      this.debugLog(`Video position data already sent for player mode ${this.playerMode}. Skipping data capture.`, [LogType.QA, LogType.CXO]);
    }
  }

  set videoDimensionsStable(state: Boolean){
    if(state){
      if(!this.overlayUtilities.currentDimensions.elementDimensionsStable){
        this.overlayUtilities.currentDimensions.elementDimensionsStable = true;
        this.debugLog('Video size has not been recently changed. Video dimensions have become stable.', LogType.CXO);

        this.captureVideoPositionData()
      }
    }else{
      if(this.overlayUtilities.currentDimensions.elementDimensionsStable){
        this.overlayUtilities.currentDimensions.elementDimensionsStable = false;
        this.debugLog('Video size is currently in change. Video dimensions have become unstable.', LogType.CXO);
      }
      this.timers.setVideoDimensionsAsStableTimer.reset(1000);
    }
  }

  get squeezebackResizeLayers(): HTMLElement[] {
    let layers: HTMLElement[] = [];
    let addAutomaticLayers: boolean = false;
    if(!isNil(this.playerConfig.squeezebackResizeLayers)){
      this.playerConfig.squeezebackResizeLayers.forEach(squeezeNode =>{
        if(squeezeNode === 'automatic'){
          this.debugLog(`determineSqueezebackResizeLayers --layerToResize = ${squeezeNode}. Will add in automatically detected resize layers`)
          addAutomaticLayers = true;
        }else{
          this.debugLog(`determineSqueezebackResizeLayers --layerToResize = ${squeezeNode}`)
          let squeezeLayer: HTMLElement = (this.currentVideoStatus.isShadowPlayer)?this.findShadowNodeUp(squeezeNode):this.videoContainerSearchNode.querySelector(squeezeNode);
          if(this.playerConfig.squeezebackShadowLayers && isNil(squeezeLayer)){
            const searchNodeName: string = this.playerConfig.squeezebackRoot ?? this.playerConfig.searchTerm;
            let videoNodeStart: HTMLElement = this.findElementFromNode(searchNodeName, this.videoContainerSearchNode);
            videoNodeStart = this.getParent(videoNodeStart) ?? videoNodeStart;
            squeezeLayer = this.findShadowNodeDown(videoNodeStart, squeezeNode, squeezeLayer);
          }
          if(squeezeLayer != null) layers.push(squeezeLayer)
        }
      })
    }
    if(addAutomaticLayers){
      layers.concat(this.autodetectSqueezebackResizeLayers(layers));
    }
    this.debugLog(['Squeezeback layers detected: ', layers], [LogType.CXO, LogType.QA]);
    return (layers.length > 0)?layers:null;
  }

  autodetectSqueezebackResizeLayers(layers: HTMLElement[]): HTMLElement[] {
    let searchNodeName: string = this.playerConfig.squeezebackRoot ?? this.playerConfig.searchTerm;
    let videoNodeStart: HTMLElement = this.findElementFromNode(searchNodeName, this.videoContainerSearchNode);
    videoNodeStart = this.getParent(videoNodeStart) ?? videoNodeStart;
    if(isNil(videoNodeStart)){
      videoNodeStart = this.videoContainerSearchNode;
    };

    const exclusionLayers: string[] = this.playerConfig.squeezebackExcludeLayers ?? [];
    let exclusionShadowNodes: HTMLElement[] = [];
    exclusionLayers.forEach(identifier => {
      let node: HTMLElement = videoNodeStart.querySelector(identifier) ?? null;
      if(node === null && this.playerConfig.squeezebackShadowLayers){
        node = this.findShadowNodeDown(videoNodeStart, identifier, node);
        if(!isNil(node)){
          //this.debugLog(`autodetectSqueezebackResizeLayers - Exclusion node found in SHADOWDOM (${identifier}): ${node.outerHTML.substring(0, 50)}`, LogType.IMPORTANT);
          exclusionShadowNodes.push(node);
        }
      }
    })

    const addChildNodesWithoutVideo = (n: HTMLElement)=>{
      if(!isNil(n) && n.nodeType === 1){
        //this.debugLog('autodetectSqueezebackResizeLayers - Testing layer: ' + this.getElementName(n), [LogType.QA, LogType.CXO])
        let nodeContainsExcludedLayer: boolean = false;
        let nodeIsExcludedLayer: boolean = false;
        let nodeAlreadyAdded: boolean = false;
        let nodeContainsExistingLayer: boolean = false;
        layers.forEach(l =>{
          if(!nodeAlreadyAdded && !nodeContainsExistingLayer){
            if(l === n){
              nodeAlreadyAdded = true;
            }else if(n.contains(l)){
              nodeContainsExistingLayer = true;
            }
          }
        })
        if(exclusionLayers.length > 0){
          exclusionLayers.forEach(excl =>{
            if(n.matches(excl)){
              nodeIsExcludedLayer = true;
            }else if(n.querySelector(excl) !== null){
              nodeContainsExcludedLayer = true;
            }
          })
          exclusionShadowNodes.forEach(excl =>{
            if(n === excl){
              nodeIsExcludedLayer = true;
            }else if(this.containsShadowNode(excl, n)){
              nodeContainsExcludedLayer = true;
            }
          })
        }

        if(nodeAlreadyAdded){
          this.debugLog(`autodetectSqueezebackResizeLayers - Node already included in squeezebackResizeLayers (${this.getElementName(n)}). Will not add to squeezeback resize layers.`, [LogType.CXO]);
        }else if(nodeIsExcludedLayer){
          this.debugLog(`autodetectSqueezebackResizeLayers - Layer is included in squeezebackExcludeLayers (${exclusionLayers[exclusionLayers.findIndex(excl => n.matches(excl))]}). Will not include it in squeezeback resize layers.`, [LogType.CXO]);
        }else{
          //this.debugLog(`autodetectSqueezebackResizeLayers - if(${!nodeContainsExcludedLayer} && ${!nodeContainsExistingLayer} && ${n.nodeType === 1} && ${n !== this.videoElement} && ${n !== this.cxoverlay} && (${!this.currentVideoStatus.isShadowPlayer} || ${n !== (this.videoElement.getRootNode?.() as ShadowRoot)?.host}) && ${!n.contains(this.videoElement)} && ${!n.contains(this.cxoverlay)} && ${this.squeezebackNodeIsVisible(n)})`, [LogType.CXO, LogType.QA]);
          if(!nodeContainsExcludedLayer && !nodeContainsExistingLayer && n.nodeType === 1 && n !== this.videoElement && n !== this.cxoverlay && (!this.currentVideoStatus.isShadowPlayer || n !== (this.videoElement.getRootNode?.() as ShadowRoot)?.host) && !n.contains(this.videoElement) && !n.contains(this.cxoverlay) && this.squeezebackNodeIsVisible(n)){
            layers.push(n);
          }else if(n.hasChildNodes && n !== this.cxoverlay){
            if(!isNil(n?.shadowRoot)){
              n.shadowRoot.childNodes.forEach(cNode => {
                addChildNodesWithoutVideo(cNode as HTMLElement)
              })
            }
            n.childNodes.forEach(cNode => {
              addChildNodesWithoutVideo(cNode as HTMLElement)
            })
          }
        }
      }
    }

    const traverseShadowTree = (searchTerm, elem) => {
      searchTerm = String(searchTerm);
      addChildNodesWithoutVideo(elem);
      if(elem){
        if (elem.getRootNode?.() === elem) {
          if(elem.host.tagName.toLowerCase() !== searchTerm.toLowerCase()) {
            return traverseShadowTree(searchTerm, this.getParent(elem))
          }
        } else {
          if(elem.tagName.toLowerCase() !== searchTerm.toLowerCase() && !elem.matches(searchTerm)) {
            return traverseShadowTree(searchTerm, this.getParent(elem))
          }
        }
      }
      return
    }

    if(this.currentVideoStatus.isShadowPlayer){
      traverseShadowTree(searchNodeName, this.videoElement)
    } else {
      if(videoNodeStart.contains(this.videoElement)){
        addChildNodesWithoutVideo(videoNodeStart);
      }
      else {
        //this.debugLog('autodetectSqueezebackResizeLayers -- Video is not contained in the squeezeback search node. Will not add additional resize layers.', [LogType.QA, LogType.CXO]);
      }
    }

    //this.debugLog([`autodetectSqueezebackResizeLayers -- Attempted to automatically discover squeezeback resize layers from node ${searchNodeName}.`, `Start search node: `, videoNodeStart, `Layers detected: `, layers], [LogType.QA, LogType.CXO]);
    return layers;
  }

  squeezebackNodeIsVisible(n: HTMLElement): boolean{
    if(this.currentVideoStatus.isShadowPlayer && !n.matches('link, style, track')) {
      return true;
    }
    let isOverVideo: boolean = false;
    const nodeRect: DOMRect = n.getBoundingClientRect();
    if(nodeRect.width > 5 && nodeRect.height > 5){
      const videoRect: DOMRect = this.videoElement.getBoundingClientRect();
      if(nodeRect.left >= videoRect.left && nodeRect.left < videoRect.left + videoRect.width){
        if(nodeRect.top > videoRect.top && nodeRect.top < videoRect.top + videoRect.height){
          isOverVideo = true;
        }else if(nodeRect.top + nodeRect.height > videoRect.top && nodeRect.top + nodeRect.height <= videoRect.top + videoRect.height){
          isOverVideo = true;
        }
      }else if(nodeRect.left + nodeRect.width > videoRect.left && nodeRect.left + nodeRect.width <= videoRect.left + videoRect.width){
        if(nodeRect.top > videoRect.top && nodeRect.top < videoRect.top + videoRect.height){
          isOverVideo = true;
        }else if(nodeRect.top + nodeRect.height > videoRect.top && nodeRect.top + nodeRect.height <= videoRect.top + videoRect.height){
          isOverVideo = true;
        }
      }else if(videoRect.left > nodeRect.left && videoRect.left < nodeRect.left + nodeRect.width){
        if(videoRect.top > nodeRect.top && videoRect.top < nodeRect.top + nodeRect.height){
          isOverVideo = true;
        }else if(videoRect.top + videoRect.height > nodeRect.top && videoRect.top + videoRect.height < nodeRect.top + nodeRect.height){
          isOverVideo = true;
        }
      }else if(videoRect.left + videoRect.width > nodeRect.left && videoRect.left + videoRect.width < nodeRect.left + nodeRect.width){
        if(videoRect.top > nodeRect.top && videoRect.top < nodeRect.top + nodeRect.height){
          isOverVideo = true;
        }else if(videoRect.top + videoRect.height > nodeRect.top && videoRect.top + videoRect.height < nodeRect.top + nodeRect.height){
          isOverVideo = true;
        }
      }
    }
    if(!isOverVideo){
      this.debugLog('NOT over video element: ' + this.getElementName(n) + '...', [LogType.CXO]);
    }
    return isOverVideo;
  }

  getElementName(n: HTMLElement): string{
    let nodeName: string = (typeof n.id !== 'undefined' && n.id !== null && n.id.length > 0)?`id="${n.id}"`:
      (typeof n.className !== 'undefined' && n.className !== null && n.className.length > 0)?`class="${n.className}"`:
      (typeof n.outerHTML !== 'undefined' && n.outerHTML !== null && n.outerHTML.length > 0)?n.outerHTML.substring(0, 50)+'...':
      (typeof n.nodeName !== 'undefined' && n.nodeName !== null && n.nodeName.length > 0)?n.nodeName.substring(0, 50):'undefined';
    return nodeName
  }

  get squeezebackHideLayers(): HTMLElement[] {
    let layers: HTMLElement[] = [];
    if(!isNil(this.playerConfig.squeezebackHideLayers)){
      const searchNodeName: string = this.playerConfig.squeezebackRoot ?? this.playerConfig.searchTerm;
      let videoNodeStart: HTMLElement = this.findElementFromNode(searchNodeName, this.videoContainerSearchNode);
      videoNodeStart = this.getParent(videoNodeStart) ?? videoNodeStart;
      if(isNil(videoNodeStart)){
        this.debugLog([`squeezebackHideLayers -- searchNodeName'${searchNodeName}' not found within player. Using videoContainerSearchNode instead.`], [LogType.QA, LogType.CXO]);
        videoNodeStart = this.videoContainerSearchNode;
      };
      this.playerConfig.squeezebackHideLayers.forEach(squeezeNode =>{
        this.debugLog(`squeezebackHideLayers -- layer to hide ${squeezeNode} found.`)
        const squeezeLayer: HTMLElement = (this.currentVideoStatus.isShadowPlayer)?this.findShadowNodeUp(squeezeNode):videoNodeStart.querySelector(squeezeNode);
        if(squeezeLayer != null) layers.push(squeezeLayer)
      })
      this.debugLog([`squeezebackHideLayers -- layers found: `, layers], [LogType.QA, LogType.CXO]);
    }
    return (layers.length > 0)?layers:null;
  }

  get activeInsertIndex(): number{
    const activeInsertPosition = this.inserts.indexOf(this.activeResourceData);
    this.debugLog(['CURRENT INSERT FOUND AT INSERT INDEX: ' + activeInsertPosition, this.inserts, this.activeResourceData], [LogType.CXO]);
    return activeInsertPosition;
  }

  get nextAvailableResource(): Resource{
    const nextResouce: Resource = this.inserts.find(data => data !== this.activeResourceData && data !== this.carouselResourceData);
    this.debugLog(['Next resource available in the inserts arary: ', nextResouce], [LogType.CXO]);
    return nextResouce;
  }

  get videoContainer(): HTMLElement {
    this.debugLog(`get videoContainer: ${this.qElementId}`)
    let vidContainer = document.querySelector(this.qElementId) as HTMLElement;
    return vidContainer
  }

  getVideoSource(videoElement): string{
    var vidSrc: string = null;
    if(!isNil(videoElement)){
      vidSrc = videoElement.src ?? null;
      if(vidSrc === null || vidSrc === ''){
        var sourceNodes = videoElement.getElementsByTagName('source');
        for(var i = 0; i < sourceNodes.length; i++){
          vidSrc = sourceNodes[i].src ?? null;
          if(vidSrc !== null && vidSrc !== ''){
            break;
          }
        }
      }
    }
    return vidSrc;
  }
  
  get isVideoAdvertisement(): boolean{
    const advertisementDetected = (result:any, method?: string, name?:string) => {
      if(!!result) {
        this.debugLog([`Current video identified as advertisement on player ${this.playerType} through ${method}: ${name}`], (this.cxWait)?[LogType.CXO]: [LogType.QA, LogType.CXO]);
        //timer to check in detect cx wait changes to stop cxwait=false too early
      }
      return !!result
    }

    if (this.playerType === PlayerType.STN_SHADOW && this.isVideoOnPage) {
      const adNode = this.findShadowNodeUp('stn-ima', true);
      return advertisementDetected((adNode && !adNode.matches(`[class*=hide]`) && window.getComputedStyle(adNode).getPropertyValue('display').toLowerCase() !== 'none'), 'node', 'stn-ima')
    }

    if(this.videoAdvertVariables.length > 0 && (typeof this.videoElement !== 'undefined' && this.videoElement !== null)) {
      const flag = this.videoAdvertVariables.find(v => this.videoElement[v]);
      if (flag) return advertisementDetected(flag, 'video-variable', flag)
    }

    const searchNode: HTMLElement = ((!isNil(this.playerConfig?.advertisingRoot))?this.findElementFromNode(this.playerConfig.advertisingRoot, this.videoContainerSearchNode):this.videoContainerSearchNode) ?? this.videoContainerSearchNode;
    const advertNodesList: AdvertiserNode[] = this.playerConfig?.advertisingIdentifiers ?? [];
    if(!isNil(searchNode) && advertNodesList.length > 0) {
      const detectedNode = advertNodesList.find(node => {
        const foundAdvertElement: HTMLElement = (searchNode.matches(node.nodeSelector))?searchNode:searchNode.querySelector(node.nodeSelector);
        if(!!foundAdvertElement){
          if(isNil(node.selectorState)) {
            return true;
          } else {
            switch(node.selectorState){
              case 'display':
                return window.getComputedStyle(foundAdvertElement).getPropertyValue('display').toLowerCase() !== 'none';
              case 'paused':
                return !(foundAdvertElement as HTMLVideoElement).paused;
              case 'zIndex':
                return parseFloat(window.getComputedStyle(foundAdvertElement).getPropertyValue('z-index')) > 0;
              case 'opacity':
                return parseFloat(window.getComputedStyle(foundAdvertElement).getPropertyValue('opacity')) > 0;
              default:
                return false; 
            }
          }
        }else{
          return false;
        }
      })
      if (detectedNode) return advertisementDetected(detectedNode, 'node-list', detectedNode.nodeSelector)
    }

    return advertisementDetected(false);
  }

  get isInsertTimeBlocked(): boolean{
    let timeBlocked: boolean = false;
    if(!isNil(this.overlayUtilities.groupConfig.neverInsert) && !isNil(this.videoElement)){
      this.overlayUtilities.groupConfig.neverInsert.forEach(timeBlock => {
        if(!timeBlocked && this.videoElement.currentTime > timeBlock.start && this.videoElement.currentTime < timeBlock.end){
          timeBlocked = true;
        }
      })
    }
    return timeBlocked;
  }

  detectCXWaitChanges(){
    if(this.cxoverlay.getAttribute('cx-wait') === null){
      if(this.isVideoAdvertisement){
        if(!this.cxWait){
          //this.clearRemainingInserts();
          this.cxWait = true;
          this.timers.detectCXWaitChangesTimer.cancel();
        }
      } else {
        if(this.cxWait && !isNil(this.videoElement)){
          if(this.overlayUtilities.currentDimensions.width > 10 && this.overlayUtilities.currentDimensions.height > 10){
            this.debugLog(`setting cxwait = false ${this.overlayUtilities.currentDimensions.width} ${this.overlayUtilities.currentDimensions.height}`, LogType.CXO);
            this.timers.detectCXWaitChangesTimer.cancel();
            this.cxWait = false;
          }else{
            this.determineDimensions();
            this.timers.detectCXWaitChangesTimer.resetInterval(500, 6);
          }
        }
      }
    }
    return this.cxWait;
  }
  
  get isOverflowHidden(): ElementHiddenDirection{
    let hiddenDirections: ElementHiddenDirection = {hiddenX: false, hiddenY: false};

    let checkHiddenNode: HTMLElement = this.bleedoverParentElement;
    const videoDimensions = (!isNil(this.videoElement))?this.videoElement.getBoundingClientRect():null;

    if(videoDimensions !== null){
      let travelDistance: number = 20;
      while(travelDistance-- > 0 && checkHiddenNode !== null){
        const hiddenNodeDimensions= checkHiddenNode.getBoundingClientRect();
        const calculatedOverflow = window.getComputedStyle(checkHiddenNode).getPropertyValue('overflow').toLowerCase();
        //this.debugLog(['Checking overflow:hidden on node: ', checkHiddenNode, `Size: ${hiddenNodeDimensions.width}px x ${hiddenNodeDimensions.height}`, calculatedOverflow], LogType.CXO);
        if(calculatedOverflow === 'hidden'){
          if(hiddenNodeDimensions.width/videoDimensions.width < 1.25){
            hiddenDirections.hiddenX = true;
          }
          if(hiddenNodeDimensions.height/videoDimensions.height < 1.2){
            hiddenDirections.hiddenY = true;
          }
          break;
        }else if(hiddenNodeDimensions.width/videoDimensions.width > 1.1 && hiddenNodeDimensions.height/videoDimensions.height > 1.1 ){
          break;
        }
        else if(window.getComputedStyle(checkHiddenNode).getPropertyValue('position').toLowerCase() === CSSPosition.FIXED){
          break;
        }
        checkHiddenNode = this.getParent(checkHiddenNode, true) ?? null;
      }
    }

    if(hiddenDirections.hiddenX || hiddenDirections.hiddenY){
      this.debugLog([`Overflow hidden detected on parent element. X-Axis hidden: ${hiddenDirections.hiddenX}. Y-Axis hidden: ${hiddenDirections.hiddenY}`], [LogType.QA, LogType.CXO]);
    }else{
      this.debugLog(["Overflow hidden NOT detected on parent element.", checkHiddenNode], [LogType.CXO]);
    }
    
    return hiddenDirections;
  }

  get bleedoverParentElement(): HTMLElement{
    const targetType = this.playerConfig.moveCxoBleedover;
    let anchorTarget: string = this.playerConfig.bleedoverAnchorTarget ?? this.anchorTarget;

    this.debugLog(`getBleedoverTarget --targetType = ${targetType} --anchorTarget = ${anchorTarget}`);
    let anchorNode:HTMLElement = this.videoContainerSearchNode.querySelector(anchorTarget) ?? this.videoElementContainer;
    switch (targetType) {
      case 'into':
        return anchorNode
      case 'after':
      case 'before':
        return this.getParent(anchorNode)
      case 'video':
      case 'after-video':
        return this.videoElement
      default:
        return this.videoElementContainer
    }
  }

  get overlayParentElement(): HTMLElement{
    const targetType = this.playerConfig.moveCxoStandard;
    let anchorTarget: string = this.playerConfig.anchorTarget ?? this.anchorTarget;

    this.debugLog(`getOverlayTarget --targetType = ${targetType} --anchorTarget = ${anchorTarget}`);
    let anchorNode:HTMLElement = this.videoContainerSearchNode.querySelector(anchorTarget) ?? this.videoElementContainer;
    switch (targetType) {
      case 'into':
        return anchorNode
      case 'after':
      case 'before':
        return this.getParent(anchorNode)
      case 'video':
      case 'after-video':
        return this.videoElement
      default:
        return this.videoElementContainer
    }
  }

  get fullscreenParentElement(): HTMLElement{
    const targetType = this.playerConfig.moveCxoFullscreen;
    let anchorTarget: string = this.playerConfig.fullscreenAnchorTarget ?? this.anchorTarget;

    this.debugLog(`getFullscreenTarget --targetType = ${targetType} --anchorTarget = ${anchorTarget}`);
    let anchorNode:HTMLElement = (anchorTarget !== 'top')?this.videoContainerSearchNode.querySelector(anchorTarget) ?? this.videoElementContainer : this.topAnchorTarget;
    switch (targetType) {
      case 'into':
        return anchorNode
      case 'after':
      case 'before':
        return this.getParent(anchorNode)
      case 'video':
      case 'after-video':
        return this.videoElement
      default:
        return this.videoElementContainer
    }
  }

  get topAnchorTarget(): HTMLElement{
    let anchorTarget: HTMLElement = document.querySelector(this.qElementId);
    let dist: number = 20;
    while(this.getParent(anchorTarget)?.tagName.toLowerCase() !== 'body' && dist-- > 0){
      anchorTarget = this.getParent(anchorTarget);
    }
    return anchorTarget;
  }
  
  get isWideScreenVideoPlayer(): boolean{
    if(!isNil(this.videoElement)){
      const videoRect: DOMRect = this.videoElement.getBoundingClientRect();
      const widescreenNearness: number = this.overlayUtilities.percentageDifference((16/9),(videoRect.width/videoRect.height));
      return (widescreenNearness < 14);
    }
    return false;
  }

  get isVideoFileWidescreen(): boolean{
    let isVideoFileWidescreen: boolean = true;
    if(!isNil(this.videoElement)){
      const difference = this.overlayUtilities.percentageDifference((16/9), (this.videoElement.videoWidth/this.videoElement.videoHeight));
      this.debugLog("Percent difference from 16/9 ratio: " + difference);
      isVideoFileWidescreen =  (difference > 14) ? false: true;
    }
    return isVideoFileWidescreen;
  }

  get isPortraitVideoPlayer(): boolean{
    if(!isNil(this.videoElement)){
      const videoRect: DOMRect = this.videoElement.getBoundingClientRect();
      const portraitNearness: number = this.overlayUtilities.percentageDifference((9/16),(videoRect.width/videoRect.height));
      return (portraitNearness < 14);
    }
    return false;
  }

  get isVerticalVideo(): boolean{
    if(!isNil(this.videoElement)){
      const videoRect: DOMRect = this.videoElement.getBoundingClientRect();
      if(videoRect.height/videoRect.width > 1.2){
        return true;
      }
    }
    return false;
  }

  get isInArticlePlayer(): boolean{
    let viewableHeight:number = window.innerHeight;
    let isInArticle:boolean = false;

    if(!isNil(this.videoElement)){
      let yScroll  = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const videoScaleAdjust = (this.currentVideoElementScale*(parseFloat(this.overlayUtilities.currentDimensions.transform[1])/100));
      let videoPlayerBottom = this.videoElement.getBoundingClientRect().bottom - (this.videoElement.getBoundingClientRect().height/videoScaleAdjust)*.1;
      if(window.self !== window.top){
        this.isIframePlayer = true
        try{
          yScroll = window.top.scrollY;
          viewableHeight = window.top.innerHeight;
          if(!isNil(window.frameElement)){
            videoPlayerBottom = window.frameElement.getBoundingClientRect().bottom
          }
        }catch(err){
          this.debugLog(['Unable to calculate player distance from top due to iframe.', err], LogType.CXO);
        }
      }
      let distanceFromTop = (videoPlayerBottom + yScroll);
      isInArticle = (distanceFromTop < viewableHeight)?false:true;
    }

    return isInArticle;
  }

  get isPlayerFloating(): boolean {
    let isPlayerFloating = false
    let floatNode = this.videoElement as HTMLElement
    let floatDistance = 15
    while (!isNil(floatNode) && floatDistance-- > 0) {
      if (window.getComputedStyle(floatNode).getPropertyValue('position') === CSSPosition.FIXED) {
        isPlayerFloating = true
        break
      }
      floatNode = this.getParent(floatNode, true);
    }
    return isPlayerFloating;
  }

  get isPreloadImageryComplete(): boolean{
    let complete: boolean = true;
    const preloadImages: HTMLCollectionOf<Element> = this.overlayTimerElement.getElementsByClassName('preloadImage');
    for(let i = 0; i < preloadImages.length; i++){
      if(!(preloadImages[i] as HTMLImageElement).complete){
        complete = false;
        break;
      }
    }
    //this.debugLog('All preload images have finished loading? ' + complete, [LogType.CXO, LogType.QA]);
    return complete;
  }

  get isFullscreenIOS(): boolean{
    return Boolean(this.overlayUtilities.isMobileDevice && Boolean(navigator.platform.match(/iPhone|iPod|iPad/)) && Boolean(document.fullscreenElement || document['webkitIsFullScreen'] || document['mozFullScreen'] || document['msFullscreenElement'] || document['webkitCurrentFullScreenElement'] || this.videoElement['webkitDisplayingFullscreen']))
  }

  get isFullscreenVideoNode(): boolean{
    const isFullscreenVideo: boolean = Boolean(this.overlayUtilities.isMobileDevice && (this.videoContainerSearchNode?.getRootNode?.() as Document).fullscreenElement?.tagName.toLowerCase() === 'video');
    if(isFullscreenVideo){
      this.debugLog('FULLSCREEN VIDEO NODE ONLY', [LogType.CXO, LogType.QA]);
    }
    return isFullscreenVideo;
  }

  get doesWingInsertFit(): boolean{
    if(this.overlayUtilities.currentDimensions.left > this.overlayUtilities.currentDimensions.width*.25 || this.overlayUtilities.currentDimensions.right > this.overlayUtilities.currentDimensions.width*.25){
      return true;
    }
    return false;
  }

  get didVideoSourceChange(): boolean{
    if(this.videoUrl === this.getVideoSource(this.videoElement)){
      return false;
    }
    this.debugLog(`Old video source: ${this.videoUrl}. Current video source: ${this.getVideoSource(this.videoElement)}`);
    return true;
  }

  get isCarouselStarted(): boolean{
    return this.overlayUtilities.activeCarouselData.active = this.overlayUtilities.activeCarouselData.active || this.overlayUtilities.carouselBidTimer.getTotalElapsedTime() > 0;
  }

  get isOSDAvailable(): boolean{
    if(this.overlayUtilities.osdConfig?.slotRefreshParams?.allowGAMRefresh){
      return !isNil(this.overlayUtilities.osdConfig);
    }
    return this.overlayUtilities.osdConfig?.isPrebidAvailable ?? false;
  }

  get isVideoOnPage(): boolean{
    if(isNil(this.videoElement)){
      return false;
    }else if(this.currentVideoStatus.isShadowPlayer){
      let videoRoot: ShadowRoot = this.videoElement.getRootNode?.() as ShadowRoot;
      while(!isNil(videoRoot) && !isNil(videoRoot?.host)){
        videoRoot = videoRoot.host.getRootNode() as ShadowRoot;
      }
      if(videoRoot?.nodeName !== '#document'){
        return false;
      }
    }else if(!document.contains(this.videoElement)){
      return false;
    }
    return true;
  }

  set activeMediaId(mid: string){
    this._activeMediaId = mid;
    this.analyticsEventDispatcher.assignMediaId(mid);
  }

  get activeMediaId(){
    return this._activeMediaId;
  }

  set activeLogicalVideoId(lvid: string){
    this._activeLogicalVideoId = lvid;
    this.analyticsEventDispatcher.assignLogicalVideoId(lvid);
  }

  get activeLogicalVideoId(){
    return this._activeLogicalVideoId;
  }

  get videoUrl(): string{
    return this._videoUrl;
  }

  set videoUrl(newUrl: string){
    if(newUrl !== this._videoUrl){
      this._videoUrl = newUrl;
      this._videoUrlId = this.overlayUtilities.generateUniqueId;
      let videoEventsUrl: string = this.videoUrlSourceMapping;
      this.analyticsEventDispatcher.assignVideoUrl(videoEventsUrl, this._videoUrlId);
    }
  }

  set timerBidding(timerBidding: boolean){
    this.currentVideoStatus.timerBasedBidding = timerBidding;
    this.debugLog(`Timer bidding set in cx-overlay to: ${timerBidding}`, [LogType.QA, LogType.CXO]);
  }

  set zIndexUpdate(zIndexUpdate: string){
    this.overlayTimerElement.style.setProperty('z-index', zIndexUpdate);
    this.containerElement.style.setProperty('z-index', zIndexUpdate);
  }

  get videoUrlSourceMapping(): string{
    let returnUrl: string = this._videoUrl;
    if(this.playerType === PlayerType.DAILYMOTION){
      //const topWindow: Window = this.availableTopWindow;
      const topWindow: Window = window.self;
      const dmpCanonicalLink: NodeList = topWindow.document.querySelectorAll('link[rel=canonical]');
      const lastLink: Node = dmpCanonicalLink.item(dmpCanonicalLink.length-1);
      returnUrl = (!isNil(lastLink) && !!(lastLink as HTMLLinkElement).getAttribute('href'))?(lastLink as HTMLLinkElement).getAttribute('href'):returnUrl;
    }
    return returnUrl;
  }

  get availableTopWindow(): Window{
    let returnWindow: Window = window;
    if(window.self !== window.top){
      try{
        if(window.top.location.href !== null){
          returnWindow = window.top;
        }
      }catch(err:any){
        this.debugLog(['Unable to access window.top. Serving from inside an unsafe iframe.', err], [LogType.QA, LogType.IMPORTANT]);
      }
    }
    return returnWindow;
  }

  get cxInjectorWindowDebug(): CXInjectorWindowDebug{
    return window['cxInjectorWindowDebug'] ?? null
  }

  get scriptBaseURL(): string{
    let returnURL: string = "";
      if(!isNil(this.currentScript?.src)){
        const scriptURL: URL = new URL(this.currentScript.src);
        returnURL += scriptURL.protocol + "//" + scriptURL.host;
      }
    return returnURL;
  }

  get currentInserts(): CurrentInsertMap{
    return this.overlayUtilities.currentInserts;
  }

  render() {
    return (
      <div id="overlaySizer" ref={(el: HTMLDivElement) => (this.overlaySizerElement = el)}>
        <div ref={(el: HTMLDivElement) => (this.containerElement = el)}>
          <div id="timer" ref={(el: HTMLDivElement) => (this.overlayTimerElement = el)}>
          </div>
        </div>
      </div>

    )
  }
}
